/** THIS FILE IS AUTO-GENERATED **/
/** DO NOT EDIT **/
/* eslint-disable */
  
import * as Operations from '../operations';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
}

export interface AddProtocolInput {
  startDate: Scalars['DateTime']['input'];
  treatmentId: Scalars['ID']['input'];
  treatmentSchemaId: Scalars['ID']['input'];
}

export interface AdminProfile extends ProfileInterface {
  __typename: 'AdminProfile';
  createdAt: Scalars['DateTime']['output'];
  extraInfo: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
}

export interface AggregatedSurveyResults {
  __typename: 'AggregatedSurveyResults';
  csvInBase64: Scalars['String']['output'];
  surveyQuestionResultList: Array<SurveyQuestionResult>;
  totalSubmitters: Scalars['Float']['output'];
  xlsxInBase64: Scalars['String']['output'];
}

export interface AnswerOption {
  __typename: 'AnswerOption';
  id?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
}

export interface AnswerOptionInput {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
}

export interface Appointment {
  __typename: 'Appointment';
  appointmentInfo?: Maybe<AppointmentInfo>;
  createdAt: Scalars['DateTime']['output'];
  dependencies: Array<AppointmentDependency>;
  dependent: Array<AppointmentDependency>;
  doctor: DoctorProfile;
  doctorId: Scalars['ID']['output'];
  doctorProfile: DoctorProfile;
  duration: Scalars['String']['output'];
  eesztBookingId?: Maybe<Scalars['String']['output']>;
  eesztBookingTransaction?: Maybe<EesztAppointmentBookingTransaction>;
  ics?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<AppointmentInfo>;
  institution?: Maybe<Institution>;
  institutionId?: Maybe<Scalars['ID']['output']>;
  isBetmenBooked: Scalars['Boolean']['output'];
  katId?: Maybe<Scalars['String']['output']>;
  proposedDate: Scalars['DateTime']['output'];
  ratingStars?: Maybe<Scalars['Float']['output']>;
  ratingText?: Maybe<Scalars['String']['output']>;
  room?: Maybe<Room>;
  roomId?: Maybe<Scalars['ID']['output']>;
  status: AppointmentStatus;
  timeFrom?: Maybe<Scalars['String']['output']>;
  timeTo?: Maybe<Scalars['String']['output']>;
  treatment: Treatment;
  treatmentId: Scalars['ID']['output'];
  treatmentSchema?: Maybe<TreatmentSchema>;
  treatmentSchemaId?: Maybe<Scalars['ID']['output']>;
  updatedAt: Scalars['DateTime']['output'];
}

export interface AppointmentDateFilter {
  start?: InputMaybe<Scalars['DateTime']['input']>;
  stop?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface AppointmentDependency {
  __typename: 'AppointmentDependency';
  appointment: Appointment;
  appointmentId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  distance: Scalars['String']['output'];
  from: Appointment;
  fromId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  isBroken: Scalars['Boolean']['output'];
  isCustom: Scalars['Boolean']['output'];
  type: AppointmentDependencyTypes;
  updatedAt: Scalars['DateTime']['output'];
}

/** Possible types for appointment dependency */
export enum AppointmentDependencyTypes {
  maxDistance = 'maxDistance',
  minDistance = 'minDistance',
  notSpecified = 'notSpecified'
}

export interface AppointmentInfo {
  __typename: 'AppointmentInfo';
  beforeTreatmentNote?: Maybe<Scalars['Boolean']['output']>;
  createdAt: Scalars['DateTime']['output'];
  doctorTitle: MultiLangText;
  doctorTodo: MultiLangText;
  eesztServiceId?: Maybe<Scalars['String']['output']>;
  eesztServiceTypeId?: Maybe<Scalars['String']['output']>;
  goodToKnow: MultiLangText;
  id: Scalars['ID']['output'];
  oeno?: Maybe<Scalars['String']['output']>;
  patientTitle: MultiLangText;
  practiceProfessionalActivity: Scalars['Boolean']['output'];
  practiceProfessionalActivityCode?: Maybe<Scalars['String']['output']>;
  professions?: Maybe<Array<Profession>>;
  treatmentSchemaId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
}

export interface AppointmentInput {
  appointmentInfoId: Scalars['String']['input'];
  consultationId?: InputMaybe<Scalars['String']['input']>;
  doctorId: Scalars['String']['input'];
  institutionId?: InputMaybe<Scalars['String']['input']>;
  isBetmenBooked?: InputMaybe<Scalars['Boolean']['input']>;
  proposedDate: Scalars['String']['input'];
  roomId?: InputMaybe<Scalars['String']['input']>;
  treatmentId: Scalars['String']['input'];
}

export interface AppointmentList {
  __typename: 'AppointmentList';
  appointments: Array<Appointment>;
  total: Scalars['Float']['output'];
}

/** Possible statuses for appointments */
export enum AppointmentStatus {
  BetmenBooked = 'BetmenBooked',
  Declined = 'Declined',
  EesztBooked = 'EesztBooked',
  Expired = 'Expired',
  Happened = 'Happened',
  Missed = 'Missed',
  Proposed = 'Proposed'
}

export interface AppointmentUpdateGoodToKnowInput {
  goodToKnowEn?: InputMaybe<Scalars['String']['input']>;
  goodToKnowHu?: InputMaybe<Scalars['String']['input']>;
}

export interface AppointmentUpdateInput {
  appointmentId: Scalars['String']['input'];
  consultationId?: InputMaybe<Scalars['String']['input']>;
  doctorId: Scalars['String']['input'];
  institutionId?: InputMaybe<Scalars['String']['input']>;
  isBetmenBooked?: InputMaybe<Scalars['Boolean']['input']>;
  proposedDate: Scalars['String']['input'];
  roomId?: InputMaybe<Scalars['String']['input']>;
}

export type AppointmentUpdateResult = Appointment | CalculatedSchedule;

export interface AspectAnswer {
  __typename: 'AspectAnswer';
  aspectId: Scalars['String']['output'];
  scaleValue: Scalars['Float']['output'];
}

export interface AssistantInputData {
  email?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
}

export interface AssistantProfile extends ProfileInterface {
  __typename: 'AssistantProfile';
  createdAt: Scalars['DateTime']['output'];
  extraInfo: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  ownDoctors?: Maybe<Array<DoctorOwnAssistants>>;
  ownPatients: Array<DoctorOwnPatients>;
  phone?: Maybe<Scalars['String']['output']>;
  registrationNumber: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
}

export interface AssistantProfileFilter {
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface AssistantProfileList {
  __typename: 'AssistantProfileList';
  profiles: Array<AssistantProfile>;
  total: Scalars['Float']['output'];
}

export interface AssistantProfileNotFoundError {
  __typename: 'AssistantProfileNotFoundError';
  message: Scalars['String']['output'];
}

/** Possible blood types */
export enum BloodType {
  AB_minus = 'AB_minus',
  AB_plus = 'AB_plus',
  A_minus = 'A_minus',
  A_plus = 'A_plus',
  B_minus = 'B_minus',
  B_plus = 'B_plus',
  O_minus = 'O_minus',
  O_plus = 'O_plus'
}

export interface BnoCode {
  __typename: 'BnoCode';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  gender?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  mainCategory: Scalars['Boolean']['output'];
  maxAge?: Maybe<Scalars['Float']['output']>;
  minAge?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface BulkDismissResult {
  __typename: 'BulkDismissResult';
  error?: Maybe<Scalars['String']['output']>;
  profile: DoctorOwnPatients;
  success: Scalars['Boolean']['output'];
}

export enum CacheControlScope {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC'
}

export interface CalculatedSchedule {
  __typename: 'CalculatedSchedule';
  brokenDependants: Array<AppointmentDependency>;
  brokenDependingFrom: Array<AppointmentDependency>;
  schedule: Array<PlainTreatmentElement>;
}

export interface CancelTreatmentInput {
  closingComment?: InputMaybe<Scalars['String']['input']>;
  treatmentId: Scalars['ID']['input'];
}

export interface CaseGroup {
  __typename: 'CaseGroup';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  status: CaseStatus;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export enum CaseStatus {
  Active = 'Active',
  Closed = 'Closed',
  Inactive = 'Inactive',
  Solved = 'Solved'
}

export interface ChoiceResult {
  __typename: 'ChoiceResult';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  total: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface ConsultationData {
  __typename: 'ConsultationData';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  maxPatient: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
}

export interface CreateAppointmentDependencyInput {
  appointmentId: Scalars['String']['input'];
  distance: Scalars['String']['input'];
  fromId: Scalars['String']['input'];
}

export interface CreateAppointmentInfoInput {
  beforeTreatmentNote: Scalars['Boolean']['input'];
  doctorTitle: MultiLangTextInput;
  doctorTodo: MultiLangTextInput;
  goodToKnow: MultiLangTextInput;
  oeno?: InputMaybe<Scalars['String']['input']>;
  patientTitle: MultiLangTextInput;
  professionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  treatmentSchemaId?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateAssistantProfileData {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  registrationNumber: Scalars['String']['input'];
  title: Scalars['String']['input'];
}

export interface CreateDependencyInput {
  dependencyType: AppointmentDependencyTypes;
  distance: Scalars['Float']['input'];
  fromId: Scalars['String']['input'];
  toId: Scalars['String']['input'];
  treatmentSchemaId: Scalars['String']['input'];
  unit: Scalars['String']['input'];
}

export interface CreateDoctorProfileData {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  stampNumber: Scalars['String']['input'];
  title: Scalars['String']['input'];
}

export interface CreatePatientProfileData {
  birthDate: Scalars['DateTime']['input'];
  birthPlace: Scalars['String']['input'];
  email: Scalars['String']['input'];
  emergencyContacts: Array<PatientContactInput>;
  entitleToInfoContacts?: InputMaybe<Array<PatientContactInput>>;
  firstName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  height?: InputMaybe<Scalars['Float']['input']>;
  lastName: Scalars['String']['input'];
  motherFirstName: Scalars['String']['input'];
  motherLastName: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  tajNumber: Scalars['String']['input'];
  title: Scalars['String']['input'];
  weight?: InputMaybe<Scalars['Float']['input']>;
}

export interface CreateReferralInput {
  createdAtDate: Scalars['DateTimeISO']['input'];
  createdAtPlace: Scalars['String']['input'];
  description: Scalars['String']['input'];
  doctorProfileId: Scalars['ID']['input'];
  expirationDate: Scalars['DateTimeISO']['input'];
  logNumber: Scalars['String']['input'];
  name: Scalars['String']['input'];
  patientProfileId: Scalars['ID']['input'];
  professionId?: InputMaybe<Scalars['ID']['input']>;
  status: ReferralStatus;
  treatmentId: Scalars['ID']['input'];
}

export interface CreateRoomInput {
  address?: InputMaybe<OptionalMultiLangTextInput>;
  description?: InputMaybe<OptionalMultiLangTextInput>;
  institutionId: Scalars['String']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: MultiLangTextInput;
  neakCode?: InputMaybe<Scalars['String']['input']>;
}

export interface CreateSurveyQuestionInput {
  data?: InputMaybe<QuestionDataInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  isSurveySpecific?: InputMaybe<Scalars['Boolean']['input']>;
  mcSurveyQuestionChoices?: InputMaybe<Array<AnswerOptionInput>>;
  sclSurveyQuestionAspects?: InputMaybe<Array<AnswerOptionInput>>;
  surveySchemaId?: InputMaybe<Scalars['ID']['input']>;
  title: Scalars['String']['input'];
  type: SurveyQuestionEnum;
}

export interface CreateSurveySchemaInput {
  bnoCodeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categories: Array<SurveyCategoryEnum>;
  description: Scalars['String']['input'];
  patientDescription: Scalars['String']['input'];
  professionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  questions: Array<SurveyQuestionToSurveySchemaInput>;
  referenceUrls?: InputMaybe<Array<InputSurveySchemaReferenceUrl>>;
  snomedCode?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
}

export interface CreateTreatmentInput {
  bnoCodeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  customTreatmentDescription: MultiLangTextInput;
  customTreatmentTitle: MultiLangTextInput;
  patientId: Scalars['String']['input'];
}

export interface DateIntervalInput {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface DeleteAppointmentInfoInput {
  appointmentInfoId: Scalars['String']['input'];
}

export interface DeleteProtocolInput {
  treatmentId: Scalars['ID']['input'];
  treatmentSchemaId: Scalars['ID']['input'];
}

export interface Dependency {
  __typename: 'Dependency';
  distance: Scalars['String']['output'];
  doctorTitle?: Maybe<MultiLangText>;
  fromId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: AppointmentDependencyTypes;
}

export interface DoctorOwnAssistants {
  __typename: 'DoctorOwnAssistants';
  assistant: AssistantProfile;
  assistantId: Scalars['String']['output'];
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  doctor: DoctorProfile;
  doctorId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface DoctorOwnPatients {
  __typename: 'DoctorOwnPatients';
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  doctor?: Maybe<DoctorProfile>;
  doctorId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  patient?: Maybe<PatientProfile>;
  patientId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface DoctorProfile extends ProfileInterface {
  __typename: 'DoctorProfile';
  assistants: Array<AssistantProfile>;
  createdAt: Scalars['DateTime']['output'];
  extraInfo: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  hasEESZTToken: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  institutionToDoctor: Array<InstitutionToDoctor>;
  invitations: Invitations;
  lastName: Scalars['String']['output'];
  ownPatients: Array<DoctorOwnPatients>;
  phone?: Maybe<Scalars['String']['output']>;
  professions: Array<Profession>;
  stampNumber: Scalars['String']['output'];
  title: Scalars['String']['output'];
  treatments?: Maybe<Array<Treatment>>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
}


export interface DoctorProfileownPatientsArgs {
  isActivePatient?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface DoctorProfiletreatmentsArgs {
  doctorId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Float']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<SortByArgs>;
  statuses?: InputMaybe<Array<TreatmentStatus>>;
}

export interface DoctorProfileFilter {
  assistantId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

export interface DoctorProfileList {
  __typename: 'DoctorProfileList';
  profiles: Array<DoctorProfile>;
  total: Scalars['Float']['output'];
}

export interface Document {
  __typename: 'Document';
  createdAt: Scalars['DateTime']['output'];
  dangling: Scalars['Boolean']['output'];
  fileName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  originalFileName: Scalars['String']['output'];
  relFilePath?: Maybe<Scalars['String']['output']>;
  type: DocumentTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
}

export interface DocumentAnswer {
  __typename: 'DocumentAnswer';
  documentId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
}

/** Possible categories of document type */
export enum DocumentTypeEnum {
  SurveyQuestionAnswerFile = 'SurveyQuestionAnswerFile'
}

export interface EESZTDoctor {
  __typename: 'EESZTDoctor';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  stampNo: Scalars['String']['output'];
}

export interface EESZTEhrDocument {
  __typename: 'EESZTEhrDocument';
  EESZTId?: Maybe<Scalars['String']['output']>;
  doctor: EESZTDoctor;
  document: Scalars['String']['output'];
  documentId: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  hospitalDescr: Scalars['String']['output'];
  locationCode: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
}

export interface EESZTEhrDocumentList {
  __typename: 'EESZTEhrDocumentList';
  documents: Array<EESZTEhrDocument>;
  hasDORError: Scalars['Boolean']['output'];
  total: Scalars['Float']['output'];
}

export interface EESZTKatEvent {
  __typename: 'EESZTKatEvent';
  doctor: Scalars['String']['output'];
  eventStart: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  katId: Scalars['String']['output'];
  room: MultiLangText;
  status: Scalars['String']['output'];
  taj: Scalars['String']['output'];
}

export interface EESZTLoginResponse {
  __typename: 'EESZTLoginResponse';
  expires: Scalars['DateTime']['output'];
  success: Scalars['Boolean']['output'];
}

export interface EESZTLogoutResponse {
  __typename: 'EESZTLogoutResponse';
  success: Scalars['Boolean']['output'];
}

export interface EESZTPocId {
  __typename: 'EESZTPocId';
  pocId: Scalars['String']['output'];
}

export interface EESZTRssFeed {
  __typename: 'EESZTRssFeed';
  description: Scalars['String']['output'];
  items: Array<EESZTRssFeedItem>;
  title: Scalars['String']['output'];
}

export interface EESZTRssFeedItem {
  __typename: 'EESZTRssFeedItem';
  description: Scalars['String']['output'];
  guid: Scalars['String']['output'];
  link: Scalars['String']['output'];
  pubDate: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface EESZTSlot {
  __typename: 'EESZTSlot';
  consultationData: ConsultationData;
  date: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  institutionData: IdentificationData;
  organizationData: IdentificationData;
  startTime: Scalars['String']['output'];
}

export interface EESZTStsLoginInput {
  password: Scalars['String']['input'];
}

export enum EESzTSyncResult {
  Failed = 'Failed',
  Success = 'Success'
}

export interface EditAbleDoctorData {
  institutions?: InputMaybe<Array<InstitutionInputData>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  professionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface EditablePatientData {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCounty?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  addressStreet?: InputMaybe<Scalars['String']['input']>;
  birthPlace?: InputMaybe<Scalars['String']['input']>;
  emergencyContacts?: InputMaybe<Array<PatientContactInput>>;
  entitleToInfoContacts?: InputMaybe<Array<PatientContactInput>>;
  gender?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Float']['input']>;
  medicineIntolerance?: InputMaybe<Array<Scalars['String']['input']>>;
  motherFirstName?: InputMaybe<Scalars['String']['input']>;
  motherLastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  takenMedicines?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
}

export interface EesztAppointmentBookingTransaction {
  __typename: 'EesztAppointmentBookingTransaction';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EesztAppointmentBookingTransactionStatusEnum>;
  updatedAt: Scalars['DateTime']['output'];
}

/** Possible statuses for EesztAppointmentBookingTransactions */
export enum EesztAppointmentBookingTransactionStatusEnum {
  Failed = 'Failed',
  Pending = 'Pending',
  Success = 'Success'
}

export interface EesztTorSyncState {
  __typename: 'EesztTorSyncState';
  lastSyncEndDate?: Maybe<Scalars['DateTime']['output']>;
  lastSyncSuccessful?: Maybe<Scalars['Boolean']['output']>;
  synchronizationInProgress: Scalars['Boolean']['output'];
}

export interface FileDocument {
  __typename: 'FileDocument';
  base64EncodedFile: Scalars['String']['output'];
  document: Document;
}

export interface FileUploadData {
  __typename: 'FileUploadData';
  maxFileSize: SurveyQuestionFileSize;
  maxItemsCount: Scalars['Float']['output'];
  validFileTypes: Array<SurveyQuestionValidFileType>;
}

export interface FileUploadDataInput {
  maxFileSize: SurveyQuestionFileSize;
  maxItemsCount: Scalars['Float']['input'];
  validFileTypes: Array<SurveyQuestionValidFileType>;
}

export interface FileUploadQuestionAnswer {
  __typename: 'FileUploadQuestionAnswer';
  documents?: Maybe<Array<DocumentAnswer>>;
}

export interface FileUploadQuestionResult {
  __typename: 'FileUploadQuestionResult';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<DocumentAnswer>;
  id: Scalars['ID']['output'];
  isGlobal: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  totalSubmitters: Scalars['Float']['output'];
  type: SurveyQuestionEnum;
  updatedAt: Scalars['DateTime']['output'];
}

export type FindAssistantProfileResult = AssistantProfile | AssistantProfileNotFoundError;

export type FindPatientProfileResult = PatientProfile | PatientProfileNotFoundError;

export interface FirstAndLastDates {
  __typename: 'FirstAndLastDates';
  firstAppointmentDate?: Maybe<Scalars['DateTime']['output']>;
  lastAppointmentDate?: Maybe<Scalars['DateTime']['output']>;
}

/** Possible gender types */
export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

export interface IdentificationData {
  __typename: 'IdentificationData';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface IndividualResults {
  __typename: 'IndividualResults';
  csvInBase64: Scalars['String']['output'];
  surveys: Array<Survey>;
  total: Scalars['Float']['output'];
  xlsxInBase64: Scalars['String']['output'];
}

export interface InputAspectAnswer {
  aspectId: Scalars['String']['input'];
  scaleValue: Scalars['Float']['input'];
}

export interface InputFileUploadAnswer {
  documentId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}

export interface InputFileUploadQuestionAnswer {
  documents?: InputMaybe<Array<InputFileUploadAnswer>>;
}

export interface InputMcQuestionAnswer {
  selectedChoiceIds?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface InputScaleQuestionAnswer {
  aspectAnswers?: InputMaybe<Array<InputAspectAnswer>>;
}

export interface InputSimpleTextQuestionAnswer {
  text?: InputMaybe<Scalars['String']['input']>;
}

export interface InputSurveyQuestionAnswer {
  fileUploadQuestionAnswer?: InputMaybe<InputFileUploadQuestionAnswer>;
  mcQuestionAnswer?: InputMaybe<InputMcQuestionAnswer>;
  scaleQuestionAnswer?: InputMaybe<InputScaleQuestionAnswer>;
  simpleTextQuestionAnswer?: InputMaybe<InputSimpleTextQuestionAnswer>;
  surveyId: Scalars['String']['input'];
  surveyQuestionId: Scalars['String']['input'];
}

export interface InputSurveySchemaReferenceUrl {
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
}

export interface Institution {
  __typename: 'Institution';
  addressAddress?: Maybe<Scalars['String']['output']>;
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCounty?: Maybe<Scalars['String']['output']>;
  addressPostalCode?: Maybe<Scalars['String']['output']>;
  concatenatedAddress?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  eesztId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  isOwn: Scalars['Boolean']['output'];
  mapLink?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  neak?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rooms: Array<Room>;
  updatedAt: Scalars['DateTime']['output'];
  website?: Maybe<Scalars['String']['output']>;
}

export interface InstitutionInput {
  addressAddress?: InputMaybe<Scalars['String']['input']>;
  addressCity?: InputMaybe<Scalars['String']['input']>;
  addressCounty?: InputMaybe<Scalars['String']['input']>;
  addressPostalCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  neak?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
}

export interface InstitutionInputData {
  assistant?: InputMaybe<AssistantInputData>;
  facebookId?: InputMaybe<Scalars['String']['input']>;
  institution: InstitutionInputType;
  phone?: InputMaybe<Scalars['String']['input']>;
  workingHours?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface InstitutionInputType {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}

export interface InstitutionList {
  __typename: 'InstitutionList';
  institutions: Array<Institution>;
  total: Scalars['Float']['output'];
}

export interface InstitutionPermission {
  __typename: 'InstitutionPermission';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  institution: Institution;
  institutionId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  userId: Scalars['String']['output'];
}

export interface InstitutionToDoctor {
  __typename: 'InstitutionToDoctor';
  assistant?: Maybe<Scalars['JSON']['output']>;
  doctorProfile: DoctorProfile;
  doctorProfileId: Scalars['String']['output'];
  facebookId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institution: Institution;
  institutionId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  workingHours?: Maybe<Array<Scalars['String']['output']>>;
}

export interface Invitations {
  __typename: 'Invitations';
  assistants?: Maybe<Array<User>>;
  doctors?: Maybe<Array<User>>;
}

/** Possible languages */
export enum Language {
  en = 'en',
  hu = 'hu'
}

export interface LifeStyleGroup {
  __typename: 'LifeStyleGroup';
  alcohol?: Maybe<Scalars['String']['output']>;
  diet?: Maybe<Scalars['String']['output']>;
  exercise?: Maybe<Scalars['String']['output']>;
  healthHabits?: Maybe<Scalars['String']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  medicationInfo?: Maybe<Scalars['String']['output']>;
  smoking?: Maybe<Scalars['String']['output']>;
  toxicImpacts?: Maybe<Scalars['String']['output']>;
  typeOfWork?: Maybe<Scalars['String']['output']>;
}

export interface LogUser {
  __typename: 'LogUser';
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
}

export interface LoginResponse {
  __typename: 'LoginResponse';
  isFirstLogin: Scalars['Boolean']['output'];
  /** It will always be NULL in case 2FA is enabled. */
  jwtToken?: Maybe<Scalars['String']['output']>;
}

export interface LoginWithTwoFactorTokenInput {
  email: Scalars['String']['input'];
  token: Scalars['String']['input'];
}

export interface LoginWithTwoFactorTokenResponse {
  __typename: 'LoginWithTwoFactorTokenResponse';
  jwtToken: Scalars['String']['output'];
}

export interface McQuestionAnswer {
  __typename: 'McQuestionAnswer';
  selectedChoiceIds?: Maybe<Array<Scalars['String']['output']>>;
}

export interface MedicationGroup {
  __typename: 'MedicationGroup';
  date: Scalars['DateTime']['output'];
  doctor: Scalars['String']['output'];
  dosage: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isTakenNow?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  severity?: Maybe<Severity>;
}

export interface Message {
  __typename: 'Message';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  readAt?: Maybe<Scalars['DateTime']['output']>;
  recipientUser?: Maybe<User>;
  recipientUserId: Scalars['ID']['output'];
  senderUser?: Maybe<User>;
  senderUserId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface MessagePartner {
  __typename: 'MessagePartner';
  id: Scalars['ID']['output'];
  lastMessageAt?: Maybe<Scalars['DateTime']['output']>;
  newMessages: Array<Message>;
  user: User;
}

export interface MultiLangText {
  __typename: 'MultiLangText';
  en: Scalars['String']['output'];
  hu: Scalars['String']['output'];
}

export interface MultiLangTextInput {
  en: Scalars['String']['input'];
  hu: Scalars['String']['input'];
}

export interface MultipleChoiceQuestionResult {
  __typename: 'MultipleChoiceQuestionResult';
  choiceResults: Array<ChoiceResult>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isGlobal: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  totalAnswers: Scalars['Float']['output'];
  type: SurveyQuestionEnum;
  updatedAt: Scalars['DateTime']['output'];
}

export interface Mutation {
  __typename: 'Mutation';
  EesztESZIGLogin: EESZTLoginResponse;
  EesztLogout: EESZTLogoutResponse;
  EesztMobileTokenLogin: EESZTLoginResponse;
  EesztStsLogin: EESZTLoginResponse;
  addAssistantToDoctor: DoctorOwnAssistants;
  addProtocol: Treatment;
  addSchedule: SchemaSchedule;
  addSchemaDependency: SchemaDependency;
  addSurveySchemaToTreatmentSchema: TreatmentSchemaToSurvey;
  addSurveyToTreatment: Survey;
  assignAdminsToInstitution: Institution;
  cancelTreatment: Treatment;
  changeLanguage: User;
  createAppointment: Appointment;
  createAppointmentDependency: AppointmentDependency;
  createAppointmentInfo: AppointmentInfo;
  createInstitution: Institution;
  createNewTreatmentSchema: TreatmentSchema;
  createReferral: Referral;
  createRoom: Room;
  createSchedules: Array<SchemaSchedule>;
  createSurveyQuestion: SurveyQuestion;
  createSurveySchema: SurveySchema;
  createTreatment: Treatment;
  deleteAppointment: Appointment;
  deleteAppointmentDependency: AppointmentDependency;
  deleteAppointmentInfo: AppointmentInfo;
  deleteAppointments: Array<Appointment>;
  deleteDoctorsOwnPatient?: Maybe<DoctorOwnPatients>;
  deleteDoctorsOwnPatients?: Maybe<Array<BulkDismissResult>>;
  deleteDraftTreatment: Scalars['Boolean']['output'];
  deleteInvitation: Scalars['Boolean']['output'];
  deleteProtocol: Treatment;
  deleteReferral: Scalars['Boolean']['output'];
  deleteSurveyQuestion: SurveyQuestion;
  deleteSurveySchema: SurveySchema;
  deleteSurveysFromTreatment: Scalars['Boolean']['output'];
  downloadDocuments: Array<FileDocument>;
  duplicateSurveySchema: SurveySchema;
  duplicateTreatmentSchema: TreatmentSchema;
  finishSurvey: Survey;
  initiatePasswordReset: Scalars['Boolean']['output'];
  inviteAssistant: AssistantProfile;
  inviteDoctor: DoctorProfile;
  inviteExistingPatient: Array<DoctorOwnPatients>;
  invitePatient: PatientProfile;
  login: LoginResponse;
  loginWithTwoFactorToken: LoginWithTwoFactorTokenResponse;
  markAllNotificationAsRead: Scalars['Boolean']['output'];
  markMessagesAsRead: Array<Message>;
  markNotificationAsRead: Notification;
  markSurveyTouched: Survey;
  removeAssistantFromDoctor: DoctorOwnAssistants;
  removeSchedule: SchemaSchedule;
  removeSchedules: Scalars['Float']['output'];
  removeSchemaDependency: SchemaDependency;
  removeSurveyFromTreatment: Survey;
  removeSurveySchemaFromTreatmentSchema: TreatmentSchemaToSurvey;
  removeTreatmentSchema: TreatmentSchema;
  resendSurvey: Survey;
  sendDraftTreatment: Treatment;
  sendMessage: Message;
  sendMessageToUsers: SendManyResults;
  sendSurveyToUsers: Array<Survey>;
  setCustomDaysOfSchedule: SchemaSchedule;
  setCustomDaysOfTreatmentSchemaSurvey: TreatmentSchemaToSurvey;
  setNewPassword: Scalars['Boolean']['output'];
  shareSurveySchema: SurveySchema;
  shareTreatmentSchema: TreatmentSchema;
  synchronizeEesztTorData: Scalars['Boolean']['output'];
  unSubscribeTreatmentSchema: TreatmentSchema;
  unsubscribeFromSurveySchema: SurveySchema;
  updateAppointment: AppointmentUpdateResult;
  updateAppointmentDependency: AppointmentDependency;
  updateAppointmentGoodToKnow: Appointment;
  updateAppointmentInfo: AppointmentInfo;
  updateAppointmentOeno: Appointment;
  updateAppointmentWithDeps: Appointment;
  updateAssistantProfile: AssistantProfile;
  updateDoctorProfile: DoctorProfile;
  updateInstitution: Institution;
  updateNotificationSettings: NotificationSettings;
  updatePatientProfile: PatientProfile;
  updatePatientsBloodType: PatientProfile;
  updatePoc: EESZTPocId;
  updateRoom: Room;
  updateScheduleAppointmentInfo: AppointmentInfo;
  updateSchemaDependency: SchemaDependency;
  updateSurveyFillableFromDate: Survey;
  updateSurveyFillableUntilDate: Survey;
  updateSurveyQuestion: SurveyQuestion;
  updateSurveySchema: SurveySchema;
  updateSurveySchemaStatus: SurveySchema;
  updateTreatment: Treatment;
  updateTreatmentSchema: TreatmentSchema;
  updateTreatmentSchemaStatus: TreatmentSchema;
  uploadCertificate: Scalars['Boolean']['output'];
  uploadDocument: Scalars['String']['output'];
  upsertSurveyQuestionAnswer: SurveyQuestionAnswer;
}


export interface MutationEesztESZIGLoginArgs {
  token: Scalars['String']['input'];
}


export interface MutationEesztMobileTokenLoginArgs {
  institutionId: Scalars['String']['input'];
  institutionUnitId: Scalars['String']['input'];
  mobileToken: Scalars['String']['input'];
}


export interface MutationEesztStsLoginArgs {
  institutionId: Scalars['String']['input'];
  institutionUnitId: Scalars['String']['input'];
  stsLoginInput: EESZTStsLoginInput;
}


export interface MutationaddAssistantToDoctorArgs {
  assistantId: Scalars['String']['input'];
}


export interface MutationaddProtocolArgs {
  treatmentData: AddProtocolInput;
}


export interface MutationaddScheduleArgs {
  appointmentInfoId: Scalars['String']['input'];
  treatmentSchemaId: Scalars['String']['input'];
}


export interface MutationaddSchemaDependencyArgs {
  dependencyInput: CreateDependencyInput;
}


export interface MutationaddSurveySchemaToTreatmentSchemaArgs {
  surveySchemaId: Scalars['String']['input'];
  treatmentSchemaId: Scalars['String']['input'];
}


export interface MutationaddSurveyToTreatmentArgs {
  fillableFrom: Scalars['DateTime']['input'];
  fillableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  patientUserId: Scalars['String']['input'];
  surveySchemaId: Scalars['String']['input'];
  treatmentId: Scalars['String']['input'];
}


export interface MutationassignAdminsToInstitutionArgs {
  institutionId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
}


export interface MutationcancelTreatmentArgs {
  treatmentData: CancelTreatmentInput;
}


export interface MutationchangeLanguageArgs {
  language: Scalars['String']['input'];
}


export interface MutationcreateAppointmentArgs {
  appointmentInput: AppointmentInput;
}


export interface MutationcreateAppointmentDependencyArgs {
  createAppointmentDependencyInput: CreateAppointmentDependencyInput;
}


export interface MutationcreateAppointmentInfoArgs {
  createAppointmentInfoInput: CreateAppointmentInfoInput;
}


export interface MutationcreateInstitutionArgs {
  institutionInput: InstitutionInput;
}


export interface MutationcreateNewTreatmentSchemaArgs {
  schema: TreatmentSchemaCreateInput;
}


export interface MutationcreateReferralArgs {
  referralData: CreateReferralInput;
}


export interface MutationcreateRoomArgs {
  createRoomInput: CreateRoomInput;
}


export interface MutationcreateSchedulesArgs {
  appointmentInfoIds: Array<Scalars['String']['input']>;
  treatmentSchemaId: Scalars['String']['input'];
}


export interface MutationcreateSurveyQuestionArgs {
  surveyQuestionData: CreateSurveyQuestionInput;
}


export interface MutationcreateSurveySchemaArgs {
  surveySchemaData: CreateSurveySchemaInput;
}


export interface MutationcreateTreatmentArgs {
  treatmentData: CreateTreatmentInput;
}


export interface MutationdeleteAppointmentArgs {
  appointmentId: Scalars['String']['input'];
}


export interface MutationdeleteAppointmentDependencyArgs {
  dependencyId: Scalars['String']['input'];
}


export interface MutationdeleteAppointmentInfoArgs {
  appointmentInfoInput: DeleteAppointmentInfoInput;
}


export interface MutationdeleteAppointmentsArgs {
  appointmentIds: Array<Scalars['String']['input']>;
}


export interface MutationdeleteDoctorsOwnPatientArgs {
  patientId: Scalars['String']['input'];
}


export interface MutationdeleteDoctorsOwnPatientsArgs {
  patientIds: Array<Scalars['String']['input']>;
}


export interface MutationdeleteDraftTreatmentArgs {
  treatmentData: UpdateTreatmentInput;
}


export interface MutationdeleteInvitationArgs {
  deleteUserId: Scalars['String']['input'];
}


export interface MutationdeleteProtocolArgs {
  treatmentData: DeleteProtocolInput;
}


export interface MutationdeleteReferralArgs {
  referralId: Scalars['String']['input'];
}


export interface MutationdeleteSurveyQuestionArgs {
  surveyQuestionId: Scalars['String']['input'];
}


export interface MutationdeleteSurveySchemaArgs {
  surveySchemaId: Scalars['String']['input'];
}


export interface MutationdeleteSurveysFromTreatmentArgs {
  surveyIds: Array<Scalars['String']['input']>;
  treatmentId: Scalars['String']['input'];
}


export interface MutationdownloadDocumentsArgs {
  documentIds: Array<Scalars['String']['input']>;
}


export interface MutationduplicateSurveySchemaArgs {
  surveySchemaId: Scalars['String']['input'];
}


export interface MutationduplicateTreatmentSchemaArgs {
  treatmentSchemaId: Scalars['String']['input'];
}


export interface MutationfinishSurveyArgs {
  surveyId: Scalars['String']['input'];
}


export interface MutationinitiatePasswordResetArgs {
  email: Scalars['String']['input'];
}


export interface MutationinviteAssistantArgs {
  createAssistantArgs: CreateAssistantProfileData;
}


export interface MutationinviteDoctorArgs {
  createDoctorArgs: CreateDoctorProfileData;
}


export interface MutationinviteExistingPatientArgs {
  doctorUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
  patientId: Scalars['String']['input'];
}


export interface MutationinvitePatientArgs {
  createPatientArgs: CreatePatientProfileData;
  doctorUserIds?: InputMaybe<Array<Scalars['String']['input']>>;
}


export interface MutationloginArgs {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}


export interface MutationloginWithTwoFactorTokenArgs {
  loginWithTwoFactorTokenInput: LoginWithTwoFactorTokenInput;
}


export interface MutationmarkMessagesAsReadArgs {
  senderUserId?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationmarkNotificationAsReadArgs {
  notificationId: Scalars['String']['input'];
}


export interface MutationmarkSurveyTouchedArgs {
  surveyId: Scalars['String']['input'];
}


export interface MutationremoveAssistantFromDoctorArgs {
  assistantId: Scalars['String']['input'];
}


export interface MutationremoveScheduleArgs {
  scheduleId: Scalars['String']['input'];
}


export interface MutationremoveSchedulesArgs {
  scheduleIds: Array<Scalars['String']['input']>;
}


export interface MutationremoveSchemaDependencyArgs {
  dependencyId: Scalars['String']['input'];
  treatmentSchemaId: Scalars['String']['input'];
}


export interface MutationremoveSurveyFromTreatmentArgs {
  surveyId: Scalars['String']['input'];
  treatmentId: Scalars['String']['input'];
}


export interface MutationremoveSurveySchemaFromTreatmentSchemaArgs {
  treatmentSchemaToSurveyId: Scalars['String']['input'];
}


export interface MutationremoveTreatmentSchemaArgs {
  treatmentSchemaId: Scalars['String']['input'];
}


export interface MutationresendSurveyArgs {
  surveyId: Scalars['String']['input'];
}


export interface MutationsendDraftTreatmentArgs {
  treatmentId: Scalars['ID']['input'];
}


export interface MutationsendMessageArgs {
  message: Scalars['String']['input'];
  recipientUserId: Scalars['String']['input'];
}


export interface MutationsendMessageToUsersArgs {
  alsoAsEmail: Scalars['Boolean']['input'];
  message: Scalars['String']['input'];
  recipientUserIds: Array<Scalars['String']['input']>;
}


export interface MutationsendSurveyToUsersArgs {
  fillableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  fillableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  patientId?: InputMaybe<Scalars['String']['input']>;
  surveySchemaId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
}


export interface MutationsetCustomDaysOfScheduleArgs {
  customDays?: InputMaybe<Scalars['Float']['input']>;
  scheduleId: Scalars['String']['input'];
}


export interface MutationsetCustomDaysOfTreatmentSchemaSurveyArgs {
  customDays?: InputMaybe<Scalars['Float']['input']>;
  treatmentSchemaToSurveyId: Scalars['String']['input'];
}


export interface MutationsetNewPasswordArgs {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}


export interface MutationshareSurveySchemaArgs {
  shareSurveySchemaInput: ShareSurveySchemaInput;
}


export interface MutationshareTreatmentSchemaArgs {
  treatmentData: ShareSchemaInput;
}


export interface MutationunSubscribeTreatmentSchemaArgs {
  treatmentData: UnsubscribeSchemaInput;
}


export interface MutationunsubscribeFromSurveySchemaArgs {
  surveySchemaId: Scalars['String']['input'];
}


export interface MutationupdateAppointmentArgs {
  updateInput: AppointmentUpdateInput;
}


export interface MutationupdateAppointmentDependencyArgs {
  updateAppointmentDependencyInput: UpdateAppointmentDependencyInput;
}


export interface MutationupdateAppointmentGoodToKnowArgs {
  appointmentId: Scalars['String']['input'];
  updateGoodToKnowInput: AppointmentUpdateGoodToKnowInput;
}


export interface MutationupdateAppointmentInfoArgs {
  appointmentInfoInput: UpdateAppointmentInfoInput;
}


export interface MutationupdateAppointmentOenoArgs {
  appointmentId: Scalars['String']['input'];
  oeno: Scalars['String']['input'];
}


export interface MutationupdateAppointmentWithDepsArgs {
  reschedule: Scalars['Boolean']['input'];
  updateInput: AppointmentUpdateInput;
}


export interface MutationupdateAssistantProfileArgs {
  updateAssistantInput: UpdateAssistantProfileInput;
}


export interface MutationupdateDoctorProfileArgs {
  doctorProfileId: Scalars['String']['input'];
  updateDoctorInput: EditAbleDoctorData;
}


export interface MutationupdateInstitutionArgs {
  id: Scalars['String']['input'];
  institutionInput: InstitutionInput;
}


export interface MutationupdateNotificationSettingsArgs {
  newSettings: NotificationSettingsInput;
}


export interface MutationupdatePatientProfileArgs {
  patientId: Scalars['String']['input'];
  updatePatientInput: EditablePatientData;
}


export interface MutationupdatePatientsBloodTypeArgs {
  bloodType: BloodType;
  bloodTypeAttachmentEESZTId?: InputMaybe<Scalars['String']['input']>;
  patientId: Scalars['String']['input'];
}


export interface MutationupdatePocArgs {
  appointmentId: Scalars['String']['input'];
  katId: Scalars['String']['input'];
  pocId: Scalars['String']['input'];
}


export interface MutationupdateRoomArgs {
  updateRoomInput: UpdateRoomInput;
}


export interface MutationupdateScheduleAppointmentInfoArgs {
  appointmentInfoInput: UpdateScheduleAppointmentInfoInput;
  scheduleId: Scalars['String']['input'];
}


export interface MutationupdateSchemaDependencyArgs {
  dependencyInput: UpdateDependencyInput;
}


export interface MutationupdateSurveyFillableFromDateArgs {
  fillableFromDate: Scalars['DateTime']['input'];
  fillableUntilDate: Scalars['DateTime']['input'];
  surveyId: Scalars['String']['input'];
}


export interface MutationupdateSurveyFillableUntilDateArgs {
  fillableUntilDate: Scalars['DateTime']['input'];
  surveyId: Scalars['String']['input'];
}


export interface MutationupdateSurveyQuestionArgs {
  surveyQuestionData: UpdateSurveyQuestionInput;
}


export interface MutationupdateSurveySchemaArgs {
  surveySchemaData: UpdateSurveySchemaInput;
}


export interface MutationupdateSurveySchemaStatusArgs {
  status: SurveySchemaStatusEnum;
  surveySchemaId: Scalars['String']['input'];
}


export interface MutationupdateTreatmentArgs {
  treatmentData: UpdateTreatmentInput;
}


export interface MutationupdateTreatmentSchemaArgs {
  treatmentData: UpdateSchemaInput;
}


export interface MutationupdateTreatmentSchemaStatusArgs {
  publish: Scalars['Boolean']['input'];
  treatmentSchemaId: Scalars['ID']['input'];
}


export interface MutationuploadCertificateArgs {
  certificate: Scalars['Upload']['input'];
  institutionId: Scalars['String']['input'];
  passphrase: Scalars['String']['input'];
}


export interface MutationuploadDocumentArgs {
  documentType: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
}


export interface MutationupsertSurveyQuestionAnswerArgs {
  inputSurveyQuestionAnswer: InputSurveyQuestionAnswer;
}

export interface NextSectionInformation {
  __typename: 'NextSectionInformation';
  choiceId: Scalars['String']['output'];
  choiceIndex: Scalars['Float']['output'];
  nextSectionOrder: Scalars['Float']['output'];
}

export interface NextSectionInformationInput {
  choiceId: Scalars['String']['input'];
  choiceIndex: Scalars['Float']['input'];
  nextSectionOrder: Scalars['Float']['input'];
}

export interface Notification {
  __typename: 'Notification';
  appointment?: Maybe<Appointment>;
  appointmentId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isRead: Scalars['Boolean']['output'];
  recipientUser?: Maybe<User>;
  recipientUserId?: Maybe<Scalars['ID']['output']>;
  sentAt?: Maybe<Scalars['DateTimeISO']['output']>;
  type: NotificationTypes;
  updatedAt: Scalars['DateTime']['output'];
}

export interface NotificationSettings {
  __typename: 'NotificationSettings';
  allowEmailSending: Scalars['Boolean']['output'];
  allowSmsSending: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  type: NotificationTypes;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
}

export interface NotificationSettingsInput {
  allowEmailSending?: InputMaybe<Scalars['Boolean']['input']>;
  allowSmsSending?: InputMaybe<Scalars['Boolean']['input']>;
  type: NotificationTypes;
}

/** Types of possible notifications */
export enum NotificationTypes {
  AppointmentGoodToKnowChanged = 'AppointmentGoodToKnowChanged',
  AppointmentLocationChanged = 'AppointmentLocationChanged',
  AppointmentStatusChanged = 'AppointmentStatusChanged',
  AppointmentTimeChanged = 'AppointmentTimeChanged',
  AssistantAddedToDoctor = 'AssistantAddedToDoctor',
  AssistantInvite = 'AssistantInvite',
  CancelledTreatment = 'CancelledTreatment',
  DailyAppointmentReminder = 'DailyAppointmentReminder',
  DoctorDeclinedAppointment = 'DoctorDeclinedAppointment',
  DoctorInvite = 'DoctorInvite',
  DoctorNextWeekTasks = 'DoctorNextWeekTasks',
  DoctorReceivedNewPatient = 'DoctorReceivedNewPatient',
  EESZTNewFeedItem = 'EESZTNewFeedItem',
  ExpiringPasswordReminder = 'ExpiringPasswordReminder',
  ExpiringTreatmentReminder = 'ExpiringTreatmentReminder',
  LockOutUser = 'LockOutUser',
  NewAppointment = 'NewAppointment',
  NewAppointmentAssignedToDoctor = 'NewAppointmentAssignedToDoctor',
  NewDoctorAssignedToAppointment = 'NewDoctorAssignedToAppointment',
  NewHealthIssue = 'NewHealthIssue',
  NewMessage = 'NewMessage',
  NewSurvey = 'NewSurvey',
  NewTreatment = 'NewTreatment',
  PasswordResetLink = 'PasswordResetLink',
  PatientAddedToDoctor = 'PatientAddedToDoctor',
  PatientInvite = 'PatientInvite',
  PatientNextWeekAppointments = 'PatientNextWeekAppointments',
  SurveyFillableFromToday = 'SurveyFillableFromToday',
  SurveyToFillExpiring = 'SurveyToFillExpiring',
  TwoFactorAuthToken = 'TwoFactorAuthToken'
}

export interface OptionalMultiLangText {
  __typename: 'OptionalMultiLangText';
  en?: Maybe<Scalars['String']['output']>;
  hu?: Maybe<Scalars['String']['output']>;
}

export interface OptionalMultiLangTextInput {
  en?: InputMaybe<Scalars['String']['input']>;
  hu?: InputMaybe<Scalars['String']['input']>;
}

export interface PaginationInput {
  limit?: InputMaybe<Scalars['Float']['input']>;
  offset?: InputMaybe<Scalars['Float']['input']>;
}

export interface PatientAgeFilter {
  max?: InputMaybe<Scalars['Float']['input']>;
  min?: InputMaybe<Scalars['Float']['input']>;
}

export interface PatientBNOCodeFilter {
  excludes?: InputMaybe<Array<Scalars['String']['input']>>;
  includes?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface PatientContact {
  __typename: 'PatientContact';
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
}

export interface PatientContactInput {
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
}

export interface PatientEProfile {
  __typename: 'PatientEProfile';
  cases: Array<CaseGroup>;
  lifestyle: LifeStyleGroup;
  medications: Array<MedicationGroup>;
  patientId: Scalars['ID']['output'];
  surgeries: Array<SurgeryGroup>;
  syncStatus: EESzTSyncResult;
  vaccinations: Array<VaccinationGroup>;
  warnings: Array<WarningGroup>;
}

export interface PatientFilter {
  age?: InputMaybe<PatientAgeFilter>;
  appointmentDateRange?: InputMaybe<AppointmentDateFilter>;
  appointmentInfoIds?: InputMaybe<Array<Scalars['String']['input']>>;
  appointmentStatuses?: InputMaybe<Array<AppointmentStatus>>;
  bnoCode?: InputMaybe<PatientBNOCodeFilter>;
  cities?: InputMaybe<Array<Scalars['String']['input']>>;
  gender?: InputMaybe<Gender>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  nameOrTAJ?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<PatientStatus>;
}

export interface PatientProfile extends ProfileInterface {
  __typename: 'PatientProfile';
  addressCity?: Maybe<Scalars['String']['output']>;
  addressCounty?: Maybe<Scalars['String']['output']>;
  addressPostalCode?: Maybe<Scalars['String']['output']>;
  addressStreet?: Maybe<Scalars['String']['output']>;
  birthDate: Scalars['DateTime']['output'];
  birthPlace: Scalars['String']['output'];
  bloodType?: Maybe<BloodType>;
  bloodTypeAttachmentEESZTId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  doctors: Array<DoctorProfile>;
  ehrDocumentList: EESZTEhrDocumentList;
  emailSettings?: Maybe<Scalars['JSON']['output']>;
  emergencyContacts?: Maybe<Array<PatientContact>>;
  entitleToInfoContacts?: Maybe<Array<PatientContact>>;
  extraInfo: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  isDeletableForDoctor: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  medicineIntolerance?: Maybe<Array<Scalars['String']['output']>>;
  motherFirstName: Scalars['String']['output'];
  motherLastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  tajNumber: Scalars['String']['output'];
  takenMedicines?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  treatments: Array<Treatment>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
  weight?: Maybe<Scalars['Int']['output']>;
}


export interface PatientProfileehrDocumentListArgs {
  paginationInput?: InputMaybe<PaginationInput>;
}

export interface PatientProfileList {
  __typename: 'PatientProfileList';
  patients: Array<DoctorOwnPatients>;
  total: Scalars['Float']['output'];
}

export interface PatientProfileNotFoundError {
  __typename: 'PatientProfileNotFoundError';
  message: Scalars['String']['output'];
}

/** Patient status */
export enum PatientStatus {
  ACTIVE = 'ACTIVE',
  DISCHARGED = 'DISCHARGED'
}

export interface PlainTreatmentElement {
  __typename: 'PlainTreatmentElement';
  appointmentInfo: AppointmentInfo;
  createdAt: Scalars['DateTime']['output'];
  customDays?: Maybe<Scalars['Float']['output']>;
  date: StartEndDates;
  dependencies: Array<Dependency>;
  dependents: Array<Dependency>;
  doctorTitle?: Maybe<MultiLangText>;
  id: Scalars['String']['output'];
  isModified?: Maybe<Scalars['Boolean']['output']>;
  oldDate?: Maybe<StartEndDates>;
}

export interface Profession {
  __typename: 'Profession';
  appointmentInfos: Array<AppointmentInfo>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  doctorProfiles: Array<DoctorProfile>;
  id: Scalars['ID']['output'];
  isSystemDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface ProfileInterface {
  createdAt: Scalars['DateTime']['output'];
  extraInfo: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gender: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['String']['output'];
}

export interface Query {
  __typename: 'Query';
  EesztFeed: EESZTRssFeed;
  appointmentCountByIsOwnAndInFuture: Scalars['Int']['output'];
  bnoCode: BnoCode;
  bnoCodes: Array<BnoCode>;
  checkCertificate: Scalars['Boolean']['output'];
  eesztTorSyncState: EesztTorSyncState;
  findAssistantProfile: FindAssistantProfileResult;
  findPatientProfile: FindPatientProfileResult;
  getAggregatedSurveyResults: AggregatedSurveyResults;
  getAppointment: Appointment;
  getAppointments: AppointmentList;
  getAssistantProfile: AssistantProfile;
  getAssistantProfiles: AssistantProfileList;
  getDashboardAppointments: AppointmentList;
  getDoctorOwnAssistants: Array<DoctorOwnAssistants>;
  getDoctorProfile: DoctorProfile;
  getDoctorProfiles: DoctorProfileList;
  getDoctorProfilesForAssistant: Array<DoctorProfile>;
  getDoctorProfilesForPatients: Array<DoctorProfile>;
  getEProfile: PatientEProfile;
  getEszigIdNoSaml: Scalars['String']['output'];
  getFreeSlotsByInstitution: Array<EESZTSlot>;
  getIndividualSurveyResults: IndividualResults;
  getInvitedDoctorsByAdmin: Array<User>;
  getKatEvents: Array<EESZTKatEvent>;
  getLocationByPostalCode: Array<Scalars['String']['output']>;
  getLocations: Array<Scalars['String']['output']>;
  getNewMessages: Array<Message>;
  getNotificationSettings: Array<NotificationSettings>;
  getNotifications: Array<Notification>;
  getOwnSurveys: SurveyList;
  getPartnerMessages: Array<Message>;
  getPartners: Array<MessagePartner>;
  getPatientProfile: PatientProfile;
  getProfessionCode: Profession;
  getProfessionCodes: Array<Profession>;
  getReceivedSurveysForAssistant: SurveyList;
  getReceivedSurveysForDoctor: SurveyList;
  getReferral: Referral;
  getReferrals: ReferralList;
  getSentSurveysForAssistant: SurveyList;
  getSentSurveysForDoctor: SurveyList;
  getServiceType: ServiceType;
  getServiceTypes: Array<ServiceType>;
  getSurvey: Survey;
  getSurveyQuestionBySurveyQuestionId: SurveyQuestion;
  getSurveyQuestions: SurveyQuestionList;
  getSurveySchemaById: SurveySchema;
  getSurveySchemas: SurveySchemaList;
  getSurveysForPatient: SurveyList;
  getSurveysForSchemaId: SurveyList;
  getTreatment: Treatment;
  getTreatmentSchema: TreatmentSchema;
  getTreatmentSchemas: TreatmentSchemaList;
  getTreatmentsToPatientDashboard: Array<Treatment>;
  institutionAdminProfiles: Array<ProfileInterface>;
  isSurveyExpireSoonByIsOwnAndNotFinished: Scalars['Boolean']['output'];
  listAllAppointmentInfos: Array<AppointmentInfo>;
  listAllDoctors: Array<DoctorProfile>;
  listAllProfessions: Array<Profession>;
  listAppointmentInfos: Array<AppointmentInfo>;
  listInstitutions: InstitutionList;
  listPatientsForDoctor: PatientProfileList;
  listProfiles: Array<ProfileInterface>;
  me: User;
  profile?: Maybe<ProfileInterface>;
  surveyCountByIsOwn: Scalars['Int']['output'];
  surveyCountByIsOwnAndNotFinished: Scalars['Int']['output'];
  triggerDoctorNextWeekTasks: Scalars['Boolean']['output'];
  triggerExpirePastAppointments: Array<Appointment>;
  triggerExpiringTreatmentRemainder: Scalars['Boolean']['output'];
  triggerPatientDailyAppointmentReminder: Scalars['Boolean']['output'];
  triggerPatientNextWeekAppointments: Scalars['Boolean']['output'];
}


export interface QuerybnoCodeArgs {
  id: Scalars['ID']['input'];
}


export interface QuerybnoCodesArgs {
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerycheckCertificateArgs {
  institutionId: Scalars['String']['input'];
}


export interface QueryfindAssistantProfileArgs {
  registrationNumber: Scalars['String']['input'];
}


export interface QueryfindPatientProfileArgs {
  tajNumber: Scalars['String']['input'];
}


export interface QuerygetAggregatedSurveyResultsArgs {
  dateIntervalInput?: InputMaybe<DateIntervalInput>;
  surveySchemaId: Scalars['String']['input'];
}


export interface QuerygetAppointmentArgs {
  appointmentId: Scalars['String']['input'];
}


export interface QuerygetAppointmentsArgs {
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
  paginationInput?: InputMaybe<PaginationInput>;
  patientId: Scalars['String']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  treatmentId?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerygetAssistantProfilesArgs {
  filter?: InputMaybe<AssistantProfileFilter>;
  paginationInput?: InputMaybe<PaginationInput>;
}


export interface QuerygetDashboardAppointmentsArgs {
  endDate: Scalars['String']['input'];
  paginationInput?: InputMaybe<PaginationInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
}


export interface QuerygetDoctorProfileArgs {
  doctorProfileId: Scalars['String']['input'];
}


export interface QuerygetDoctorProfilesArgs {
  filterInput: DoctorProfileFilter;
  paginationInput: PaginationInput;
}


export interface QuerygetDoctorProfilesForAssistantArgs {
  assistantId: Scalars['ID']['input'];
}


export interface QuerygetDoctorProfilesForPatientsArgs {
  patientId: Scalars['String']['input'];
}


export interface QuerygetEProfileArgs {
  patientId: Scalars['String']['input'];
}


export interface QuerygetFreeSlotsByInstitutionArgs {
  endDate: Scalars['DateTime']['input'];
  institutionId: Scalars['String']['input'];
  institutionUnitId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
}


export interface QuerygetIndividualSurveyResultsArgs {
  dateIntervalInput?: InputMaybe<DateIntervalInput>;
  isAnonymous: Scalars['Boolean']['input'];
  paginationInput?: InputMaybe<PaginationInput>;
  surveySchemaId: Scalars['String']['input'];
}


export interface QuerygetKatEventsArgs {
  tajNumber: Scalars['String']['input'];
}


export interface QuerygetLocationByPostalCodeArgs {
  postalCode: Scalars['String']['input'];
}


export interface QuerygetOwnSurveysArgs {
  filterData: SurveyFilterForPatient;
  paginationInput?: InputMaybe<PaginationInput>;
}


export interface QuerygetPartnerMessagesArgs {
  paginationInput?: InputMaybe<PaginationInput>;
  partnerUserId: Scalars['String']['input'];
}


export interface QuerygetPatientProfileArgs {
  patientId: Scalars['String']['input'];
}


export interface QuerygetProfessionCodeArgs {
  id: Scalars['ID']['input'];
}


export interface QuerygetProfessionCodesArgs {
  nameSearchTerm?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerygetReceivedSurveysForAssistantArgs {
  filterData: SurveyFilterForAssistant;
  paginationInput?: InputMaybe<PaginationInput>;
}


export interface QuerygetReceivedSurveysForDoctorArgs {
  filterData: SurveyFilterForDoctor;
  paginationInput?: InputMaybe<PaginationInput>;
}


export interface QuerygetReferralArgs {
  referralId: Scalars['ID']['input'];
}


export interface QuerygetReferralsArgs {
  filterData?: InputMaybe<ReferralFilter>;
  paginationInput?: InputMaybe<PaginationInput>;
  patientId: Scalars['ID']['input'];
}


export interface QuerygetSentSurveysForAssistantArgs {
  filterData: SurveyFilterForAssistant;
  paginationInput?: InputMaybe<PaginationInput>;
}


export interface QuerygetSentSurveysForDoctorArgs {
  filterData: SurveyFilterForDoctor;
  paginationInput?: InputMaybe<PaginationInput>;
}


export interface QuerygetServiceTypeArgs {
  code: Scalars['ID']['input'];
}


export interface QuerygetServiceTypesArgs {
  professionCode?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerygetSurveyArgs {
  surveyId: Scalars['ID']['input'];
}


export interface QuerygetSurveyQuestionBySurveyQuestionIdArgs {
  surveyQuestionId: Scalars['String']['input'];
}


export interface QuerygetSurveyQuestionsArgs {
  filterInput?: InputMaybe<SurveyQuestionFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
}


export interface QuerygetSurveySchemaByIdArgs {
  surveySchemaId: Scalars['String']['input'];
}


export interface QuerygetSurveySchemasArgs {
  filterData?: InputMaybe<SurveySchemaFilter>;
  paginationInput?: InputMaybe<PaginationInput>;
}


export interface QuerygetSurveysForPatientArgs {
  paginationInput?: InputMaybe<PaginationInput>;
  patient: SurveysForPatient;
}


export interface QuerygetSurveysForSchemaIdArgs {
  filterData: SurveyBySchemaFilter;
  paginationInput?: InputMaybe<PaginationInput>;
}


export interface QuerygetTreatmentArgs {
  sortBy?: InputMaybe<SortByArgs>;
  treatmentId: Scalars['String']['input'];
}


export interface QuerygetTreatmentSchemaArgs {
  treatmentSchemaId: Scalars['String']['input'];
}


export interface QuerygetTreatmentSchemasArgs {
  paginationInput?: InputMaybe<PaginationInput>;
  treatmentSchemaFilter?: InputMaybe<TreatmentSchemaFilter>;
}


export interface QuerygetTreatmentsToPatientDashboardArgs {
  patientId: Scalars['String']['input'];
}


export interface QueryinstitutionAdminProfilesArgs {
  institutionId: Scalars['ID']['input'];
}


export interface QuerylistAllDoctorsArgs {
  doctorListFilterData?: InputMaybe<DoctorProfileFilter>;
}


export interface QuerylistAppointmentInfosArgs {
  treatmentSchemaId?: InputMaybe<Scalars['String']['input']>;
}


export interface QuerylistInstitutionsArgs {
  hasEESZTCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  nameSearchTerm?: InputMaybe<Scalars['String']['input']>;
  paginationInput?: InputMaybe<PaginationInput>;
}


export interface QuerylistPatientsForDoctorArgs {
  doctorIds: Array<Scalars['String']['input']>;
  filterData?: InputMaybe<PatientFilter>;
  paginationInput?: InputMaybe<PaginationInput>;
}


export interface QuerylistProfilesArgs {
  institutionId?: InputMaybe<Scalars['ID']['input']>;
  types?: InputMaybe<Array<UserType>>;
}

export interface QuestionData {
  __typename: 'QuestionData';
  fileUploadData?: Maybe<FileUploadData>;
  multipleChoice?: Maybe<Scalars['Boolean']['output']>;
  scaleData?: Maybe<ScaleData>;
}

export interface QuestionDataInput {
  fileUploadData?: InputMaybe<FileUploadDataInput>;
  multipleChoice?: InputMaybe<Scalars['Boolean']['input']>;
  scaleData?: InputMaybe<ScaleDataInput>;
}

export interface Referral {
  __typename: 'Referral';
  createdAtDate: Scalars['DateTimeISO']['output'];
  createdAtPlace: Scalars['String']['output'];
  description: Scalars['String']['output'];
  doctor: DoctorProfile;
  doctorProfileId: Scalars['ID']['output'];
  expirationDate: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  isDeletable: Scalars['Boolean']['output'];
  logNumber: Scalars['String']['output'];
  name: Scalars['String']['output'];
  patient: PatientProfile;
  patientProfileId: Scalars['ID']['output'];
  profession?: Maybe<Profession>;
  professionId?: Maybe<Scalars['ID']['output']>;
  status: ReferralStatus;
  treatment: Treatment;
  treatmentId: Scalars['ID']['output'];
}

export interface ReferralFilter {
  onlyOwn?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<ReferralStatus>>;
}

export interface ReferralList {
  __typename: 'ReferralList';
  items: Array<Referral>;
  total: Scalars['Float']['output'];
}

export enum ReferralStatus {
  AppointmentBooked = 'AppointmentBooked',
  Created = 'Created',
  Deleted = 'Deleted',
  Expired = 'Expired',
  Finished = 'Finished',
  WaitingOnResult = 'WaitingOnResult'
}

export enum Risk {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export interface Room {
  __typename: 'Room';
  address?: Maybe<OptionalMultiLangText>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<OptionalMultiLangText>;
  eesztConsultingId?: Maybe<Scalars['String']['output']>;
  eesztUnitId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  institutionId?: Maybe<Scalars['ID']['output']>;
  isActive: Scalars['Boolean']['output'];
  mapLink?: Maybe<Scalars['String']['output']>;
  name: MultiLangText;
  neakCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
}

export interface ScaleAspectResult {
  __typename: 'ScaleAspectResult';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  scaleOptionResults: Array<ScaleOptionResult>;
  totalAnswers: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

export interface ScaleData {
  __typename: 'ScaleData';
  options: Array<ScaleOption>;
}

export interface ScaleDataInput {
  options: Array<ScaleOptionInput>;
}

export interface ScaleOption {
  __typename: 'ScaleOption';
  label?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
}

export interface ScaleOptionInput {
  label?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
}

export interface ScaleOptionResult {
  __typename: 'ScaleOptionResult';
  label?: Maybe<Scalars['String']['output']>;
  total: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
}

export interface ScaleQuestionAnswer {
  __typename: 'ScaleQuestionAnswer';
  aspectAnswers?: Maybe<Array<AspectAnswer>>;
}

export interface ScaleQuestionResult {
  __typename: 'ScaleQuestionResult';
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isGlobal: Scalars['Boolean']['output'];
  /** It is empty in case number of scale aspects < 1 */
  scaleAspectResults: Array<ScaleAspectResult>;
  /** It is empty in case number of scale aspects >= 1 */
  scaleOptionResultsWithoutScaleAspect: Array<ScaleOptionResult>;
  title: Scalars['String']['output'];
  /** It is null in case number of scale aspects >= 1 */
  totalAnswersWithoutScaleAspect?: Maybe<Scalars['Float']['output']>;
  type: SurveyQuestionEnum;
  updatedAt: Scalars['DateTime']['output'];
}

export interface SchemaDependency {
  __typename: 'SchemaDependency';
  createdAt: Scalars['DateTime']['output'];
  distance: Scalars['String']['output'];
  fromId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  toId: Scalars['ID']['output'];
  type: AppointmentDependencyTypes;
  updatedAt: Scalars['DateTime']['output'];
}

export interface SchemaSchedule {
  __typename: 'SchemaSchedule';
  appointmentInfo: AppointmentInfo;
  appointmentInfoId: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  customDays?: Maybe<Scalars['Float']['output']>;
  dependencies: Array<SchemaDependency>;
  dependents: Array<SchemaDependency>;
  from: SchemaSchedule;
  id: Scalars['ID']['output'];
  position: Scalars['Float']['output'];
  schema: TreatmentSchema;
  schemaId: Scalars['ID']['output'];
  to: SchemaSchedule;
  updatedAt: Scalars['DateTime']['output'];
}

export interface SendManyResults {
  __typename: 'SendManyResults';
  success: Scalars['Boolean']['output'];
  total: Scalars['Float']['output'];
}

export interface ServiceType {
  __typename: 'ServiceType';
  code: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
  special?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['DateTime']['output'];
}

export enum Severity {
  High = 'High',
  Low = 'Low'
}

export interface ShareSchemaInput {
  institutionIds: Array<Scalars['String']['input']>;
  schemaId: Scalars['String']['input'];
  sharedWithUserIds: Array<Scalars['String']['input']>;
}

export interface ShareSurveySchemaInput {
  institutionIds: Array<Scalars['String']['input']>;
  sharedWithUserIds: Array<Scalars['String']['input']>;
  surveySchemaId: Scalars['String']['input'];
}

export interface SimpleTextQuestionAnswer {
  __typename: 'SimpleTextQuestionAnswer';
  text?: Maybe<Scalars['String']['output']>;
}

export interface SimpleTextQuestionResult {
  __typename: 'SimpleTextQuestionResult';
  answers: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isGlobal: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  totalAnswers: Scalars['Float']['output'];
  type: SurveyQuestionEnum;
  updatedAt: Scalars['DateTime']['output'];
}

export interface SortByArgs {
  field: Scalars['String']['input'];
  order?: InputMaybe<SortByOrders>;
}

/** Possible orders for sorting */
export enum SortByOrders {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface StartEndDates {
  __typename: 'StartEndDates';
  end?: Maybe<Scalars['DateTime']['output']>;
  start: Scalars['DateTime']['output'];
}

export interface Subscription {
  __typename: 'Subscription';
  newMessage: Message;
  newNotification: Notification;
}

export interface SurgeryGroup {
  __typename: 'SurgeryGroup';
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: SurgeryType;
}

/** Type of surgery the patient has undergone / will undergo */
export enum SurgeryType {
  InPatient = 'InPatient',
  OutPatient = 'OutPatient'
}

export interface Survey {
  __typename: 'Survey';
  createdAt: Scalars['DateTime']['output'];
  createdByTreatmentSchemaId?: Maybe<Scalars['ID']['output']>;
  doctor: DoctorProfile;
  doctorId?: Maybe<Scalars['ID']['output']>;
  fillableFrom: Scalars['DateTime']['output'];
  fillableUntil?: Maybe<Scalars['DateTime']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  patient?: Maybe<PatientProfile>;
  patientId?: Maybe<Scalars['ID']['output']>;
  recipientProfile: ProfileInterface;
  status: SurveyStatusEnum;
  surveyQuestionAnswers: Array<SurveyQuestionAnswer>;
  surveySchema: SurveySchema;
  surveySchemaId: Scalars['ID']['output'];
  treatmentId?: Maybe<Scalars['ID']['output']>;
  type: SurveyTypeEnum;
  updatedAt: Scalars['DateTime']['output'];
  userId: Scalars['ID']['output'];
}

export interface SurveyBySchemaFilter {
  schemaId: Scalars['String']['input'];
  statuses?: InputMaybe<Array<SurveyDoneStatusEnum>>;
}

/** Possible categories of survey */
export enum SurveyCategoryEnum {
  PREM = 'PREM',
  PROM = 'PROM',
  QualityAssurance = 'QualityAssurance',
  QualityOfLife = 'QualityOfLife',
  RiskAssessment = 'RiskAssessment'
}

/** Different Statuses of the survey */
export enum SurveyDoneStatusEnum {
  EXPIRED = 'EXPIRED',
  FINISHED = 'FINISHED',
  TODO = 'TODO'
}

export interface SurveyFilterForAssistant {
  categories?: InputMaybe<Array<SurveyCategoryEnum>>;
  doctorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  professionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientNameFragments?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SurveyDoneStatusEnum>>;
}

export interface SurveyFilterForDoctor {
  categories?: InputMaybe<Array<SurveyCategoryEnum>>;
  professionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  recipientNameFragments?: InputMaybe<Scalars['String']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SurveyDoneStatusEnum>>;
}

export interface SurveyFilterForPatient {
  categories?: InputMaybe<Array<SurveyCategoryEnum>>;
  statuses?: InputMaybe<Array<SurveyDoneStatusEnum>>;
}

export interface SurveyList {
  __typename: 'SurveyList';
  surveys: Array<Survey>;
  total: Scalars['Float']['output'];
}

export interface SurveyQuestion {
  __typename: 'SurveyQuestion';
  createdAt: Scalars['DateTime']['output'];
  data?: Maybe<QuestionData>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isGlobal: Scalars['Boolean']['output'];
  mcSurveyQuestionChoices: Array<AnswerOption>;
  sclSurveyQuestionAspects: Array<AnswerOption>;
  surveySchemaId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
  type: SurveyQuestionEnum;
  updatedAt: Scalars['DateTime']['output'];
  user: User;
}

export interface SurveyQuestion2SurveySchemaData {
  __typename: 'SurveyQuestion2SurveySchemaData';
  nextSectionInformation: Array<NextSectionInformation>;
}

export interface SurveyQuestion2SurveySchemaDataInput {
  nextSectionInformation: Array<NextSectionInformationInput>;
}

export interface SurveyQuestionAnswer {
  __typename: 'SurveyQuestionAnswer';
  createdAt: Scalars['DateTime']['output'];
  fileUploadQuestionAnswer?: Maybe<FileUploadQuestionAnswer>;
  id: Scalars['ID']['output'];
  mcQuestionAnswer?: Maybe<McQuestionAnswer>;
  scaleQuestionAnswer?: Maybe<ScaleQuestionAnswer>;
  simpleTextQuestionAnswer?: Maybe<SimpleTextQuestionAnswer>;
  surveyId: Scalars['String']['output'];
  surveyQuestion?: Maybe<SurveyQuestion>;
  surveyQuestionId: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

/** Possible types of survey question */
export enum SurveyQuestionEnum {
  FileUpload = 'FileUpload',
  MultipleChoice = 'MultipleChoice',
  Scale = 'Scale',
  SimpleText = 'SimpleText'
}

/** Maximum file size of survey question */
export enum SurveyQuestionFileSize {
  FiveMB = 'FiveMB',
  TenMB = 'TenMB',
  TwentyFourMB = 'TwentyFourMB',
  Unlimited = 'Unlimited'
}

export interface SurveyQuestionFilterInput {
  includeBySurveySchemaId?: InputMaybe<Scalars['String']['input']>;
  isOwn?: InputMaybe<Scalars['Boolean']['input']>;
  questionType?: InputMaybe<Array<SurveyQuestionEnum>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}

export interface SurveyQuestionList {
  __typename: 'SurveyQuestionList';
  surveyQuestions: Array<SurveyQuestion>;
  total: Scalars['Float']['output'];
}

export type SurveyQuestionResult = FileUploadQuestionResult | MultipleChoiceQuestionResult | ScaleQuestionResult | SimpleTextQuestionResult;

export interface SurveyQuestionToSurveySchemaInput {
  data?: InputMaybe<SurveyQuestion2SurveySchemaDataInput>;
  orderInSection: Scalars['Float']['input'];
  questionData?: InputMaybe<CreateSurveyQuestionInput>;
  required: Scalars['Boolean']['input'];
  section: Scalars['Float']['input'];
  sectionName?: InputMaybe<Scalars['String']['input']>;
  surveyQuestionId?: InputMaybe<Scalars['ID']['input']>;
}

/** Valid file type of survey question */
export enum SurveyQuestionValidFileType {
  DOCX = 'DOCX',
  JPG = 'JPG',
  MP4 = 'MP4',
  PDF = 'PDF',
  PNG = 'PNG',
  XLSX = 'XLSX'
}

export interface SurveySchema {
  __typename: 'SurveySchema';
  bnoCodes: Array<BnoCode>;
  canBeDeleted: Scalars['Boolean']['output'];
  categories: Array<SurveyCategoryEnum>;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institutions: Array<Institution>;
  isGlobal: Scalars['Boolean']['output'];
  patientDescription: Scalars['String']['output'];
  professionIds: Array<Scalars['String']['output']>;
  professions: Array<Profession>;
  referenceUrls?: Maybe<Array<SurveySchemaReferenceUrl>>;
  rootSurveySchemaId?: Maybe<Scalars['String']['output']>;
  sharedWithUsers: Array<User>;
  snomedCode?: Maybe<Scalars['String']['output']>;
  status: SurveySchemaStatusEnum;
  surveySchemaQuestions: Array<SurveySchemaQuestion>;
  surveySchemaQuestionsBySameRoot: Array<SurveySchemaQuestion>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  user: User;
  version: Scalars['Float']['output'];
}

export interface SurveySchemaFilter {
  bnoCodeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categories?: InputMaybe<Array<SurveyCategoryEnum>>;
  createdByIds?: InputMaybe<Array<Scalars['String']['input']>>;
  institutionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  isGlobal?: InputMaybe<Scalars['Boolean']['input']>;
  professionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<Array<SurveySchemaStatusEnum>>;
}

export interface SurveySchemaList {
  __typename: 'SurveySchemaList';
  surveySchemas: Array<SurveySchema>;
  total: Scalars['Float']['output'];
}

export interface SurveySchemaQuestion {
  __typename: 'SurveySchemaQuestion';
  data?: Maybe<SurveyQuestion2SurveySchemaData>;
  id: Scalars['ID']['output'];
  orderInSection: Scalars['Float']['output'];
  required: Scalars['Boolean']['output'];
  section: Scalars['Float']['output'];
  sectionName?: Maybe<Scalars['String']['output']>;
  surveyQuestion: SurveyQuestion;
}

export interface SurveySchemaReferenceUrl {
  __typename: 'SurveySchemaReferenceUrl';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

/** Possible statuses of survey schema */
export enum SurveySchemaStatusEnum {
  Active = 'Active',
  Archived = 'Archived',
  InActive = 'InActive'
}

/** Possible statuses of survey */
export enum SurveyStatusEnum {
  Finished = 'Finished',
  InProgress = 'InProgress',
  Untouched = 'Untouched'
}

/** Possible type of survey */
export enum SurveyTypeEnum {
  AdHoc = 'AdHoc',
  Treatment = 'Treatment',
  TreatmentDraft = 'TreatmentDraft'
}

export interface SurveysForPatient {
  patientId: Scalars['String']['input'];
}

export interface Treatment {
  __typename: 'Treatment';
  appointments: Array<Appointment>;
  bnoCodes: Array<BnoCode>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description: MultiLangText;
  doctor: DoctorProfile;
  doctorAppointments?: Maybe<Array<Appointment>>;
  doctorId?: Maybe<Scalars['String']['output']>;
  firstAndLastDates?: Maybe<FirstAndLastDates>;
  id: Scalars['ID']['output'];
  patient: PatientProfile;
  patientId?: Maybe<Scalars['String']['output']>;
  pocId?: Maybe<Scalars['String']['output']>;
  referrals: Array<Referral>;
  status?: Maybe<TreatmentStatus>;
  surveys: Array<Survey>;
  title: MultiLangText;
  treatmentLogs?: Maybe<Array<TreatmentLogDisplay>>;
  updatedAt: Scalars['DateTime']['output'];
}

export interface TreatmentLogDisplay {
  __typename: 'TreatmentLogDisplay';
  date: Scalars['DateTime']['output'];
  diff?: Maybe<Scalars['JSON']['output']>;
  eventJson?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['String']['output'];
  title?: Maybe<MultiLangText>;
  type?: Maybe<TreatmentLogTypeEnum>;
  user?: Maybe<LogUser>;
  userId?: Maybe<Scalars['ID']['output']>;
}

/** Possible types for treatment log */
export enum TreatmentLogTypeEnum {
  TreatmentAppointmentAdded = 'TreatmentAppointmentAdded',
  TreatmentAppointmentDateUpdated = 'TreatmentAppointmentDateUpdated',
  TreatmentAppointmentDeleted = 'TreatmentAppointmentDeleted',
  TreatmentAppointmentDoctorUpdated = 'TreatmentAppointmentDoctorUpdated',
  TreatmentAppointmentFeedbackRating = 'TreatmentAppointmentFeedbackRating',
  TreatmentAppointmentFeedbackText = 'TreatmentAppointmentFeedbackText',
  TreatmentAppointmentGoodToKnowUpdated = 'TreatmentAppointmentGoodToKnowUpdated',
  TreatmentAppointmentLocationUpdated = 'TreatmentAppointmentLocationUpdated',
  TreatmentAppointmentStatusUpdated = 'TreatmentAppointmentStatusUpdated',
  TreatmentClosed = 'TreatmentClosed',
  TreatmentCreated = 'TreatmentCreated',
  TreatmentProtocolAdded = 'TreatmentProtocolAdded',
  TreatmentProtocolDeleted = 'TreatmentProtocolDeleted',
  TreatmentSent = 'TreatmentSent',
  TreatmentUpdated = 'TreatmentUpdated'
}

export interface TreatmentSchema {
  __typename: 'TreatmentSchema';
  appointments: Array<Appointment>;
  bnoCodes: Array<BnoCode>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<MultiLangText>;
  disabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  institutions: Array<Institution>;
  isDeletable: Scalars['Boolean']['output'];
  isGlobal?: Maybe<Scalars['Boolean']['output']>;
  isSecret?: Maybe<Scalars['Boolean']['output']>;
  optimalDuration?: Maybe<Scalars['Float']['output']>;
  professions: Array<Profession>;
  schedules: Array<PlainTreatmentElement>;
  schemaSchedules: Array<SchemaSchedule>;
  sharedWith: Array<User>;
  snowmedCode?: Maybe<Scalars['String']['output']>;
  surveySchemas: Array<TreatmentSchemaToSurvey>;
  title: MultiLangText;
  updatedAt: Scalars['DateTime']['output'];
  url?: Maybe<Scalars['String']['output']>;
  user: User;
  userId: Scalars['ID']['output'];
}

export interface TreatmentSchemaCreateInput {
  description: MultiLangTextInput;
  title: MultiLangTextInput;
  treatmentId?: InputMaybe<Scalars['String']['input']>;
}

export interface TreatmentSchemaFilter {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  bnoCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  isOwn?: InputMaybe<Scalars['Boolean']['input']>;
  professionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}

export interface TreatmentSchemaList {
  __typename: 'TreatmentSchemaList';
  total: Scalars['Float']['output'];
  treatmentSchemas: Array<TreatmentSchema>;
}

export interface TreatmentSchemaToSurvey {
  __typename: 'TreatmentSchemaToSurvey';
  createdAt: Scalars['DateTime']['output'];
  customDays?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  surveySchema: SurveySchema;
  surveySchemaId: Scalars['ID']['output'];
  treatmentSchema: TreatmentSchema;
  treatmentSchemaId: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
}

/** Possible statuses for treatments */
export enum TreatmentStatus {
  Cancelled = 'Cancelled',
  Draft = 'Draft',
  Sent = 'Sent'
}

export interface UnsubscribeSchemaInput {
  schemaId: Scalars['String']['input'];
}

export interface UpdateAppointmentDependencyInput {
  dependencyId: Scalars['String']['input'];
  distance: Scalars['String']['input'];
}

export interface UpdateAppointmentInfoInput {
  appointmentInfoId: Scalars['String']['input'];
  beforeTreatmentNote: Scalars['Boolean']['input'];
  doctorTitle: MultiLangTextInput;
  doctorTodo: MultiLangTextInput;
  goodToKnow: MultiLangTextInput;
  oeno?: InputMaybe<Scalars['String']['input']>;
  patientTitle: MultiLangTextInput;
  professionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  treatmentSchemaId?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateAssistantProfileInput {
  id: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateDependencyInput {
  dependencyId: Scalars['String']['input'];
  dependencyType: AppointmentDependencyTypes;
  distance: Scalars['Float']['input'];
  fromId: Scalars['String']['input'];
  toId: Scalars['String']['input'];
  treatmentSchemaId: Scalars['String']['input'];
  unit: Scalars['String']['input'];
}

export interface UpdateRoomInput {
  address?: InputMaybe<OptionalMultiLangTextInput>;
  description?: InputMaybe<OptionalMultiLangTextInput>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name: MultiLangTextInput;
  neakCode?: InputMaybe<Scalars['String']['input']>;
  roomId: Scalars['String']['input'];
}

export interface UpdateScheduleAppointmentInfoInput {
  beforeTreatmentNote: Scalars['Boolean']['input'];
  doctorTitle: MultiLangTextInput;
  doctorTodo: MultiLangTextInput;
  goodToKnow: MultiLangTextInput;
  oeno?: InputMaybe<Scalars['String']['input']>;
  patientTitle: MultiLangTextInput;
  professionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  treatmentSchemaId?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateSchemaInput {
  bnoCodeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<MultiLangTextInput>;
  id: Scalars['String']['input'];
  optimalDuration?: InputMaybe<Scalars['Float']['input']>;
  professionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  snowmedCode?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<MultiLangTextInput>;
  url?: InputMaybe<Scalars['String']['input']>;
}

export interface UpdateSurveyQuestionInput {
  data?: InputMaybe<QuestionDataInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mcSurveyQuestionChoices?: InputMaybe<Array<AnswerOptionInput>>;
  sclSurveyQuestionAspects?: InputMaybe<Array<AnswerOptionInput>>;
  title: Scalars['String']['input'];
  type: SurveyQuestionEnum;
}

export interface UpdateSurveyQuestionToSurveySchemaInput {
  data?: InputMaybe<SurveyQuestion2SurveySchemaDataInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  orderInSection: Scalars['Float']['input'];
  questionData?: InputMaybe<CreateSurveyQuestionInput>;
  required: Scalars['Boolean']['input'];
  section: Scalars['Float']['input'];
  sectionName?: InputMaybe<Scalars['String']['input']>;
  surveyQuestionId?: InputMaybe<Scalars['ID']['input']>;
}

export interface UpdateSurveySchemaInput {
  bnoCodeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  categories: Array<SurveyCategoryEnum>;
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  patientDescription: Scalars['String']['input'];
  professionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  questions: Array<UpdateSurveyQuestionToSurveySchemaInput>;
  referenceUrls?: InputMaybe<Array<InputSurveySchemaReferenceUrl>>;
  snomedCode?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
}

export interface UpdateTreatmentInput {
  bnoCodeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<MultiLangTextInput>;
  title?: InputMaybe<MultiLangTextInput>;
  treatmentId: Scalars['ID']['input'];
}

export interface User {
  __typename: 'User';
  assistantDoctorIds: Array<Scalars['ID']['output']>;
  assistantProfile?: Maybe<AssistantProfile>;
  createdAt: Scalars['DateTime']['output'];
  doctorProfile?: Maybe<DoctorProfile>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institutionPermissions: Array<InstitutionPermission>;
  invitees: Array<User>;
  inviter?: Maybe<Array<User>>;
  inviterId?: Maybe<Scalars['ID']['output']>;
  isAdmin: Scalars['Boolean']['output'];
  isLockedOut: Scalars['Boolean']['output'];
  language: Language;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  lastPasswordReset?: Maybe<Scalars['DateTime']['output']>;
  notificationSettings: Array<NotificationSettings>;
  notifications: Array<NotificationSettings>;
  patientProfile?: Maybe<PatientProfile>;
  profile: ProfileInterface;
  receivedMessages: Array<Message>;
  sentMessages: Array<Message>;
  updatedAt: Scalars['DateTime']['output'];
  userType: UserType;
}

/** Possible user types */
export enum UserType {
  Admin = 'Admin',
  Assistant = 'Assistant',
  Doctor = 'Doctor',
  Patient = 'Patient'
}

export interface VaccinationGroup {
  __typename: 'VaccinationGroup';
  code: Scalars['String']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface WarningGroup {
  __typename: 'WarningGroup';
  agent?: Maybe<Scalars['String']['output']>;
  cause: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reaction?: Maybe<Scalars['String']['output']>;
  risk?: Maybe<Risk>;
  type: WarningGroupType;
}

export enum WarningGroupType {
  Allergy = 'Allergy',
  Other = 'Other'
}

export type UserLanguageChore = { __typename: 'User', language: Language };

export type createAppointmentVariables = Exact<{
  appointmentInput: AppointmentInput;
}>;


export type createAppointment = { createAppointment: { __typename: 'Appointment', duration: string, id: string, proposedDate: any, eesztBookingId?: string | null, isBetmenBooked: boolean, status: AppointmentStatus, appointmentInfo?: { __typename: 'AppointmentInfo', id: string } | null, institution?: { __typename: 'Institution', id: string, eesztId?: string | null, name: string, addressCounty?: string | null, addressPostalCode?: string | null, addressCity?: string | null, addressAddress?: string | null, concatenatedAddress?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, mapLink?: string | null, neak?: string | null, isActive: boolean, isOwn: boolean, rooms: Array<{ __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null }> } | null, room?: { __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null } | null } };

export type updateAppointmentVariables = Exact<{
  updateInput: AppointmentUpdateInput;
}>;


export type updateAppointment = { updateAppointment: { __typename: 'Appointment', id: string, proposedDate: any, status: AppointmentStatus, institution?: { __typename: 'Institution', id: string } | null, room?: { __typename: 'Room', id: string } | null } | { __typename: 'CalculatedSchedule', schedule: Array<{ __typename: 'PlainTreatmentElement', isModified?: boolean | null, id: string, date: { __typename: 'StartEndDates', end?: any | null, start: any }, oldDate?: { __typename: 'StartEndDates', end?: any | null, start: any } | null, appointmentInfo: { __typename: 'AppointmentInfo', id: string }, doctorTitle?: { __typename: 'MultiLangText', hu: string, en: string } | null }>, brokenDependingFrom: Array<{ __typename: 'AppointmentDependency', id: string, type: AppointmentDependencyTypes, distance: string, from: { __typename: 'Appointment', info?: { __typename: 'AppointmentInfo', doctorTitle: { __typename: 'MultiLangText', hu: string, en: string } } | null } }>, brokenDependants: Array<{ __typename: 'AppointmentDependency', id: string, type: AppointmentDependencyTypes, distance: string, to: { __typename: 'Appointment', info?: { __typename: 'AppointmentInfo', doctorTitle: { __typename: 'MultiLangText', hu: string, en: string } } | null } }> } };

export type UpdateAppointmentWithDepsVariables = Exact<{
  updateInput: AppointmentUpdateInput;
  reschedule: Scalars['Boolean']['input'];
}>;


export type UpdateAppointmentWithDeps = { updateAppointmentWithDeps: { __typename: 'Appointment', createdAt: any } };

export type updateAppointmentGoodToKnowVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  updateGoodToKnowInput: AppointmentUpdateGoodToKnowInput;
}>;


export type updateAppointmentGoodToKnow = { updateAppointmentGoodToKnow: { __typename: 'Appointment', id: string } };

export type updateAppointmentOenoVariables = Exact<{
  appointmentId: Scalars['String']['input'];
  oeno: Scalars['String']['input'];
}>;


export type updateAppointmentOeno = { updateAppointmentOeno: { __typename: 'Appointment', id: string } };

export type deleteAppointmentVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type deleteAppointment = { deleteAppointment: { __typename: 'Appointment', id: string, eesztBookingId?: string | null } };

export type deleteAppointmentsVariables = Exact<{
  appointmentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type deleteAppointments = { deleteAppointments: Array<{ __typename: 'Appointment', id: string }> };

export type triggerExpirePastAppointmentsVariables = Exact<{ [key: string]: never; }>;


export type triggerExpirePastAppointments = { triggerExpirePastAppointments: Array<{ __typename: 'Appointment', id: string }> };

export type createAppointmentDependencyVariables = Exact<{
  createAppointmentDependencyInput: CreateAppointmentDependencyInput;
}>;


export type createAppointmentDependency = { createAppointmentDependency: { __typename: 'AppointmentDependency', id: string, distance: string, type: AppointmentDependencyTypes, isBroken: boolean, isCustom: boolean, fromId: string, toId: string } };

export type updateAppointmentDependencyVariables = Exact<{
  updateAppointmentDependencyInput: UpdateAppointmentDependencyInput;
}>;


export type updateAppointmentDependency = { updateAppointmentDependency: { __typename: 'AppointmentDependency', id: string, distance: string, type: AppointmentDependencyTypes, isBroken: boolean, isCustom: boolean, fromId: string, toId: string } };

export type deleteAppointmentDependencyVariables = Exact<{
  dependencyId: Scalars['String']['input'];
}>;


export type deleteAppointmentDependency = { deleteAppointmentDependency: { __typename: 'AppointmentDependency', id: string } };

export type listAllAppointmentInfosVariables = Exact<{ [key: string]: never; }>;


export type listAllAppointmentInfos = { listAllAppointmentInfos: Array<{ __typename: 'AppointmentInfo', id: string, doctorTitle: { __typename: 'MultiLangText', hu: string, en: string } }> };

export type listAppointmentInfosVariables = Exact<{
  treatmentSchemaId?: InputMaybe<Scalars['String']['input']>;
}>;


export type listAppointmentInfos = { listAppointmentInfos: Array<{ __typename: 'AppointmentInfo', id: string, oeno?: string | null, userId?: string | null, eesztServiceId?: string | null, beforeTreatmentNote?: boolean | null, patientTitle: { __typename: 'MultiLangText', hu: string, en: string }, doctorTodo: { __typename: 'MultiLangText', hu: string, en: string }, doctorTitle: { __typename: 'MultiLangText', hu: string, en: string }, goodToKnow: { __typename: 'MultiLangText', hu: string, en: string }, professions?: Array<{ __typename: 'Profession', id: string, code: string, name: string }> | null }> };

export type createAppointmentInfoVariables = Exact<{
  createAppointmentInfoInput: CreateAppointmentInfoInput;
}>;


export type createAppointmentInfo = { createAppointmentInfo: { __typename: 'AppointmentInfo', id: string, oeno?: string | null, userId?: string | null, eesztServiceId?: string | null, beforeTreatmentNote?: boolean | null, patientTitle: { __typename: 'MultiLangText', hu: string, en: string }, doctorTodo: { __typename: 'MultiLangText', hu: string, en: string }, doctorTitle: { __typename: 'MultiLangText', hu: string, en: string }, goodToKnow: { __typename: 'MultiLangText', hu: string, en: string }, professions?: Array<{ __typename: 'Profession', id: string, code: string, name: string }> | null } };

export type updateAppointmentInfoVariables = Exact<{
  appointmentInfoInput: UpdateAppointmentInfoInput;
}>;


export type updateAppointmentInfo = { updateAppointmentInfo: { __typename: 'AppointmentInfo', id: string, oeno?: string | null, userId?: string | null, eesztServiceId?: string | null, beforeTreatmentNote?: boolean | null, patientTitle: { __typename: 'MultiLangText', hu: string, en: string }, doctorTodo: { __typename: 'MultiLangText', hu: string, en: string }, doctorTitle: { __typename: 'MultiLangText', hu: string, en: string }, goodToKnow: { __typename: 'MultiLangText', hu: string, en: string }, professions?: Array<{ __typename: 'Profession', id: string, code: string, name: string }> | null } };

export type updateScheduleAppointmentInfoVariables = Exact<{
  scheduleId: Scalars['String']['input'];
  appointmentInfoInput: UpdateScheduleAppointmentInfoInput;
}>;


export type updateScheduleAppointmentInfo = { updateScheduleAppointmentInfo: { __typename: 'AppointmentInfo', id: string, oeno?: string | null, userId?: string | null, eesztServiceId?: string | null, beforeTreatmentNote?: boolean | null, patientTitle: { __typename: 'MultiLangText', hu: string, en: string }, doctorTodo: { __typename: 'MultiLangText', hu: string, en: string }, doctorTitle: { __typename: 'MultiLangText', hu: string, en: string }, goodToKnow: { __typename: 'MultiLangText', hu: string, en: string }, professions?: Array<{ __typename: 'Profession', id: string, code: string, name: string }> | null } };

export type deleteAppointmentInfoVariables = Exact<{
  appointmentInfoInput: DeleteAppointmentInfoInput;
}>;


export type deleteAppointmentInfo = { deleteAppointmentInfo: { __typename: 'AppointmentInfo', id: string, oeno?: string | null, userId?: string | null, eesztServiceId?: string | null, beforeTreatmentNote?: boolean | null, patientTitle: { __typename: 'MultiLangText', hu: string, en: string }, doctorTodo: { __typename: 'MultiLangText', hu: string, en: string }, doctorTitle: { __typename: 'MultiLangText', hu: string, en: string }, goodToKnow: { __typename: 'MultiLangText', hu: string, en: string }, professions?: Array<{ __typename: 'Profession', id: string, code: string, name: string }> | null } };

export type getAppointmentIcsVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type getAppointmentIcs = { getAppointment: { __typename: 'Appointment', id: string, ics?: string | null } };

export type getPatientAppointmentVariables = Exact<{
  appointmentId: Scalars['String']['input'];
}>;


export type getPatientAppointment = { getAppointment: { __typename: 'Appointment', id: string, proposedDate: any, status: AppointmentStatus, ratingStars?: number | null, ratingText?: string | null, updatedAt: any, timeFrom?: string | null, timeTo?: string | null, isBetmenBooked: boolean, eesztBookingId?: string | null, info?: { __typename: 'AppointmentInfo', patientTitle: { __typename: 'MultiLangText', hu: string, en: string }, goodToKnow: { __typename: 'MultiLangText', hu: string, en: string } } | null, institution?: { __typename: 'Institution', id: string, eesztId?: string | null, name: string, addressCounty?: string | null, addressPostalCode?: string | null, addressCity?: string | null, addressAddress?: string | null, concatenatedAddress?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, mapLink?: string | null, neak?: string | null, isActive: boolean, isOwn: boolean, rooms: Array<{ __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null }> } | null, room?: { __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null } | null, treatmentSchema?: { __typename: 'TreatmentSchema', title: { __typename: 'MultiLangText', hu: string, en: string }, description?: { __typename: 'MultiLangText', hu: string, en: string } | null } | null, treatment: { __typename: 'Treatment', id: string, status?: TreatmentStatus | null, firstAndLastDates?: { __typename: 'FirstAndLastDates', firstAppointmentDate?: any | null, lastAppointmentDate?: any | null } | null, description: { __typename: 'MultiLangText', hu: string, en: string }, title: { __typename: 'MultiLangText', hu: string, en: string }, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string } }, doctorProfile: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, phone?: string | null, user?: { __typename: 'User', email: string, id: string } | null, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> } } };

export type getAssistantPatientsVariables = Exact<{ [key: string]: never; }>;


export type getAssistantPatients = { getAssistantProfile: { __typename: 'AssistantProfile', id: string, ownPatients: Array<{ __typename: 'DoctorOwnPatients', id: string, closedAt?: any | null, createdAt: any, patient?: { __typename: 'PatientProfile', id: string, birthDate: any, weight?: number | null, height?: number | null, isDeletableForDoctor: boolean, firstName: string, lastName: string, title: string, tajNumber: string, phone: string, user?: { __typename: 'User', id: string, email: string } | null } | null }> } };

export type getAssistantDoctorsVariables = Exact<{ [key: string]: never; }>;


export type getAssistantDoctors = { getAssistantProfile: { __typename: 'AssistantProfile', id: string, ownDoctors?: Array<{ __typename: 'DoctorOwnAssistants', id: string, closedAt?: any | null, createdAt: any, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string } }> | null } };

export type updateAssistantProfileVariables = Exact<{
  updateAssistantInput: UpdateAssistantProfileInput;
}>;


export type updateAssistantProfile = { updateAssistantProfile: { __typename: 'AssistantProfile', id: string, title: string, phone?: string | null } };

export type getAssistantProfilesForDoctorVariables = Exact<{
  paginationInput?: InputMaybe<PaginationInput>;
  filter?: InputMaybe<AssistantProfileFilter>;
}>;


export type getAssistantProfilesForDoctor = { getAssistantProfiles: { __typename: 'AssistantProfileList', total: number, profiles: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, user: { __typename: 'User', id: string }, ownPatients: Array<{ __typename: 'DoctorOwnPatients', id: string, patient?: { __typename: 'PatientProfile', id: string, firstName: string, lastName: string, tajNumber: string, birthDate: any, doctors: Array<{ __typename: 'DoctorProfile', id: string }> } | null }> }> } };

export type bnoCodesVariables = Exact<{
  searchTerm?: InputMaybe<Scalars['String']['input']>;
}>;


export type bnoCodes = { bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> };

export type getLocationByPostalCodeVariables = Exact<{
  postalCode: Scalars['String']['input'];
}>;


export type getLocationByPostalCode = { getLocationByPostalCode: Array<string> };

export type getCitiesVariables = Exact<{ [key: string]: never; }>;


export type getCities = { getLocations: Array<string> };

export type getDashboardAppointmentsVariables = Exact<{
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getDashboardAppointments = { getDashboardAppointments: { __typename: 'AppointmentList', total: number, appointments: Array<{ __typename: 'Appointment', id: string, status: AppointmentStatus, isBetmenBooked: boolean, eesztBookingId?: string | null, proposedDate: any, room?: { __typename: 'Room', id: string } | null, info?: { __typename: 'AppointmentInfo', id: string, doctorTitle: { __typename: 'MultiLangText', hu: string, en: string } } | null, doctorProfile: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string }, treatment: { __typename: 'Treatment', id: string, status?: TreatmentStatus | null, title: { __typename: 'MultiLangText', hu: string, en: string }, patient: { __typename: 'PatientProfile', id: string, firstName: string, lastName: string, title: string, tajNumber: string, phone: string } } }> } };

export type getReceivedSurveysForDoctorVariables = Exact<{
  filterData: SurveyFilterForDoctor;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getReceivedSurveysForDoctor = { getReceivedSurveysForDoctor: { __typename: 'SurveyList', total: number, surveys: Array<{ __typename: 'Survey', id: string, status: SurveyStatusEnum, fillableFrom: any, fillableUntil?: any | null, finishedAt?: any | null, surveySchema: { __typename: 'SurveySchema', id: string, title: string, categories: Array<SurveyCategoryEnum> }, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, recipientProfile: { __typename: 'AdminProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'AssistantProfile', title: string, firstName: string, lastName: string, extraInfo: string, user: { __typename: 'User', userType: UserType, id: string } } | { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'PatientProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } }> } };

export type getSentSurveysForDoctorVariables = Exact<{
  filterData: SurveyFilterForDoctor;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getSentSurveysForDoctor = { getSentSurveysForDoctor: { __typename: 'SurveyList', total: number, surveys: Array<{ __typename: 'Survey', id: string, status: SurveyStatusEnum, fillableFrom: any, fillableUntil?: any | null, finishedAt?: any | null, surveySchema: { __typename: 'SurveySchema', id: string, title: string, categories: Array<SurveyCategoryEnum> }, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, recipientProfile: { __typename: 'AdminProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'AssistantProfile', title: string, firstName: string, lastName: string, extraInfo: string, user: { __typename: 'User', userType: UserType, id: string } } | { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'PatientProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } }> } };

export type getReceivedSurveysForAssistantVariables = Exact<{
  filterData: SurveyFilterForAssistant;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getReceivedSurveysForAssistant = { getReceivedSurveysForAssistant: { __typename: 'SurveyList', total: number, surveys: Array<{ __typename: 'Survey', id: string, status: SurveyStatusEnum, fillableFrom: any, fillableUntil?: any | null, finishedAt?: any | null, surveySchema: { __typename: 'SurveySchema', id: string, title: string, categories: Array<SurveyCategoryEnum> }, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, recipientProfile: { __typename: 'AdminProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'AssistantProfile', title: string, firstName: string, lastName: string, extraInfo: string, user: { __typename: 'User', userType: UserType, id: string } } | { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'PatientProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } }> } };

export type getSentSurveysForAssistantVariables = Exact<{
  filterData: SurveyFilterForAssistant;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getSentSurveysForAssistant = { getSentSurveysForAssistant: { __typename: 'SurveyList', total: number, surveys: Array<{ __typename: 'Survey', id: string, status: SurveyStatusEnum, fillableFrom: any, fillableUntil?: any | null, finishedAt?: any | null, surveySchema: { __typename: 'SurveySchema', id: string, title: string, categories: Array<SurveyCategoryEnum> }, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, recipientProfile: { __typename: 'AdminProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'AssistantProfile', title: string, firstName: string, lastName: string, extraInfo: string, user: { __typename: 'User', userType: UserType, id: string } } | { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'PatientProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } }> } };

export type getDoctorPatientTreatmentsVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type getDoctorPatientTreatments = { getPatientProfile: { __typename: 'PatientProfile', id: string, treatments: Array<{ __typename: 'Treatment', id: string, status?: TreatmentStatus | null, createdAt: any, updatedAt: any, comment?: string | null, firstAndLastDates?: { __typename: 'FirstAndLastDates', firstAppointmentDate?: any | null, lastAppointmentDate?: any | null } | null, doctorAppointments?: Array<{ __typename: 'Appointment', id: string, proposedDate: any }> | null, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, title: { __typename: 'MultiLangText', hu: string, en: string }, description: { __typename: 'MultiLangText', hu: string, en: string }, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> }> } };

export type GetPatientProfileWithEhrVariables = Exact<{
  patientId: Scalars['String']['input'];
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type GetPatientProfileWithEhr = { getPatientProfile: { __typename: 'PatientProfile', id: string, ehrDocumentList: { __typename: 'EESZTEhrDocumentList', total: number, hasDORError: boolean, documents: Array<{ __typename: 'EESZTEhrDocument', EESZTId?: string | null, hospitalDescr: string, documentType: string, documentId: string, timestamp: any, doctor: { __typename: 'EESZTDoctor', firstName: string, lastName: string, stampNo: string } }> } } };

export type findPatientProfileVariables = Exact<{
  tajNumber: Scalars['String']['input'];
}>;


export type findPatientProfile = { findPatientProfile: { __typename: 'PatientProfile', birthDate: any, gender: string, id: string, firstName: string, lastName: string, title: string, tajNumber: string, phone: string } | { __typename: 'PatientProfileNotFoundError', message: string } };

export type invitePatientVariables = Exact<{
  createPatientArgs: CreatePatientProfileData;
  doctorUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type invitePatient = { invitePatient: { __typename: 'PatientProfile', id: string, birthDate: any, firstName: string, lastName: string, title: string, tajNumber: string, phone: string, user?: { __typename: 'User', id: string, email: string } | null } };

export type inviteExistingPatientVariables = Exact<{
  patientId: Scalars['String']['input'];
  doctorUserIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type inviteExistingPatient = { inviteExistingPatient: Array<{ __typename: 'DoctorOwnPatients', id: string, patient?: { __typename: 'PatientProfile', id: string, birthDate: any, firstName: string, lastName: string, title: string, tajNumber: string, phone: string, user?: { __typename: 'User', id: string, email: string } | null } | null }> };

export type getDoctorPatientSurveysVariables = Exact<{
  patient: SurveysForPatient;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getDoctorPatientSurveys = { getSurveysForPatient: { __typename: 'SurveyList', total: number, surveys: Array<{ __typename: 'Survey', id: string, status: SurveyStatusEnum, fillableFrom: any, fillableUntil?: any | null, finishedAt?: any | null, surveySchema: { __typename: 'SurveySchema', id: string, title: string, categories: Array<SurveyCategoryEnum> }, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, recipientProfile: { __typename: 'AdminProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'AssistantProfile', title: string, firstName: string, lastName: string, extraInfo: string, user: { __typename: 'User', userType: UserType, id: string } } | { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'PatientProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } }> } };

export type getDoctorProfileVariables = Exact<{
  doctorProfileId: Scalars['String']['input'];
}>;


export type getDoctorProfile = { getDoctorProfile: { __typename: 'DoctorProfile', id: string, phone?: string | null, firstName: string, lastName: string, title: string, user?: { __typename: 'User', email: string } | null, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }> } };

export type getDoctorProfilesForPatientsVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type getDoctorProfilesForPatients = { getDoctorProfilesForPatients: Array<{ __typename: 'DoctorProfile', id: string, phone?: string | null, firstName: string, lastName: string, title: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }>, user?: { __typename: 'User', id: string, email: string } | null, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> }> };

export type getDoctorProfilesForAssistantVariables = Exact<{
  assistantId: Scalars['ID']['input'];
}>;


export type getDoctorProfilesForAssistant = { getDoctorProfilesForAssistant: Array<{ __typename: 'DoctorProfile', id: string, phone?: string | null, firstName: string, lastName: string, title: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }>, user?: { __typename: 'User', id: string, email: string } | null, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> }> };

export type getDoctorInvitesVariables = Exact<{
  doctorProfileId: Scalars['String']['input'];
}>;


export type getDoctorInvites = { getDoctorProfile: { __typename: 'DoctorProfile', invitations: { __typename: 'Invitations', doctors?: Array<{ __typename: 'User', id: string, email: string, lastLogin?: any | null, createdAt: any, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }> | null } } };

export type getDoctorOwnPatientsVariables = Exact<{
  doctorProfileId: Scalars['String']['input'];
  isActivePatient?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type getDoctorOwnPatients = { getDoctorProfile: { __typename: 'DoctorProfile', id: string, ownPatients: Array<{ __typename: 'DoctorOwnPatients', id: string, closedAt?: any | null, createdAt: any, patient?: { __typename: 'PatientProfile', id: string, birthDate: any, weight?: number | null, height?: number | null, isDeletableForDoctor: boolean, firstName: string, lastName: string, title: string, tajNumber: string, phone: string, user?: { __typename: 'User', id: string, email: string } | null } | null }> } };

export type getDoctorProfilesVariables = Exact<{
  paginationInput: PaginationInput;
  filterInput: DoctorProfileFilter;
}>;


export type getDoctorProfiles = { getDoctorProfiles: { __typename: 'DoctorProfileList', total: number, profiles: Array<{ __typename: 'DoctorProfile', id: string, firstName: string, lastName: string, title: string, ownPatients: Array<{ __typename: 'DoctorOwnPatients', id: string }>, treatments?: Array<{ __typename: 'Treatment', createdAt: any, id: string, appointments: Array<{ __typename: 'Appointment', proposedDate: any, id: string }> }> | null }> } };

export type getDoctorProfilesForDoctorVariables = Exact<{
  paginationInput: PaginationInput;
  filterInput: DoctorProfileFilter;
}>;


export type getDoctorProfilesForDoctor = { getDoctorProfiles: { __typename: 'DoctorProfileList', total: number, profiles: Array<{ __typename: 'DoctorProfile', id: string, firstName: string, lastName: string, title: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, user?: { __typename: 'User', id: string } | null, ownPatients: Array<{ __typename: 'DoctorOwnPatients', id: string, patient?: { __typename: 'PatientProfile', id: string, firstName: string, lastName: string, tajNumber: string, birthDate: any, doctors: Array<{ __typename: 'DoctorProfile', id: string }> } | null }> }> } };

export type updateDoctorProfileVariables = Exact<{
  doctorProfileId: Scalars['String']['input'];
  updateDoctorInput: EditAbleDoctorData;
}>;


export type updateDoctorProfile = { updateDoctorProfile: { __typename: 'DoctorProfile', id: string, phone?: string | null, title: string, hasEESZTToken: boolean, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }> } };

export type listAllProfessionsVariables = Exact<{ [key: string]: never; }>;


export type listAllProfessions = { listAllProfessions: Array<{ __typename: 'Profession', id: string, code: string, name: string }> };

export type inviteDoctorVariables = Exact<{
  createDoctorArgs: CreateDoctorProfileData;
}>;


export type inviteDoctor = { inviteDoctor: { __typename: 'DoctorProfile', id: string } };

export type listAllDoctorsVariables = Exact<{
  doctorListFilterData?: InputMaybe<DoctorProfileFilter>;
}>;


export type listAllDoctors = { listAllDoctors: Array<{ __typename: 'DoctorProfile', id: string, firstName: string, lastName: string, title: string, stampNumber: string, userId: string }> };

export type hasEESZTTokenVariables = Exact<{
  doctorProfileId: Scalars['String']['input'];
}>;


export type hasEESZTToken = { getDoctorProfile: { __typename: 'DoctorProfile', id: string, hasEESZTToken: boolean } };

export type generateFileDocumentsVariables = Exact<{
  documentIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type generateFileDocuments = { downloadDocuments: Array<{ __typename: 'FileDocument', base64EncodedFile: string, document: { __typename: 'Document', id: string, type: DocumentTypeEnum, originalFileName: string } }> };

export type EesztStsLoginVariables = Exact<{
  stsLoginInput: EESZTStsLoginInput;
  institutionId: Scalars['String']['input'];
  institutionUnitId: Scalars['String']['input'];
}>;


export type EesztStsLogin = { EesztStsLogin: { __typename: 'EESZTLoginResponse', success: boolean, expires: any } };

export type EesztMobileTokenLoginVariables = Exact<{
  mobileToken: Scalars['String']['input'];
  institutionId: Scalars['String']['input'];
  institutionUnitId: Scalars['String']['input'];
}>;


export type EesztMobileTokenLogin = { EesztMobileTokenLogin: { __typename: 'EESZTLoginResponse', success: boolean, expires: any } };

export type getEszigIdNoSamlVariables = Exact<{ [key: string]: never; }>;


export type getEszigIdNoSaml = { getEszigIdNoSaml: string };

export type EesztESZIGLoginVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type EesztESZIGLogin = { EesztESZIGLogin: { __typename: 'EESZTLoginResponse', success: boolean, expires: any } };

export type EesztLogoutVariables = Exact<{ [key: string]: never; }>;


export type EesztLogout = { EesztLogout: { __typename: 'EESZTLogoutResponse', success: boolean } };

export type getFreeSlotsByInstitutionVariables = Exact<{
  institutionId: Scalars['String']['input'];
  institutionUnitId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
  startDate: Scalars['DateTime']['input'];
  endDate: Scalars['DateTime']['input'];
}>;


export type getFreeSlotsByInstitution = { getFreeSlotsByInstitution: Array<{ __typename: 'EESZTSlot', date: string, startTime: string, endTime: string, institutionData: { __typename: 'IdentificationData', id: string, name: string }, organizationData: { __typename: 'IdentificationData', id: string, name: string }, consultationData: { __typename: 'ConsultationData', id: string, name: string, description: string, type: string, maxPatient: string } }> };

export type EesztFeedVariables = Exact<{ [key: string]: never; }>;


export type EesztFeed = { EesztFeed: { __typename: 'EESZTRssFeed', title: string, description: string, items: Array<{ __typename: 'EESZTRssFeedItem', title: string, description: string, link: string, guid: string, pubDate: string }> } };

export type EesztTorSyncStateQueryVariables = Exact<{ [key: string]: never; }>;


export type EesztTorSyncStateQuery = { eesztTorSyncState: { __typename: 'EesztTorSyncState', synchronizationInProgress: boolean, lastSyncEndDate?: any | null, lastSyncSuccessful?: boolean | null } };

export type synchronizeEesztTorDataVariables = Exact<{ [key: string]: never; }>;


export type synchronizeEesztTorData = { synchronizeEesztTorData: boolean };

export type multiLangText = { __typename: 'MultiLangText', hu: string, en: string };

export type optionalMultiLangText = { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null };

export type professionChore = { __typename: 'Profession', id: string, code: string, name: string };

export type roomChore = { __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null };

export type institutionChore = { __typename: 'Institution', id: string, eesztId?: string | null, name: string, addressCounty?: string | null, addressPostalCode?: string | null, addressCity?: string | null, addressAddress?: string | null, concatenatedAddress?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, mapLink?: string | null, neak?: string | null, isActive: boolean, isOwn: boolean, rooms: Array<{ __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null }> };

export type appointmentChore = { __typename: 'Appointment', id: string, proposedDate: any, eesztBookingId?: string | null, isBetmenBooked: boolean, status: AppointmentStatus, appointmentInfo?: { __typename: 'AppointmentInfo', id: string } | null, institution?: { __typename: 'Institution', id: string, eesztId?: string | null, name: string, addressCounty?: string | null, addressPostalCode?: string | null, addressCity?: string | null, addressAddress?: string | null, concatenatedAddress?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, mapLink?: string | null, neak?: string | null, isActive: boolean, isOwn: boolean, rooms: Array<{ __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null }> } | null, room?: { __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null } | null };

export type surveyChore = { __typename: 'Survey', id: string, fillableFrom: any, fillableUntil?: any | null, surveySchema: { __typename: 'SurveySchema', id: string, title: string, description: string, categories: Array<SurveyCategoryEnum>, isGlobal: boolean, status: SurveySchemaStatusEnum, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }> } };

export type BnoCodeChore = { __typename: 'BnoCode', id: string, code: string, title: string };

export type treatmentSchemaChore = { __typename: 'TreatmentSchema', id: string, disabled: boolean, url?: string | null, snowmedCode?: string | null, title: { __typename: 'MultiLangText', hu: string, en: string }, description?: { __typename: 'MultiLangText', hu: string, en: string } | null, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> };

export type treatmentChore = { __typename: 'Treatment', id: string, status?: TreatmentStatus | null, createdAt: any, updatedAt: any, comment?: string | null, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, title: { __typename: 'MultiLangText', hu: string, en: string }, description: { __typename: 'MultiLangText', hu: string, en: string }, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> };

export type patientChore = { __typename: 'PatientProfile', id: string, firstName: string, lastName: string, title: string, tajNumber: string, phone: string };

export type patientProfileChore = { __typename: 'PatientProfile', birthDate: any, addressCity?: string | null, addressPostalCode?: string | null, addressStreet?: string | null, motherFirstName: string, motherLastName: string, birthPlace: string, id: string, firstName: string, lastName: string, title: string, tajNumber: string, phone: string };

export type contactChore = { __typename: 'PatientContact', id: string, firstName?: string | null, lastName?: string | null, phone?: string | null };

export type notificationSettings = { __typename: 'NotificationSettings', id: string, allowEmailSending: boolean, allowSmsSending: boolean, type: NotificationTypes };

export type notification = { __typename: 'Notification', id: string, type: NotificationTypes, data?: any | null, isRead: boolean, createdAt: any, sentAt?: any | null };

export type institutionToDoctor = { __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } };

export type institutionToDoctorChore = { __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } };

export type userChore = { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null };

type profileChore_AdminProfile = { __typename: 'AdminProfile', id: string, title: string, firstName: string, lastName: string, user?: { __typename: 'User', id: string } | null };

type profileChore_AssistantProfile = { __typename: 'AssistantProfile', id: string, title: string, firstName: string, lastName: string, user: { __typename: 'User', id: string } };

type profileChore_DoctorProfile = { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, user?: { __typename: 'User', id: string } | null };

type profileChore_PatientProfile = { __typename: 'PatientProfile', id: string, title: string, firstName: string, lastName: string, user?: { __typename: 'User', id: string } | null };

export type profileChore = profileChore_AdminProfile | profileChore_AssistantProfile | profileChore_DoctorProfile | profileChore_PatientProfile;

export type assistantProfileChore = { __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } };

export type doctorProfileForList = { __typename: 'DoctorProfile', id: string, firstName: string, lastName: string, title: string, stampNumber: string, userId: string };

export type doctorProfileMinimalForPatients = { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, phone?: string | null, user?: { __typename: 'User', email: string, id: string } | null, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> };

export type doctorProfileForPatients = { __typename: 'DoctorProfile', id: string, phone?: string | null, firstName: string, lastName: string, title: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }>, user?: { __typename: 'User', id: string, email: string } | null, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> };

export type appointmentInfoChore = { __typename: 'AppointmentInfo', id: string, oeno?: string | null, userId?: string | null, eesztServiceId?: string | null, beforeTreatmentNote?: boolean | null, patientTitle: { __typename: 'MultiLangText', hu: string, en: string }, doctorTodo: { __typename: 'MultiLangText', hu: string, en: string }, doctorTitle: { __typename: 'MultiLangText', hu: string, en: string }, goodToKnow: { __typename: 'MultiLangText', hu: string, en: string }, professions?: Array<{ __typename: 'Profession', id: string, code: string, name: string }> | null };

export type treatmentOptionsChore = { __typename: 'TreatmentSchema', id: string, disabled: boolean, url?: string | null, snowmedCode?: string | null, isGlobal?: boolean | null, optimalDuration?: number | null, description?: { __typename: 'MultiLangText', hu: string, en: string } | null, title: { __typename: 'MultiLangText', hu: string, en: string }, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutions: Array<{ __typename: 'Institution', id: string, name: string }>, user: { __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }, sharedWith: Array<{ __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }>, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> };

export type doctorProfileChore = { __typename: 'DoctorProfile', id: string, phone?: string | null, title: string, firstName: string, lastName: string, stampNumber: string, userId: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, user?: { __typename: 'User', id: string, email: string } | null, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }>, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> };

export type dependencyChore = { __typename: 'AppointmentDependency', id: string, distance: string, type: AppointmentDependencyTypes, isBroken: boolean, isCustom: boolean, fromId: string, toId: string };

export type surveyQuestionChore = { __typename: 'SurveyQuestion', id: string, title: string, description?: string | null, type: SurveyQuestionEnum, surveySchemaId?: string | null, isGlobal: boolean, data?: { __typename: 'QuestionData', multipleChoice?: boolean | null, scaleData?: { __typename: 'ScaleData', options: Array<{ __typename: 'ScaleOption', value: number, label?: string | null }> } | null, fileUploadData?: { __typename: 'FileUploadData', maxItemsCount: number, maxFileSize: SurveyQuestionFileSize, validFileTypes: Array<SurveyQuestionValidFileType> } | null } | null, mcSurveyQuestionChoices: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }>, sclSurveyQuestionAspects: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }> };

export type surveySchemaQuestionChore = { __typename: 'SurveySchemaQuestion', id: string, required: boolean, orderInSection: number, section: number, sectionName?: string | null, data?: { __typename: 'SurveyQuestion2SurveySchemaData', nextSectionInformation: Array<{ __typename: 'NextSectionInformation', choiceId: string, choiceIndex: number, nextSectionOrder: number }> } | null, surveyQuestion: { __typename: 'SurveyQuestion', id: string, title: string, description?: string | null, type: SurveyQuestionEnum, surveySchemaId?: string | null, isGlobal: boolean, data?: { __typename: 'QuestionData', multipleChoice?: boolean | null, scaleData?: { __typename: 'ScaleData', options: Array<{ __typename: 'ScaleOption', value: number, label?: string | null }> } | null, fileUploadData?: { __typename: 'FileUploadData', maxItemsCount: number, maxFileSize: SurveyQuestionFileSize, validFileTypes: Array<SurveyQuestionValidFileType> } | null } | null, mcSurveyQuestionChoices: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }>, sclSurveyQuestionAspects: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }> } };

export type surveySchemaChore = { __typename: 'SurveySchema', id: string, title: string, description: string, patientDescription: string, categories: Array<SurveyCategoryEnum>, isGlobal: boolean, status: SurveySchemaStatusEnum, canBeDeleted: boolean, snomedCode?: string | null, referenceUrls?: Array<{ __typename: 'SurveySchemaReferenceUrl', name: string, url: string }> | null, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }>, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutions: Array<{ __typename: 'Institution', id: string, name: string }>, sharedWithUsers: Array<{ __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, userId: string } | null }> };

export type surveyAnswerChore = { __typename: 'SurveyQuestionAnswer', mcQuestionAnswer?: { __typename: 'McQuestionAnswer', selectedChoiceIds?: Array<string> | null } | null, scaleQuestionAnswer?: { __typename: 'ScaleQuestionAnswer', aspectAnswers?: Array<{ __typename: 'AspectAnswer', aspectId: string, scaleValue: number }> | null } | null, simpleTextQuestionAnswer?: { __typename: 'SimpleTextQuestionAnswer', text?: string | null } | null, fileUploadQuestionAnswer?: { __typename: 'FileUploadQuestionAnswer', documents?: Array<{ __typename: 'DocumentAnswer', documentId: string, fileName: string }> | null } | null };

export type surveyItemDetails = { __typename: 'Survey', id: string, status: SurveyStatusEnum, fillableFrom: any, fillableUntil?: any | null, finishedAt?: any | null, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, recipientProfile: { __typename: 'AdminProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'AssistantProfile', title: string, firstName: string, lastName: string, extraInfo: string, user: { __typename: 'User', userType: UserType, id: string } } | { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'PatientProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } };

export type surveyListItem = { __typename: 'Survey', id: string, status: SurveyStatusEnum, fillableFrom: any, fillableUntil?: any | null, finishedAt?: any | null, surveySchema: { __typename: 'SurveySchema', id: string, title: string, categories: Array<SurveyCategoryEnum> }, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, recipientProfile: { __typename: 'AdminProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'AssistantProfile', title: string, firstName: string, lastName: string, extraInfo: string, user: { __typename: 'User', userType: UserType, id: string } } | { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'PatientProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } };

export type referralListItem = { __typename: 'Referral', id: string, name: string, status: ReferralStatus, expirationDate: any, isDeletable: boolean, doctor: { __typename: 'DoctorProfile', id: string, firstName: string, lastName: string, title: string, stampNumber: string, userId: string } };

export type listInstitutionsVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  hasEESZTCertificate?: InputMaybe<Scalars['Boolean']['input']>;
  nameSearchTerm?: InputMaybe<Scalars['String']['input']>;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type listInstitutions = { listInstitutions: { __typename: 'InstitutionList', total: number, institutions: Array<{ __typename: 'Institution', id: string, eesztId?: string | null, name: string, addressCounty?: string | null, addressPostalCode?: string | null, addressCity?: string | null, addressAddress?: string | null, concatenatedAddress?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, mapLink?: string | null, neak?: string | null, isActive: boolean, isOwn: boolean, rooms: Array<{ __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null }> }> } };

export type createRoomVariables = Exact<{
  createRoomInput: CreateRoomInput;
}>;


export type createRoom = { createRoom: { __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null } };

export type updateRoomVariables = Exact<{
  updateRoomInput: UpdateRoomInput;
}>;


export type updateRoom = { updateRoom: { __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null } };

export type createInstitutionVariables = Exact<{
  institutionInput: InstitutionInput;
}>;


export type createInstitution = { createInstitution: { __typename: 'Institution', id: string, eesztId?: string | null, name: string, addressCounty?: string | null, addressPostalCode?: string | null, addressCity?: string | null, addressAddress?: string | null, concatenatedAddress?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, mapLink?: string | null, neak?: string | null, isActive: boolean, isOwn: boolean, rooms: Array<{ __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null }> } };

export type updateInstitutionVariables = Exact<{
  id: Scalars['String']['input'];
  institutionInput: InstitutionInput;
}>;


export type updateInstitution = { updateInstitution: { __typename: 'Institution', id: string, eesztId?: string | null, name: string, addressCounty?: string | null, addressPostalCode?: string | null, addressCity?: string | null, addressAddress?: string | null, concatenatedAddress?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, mapLink?: string | null, neak?: string | null, isActive: boolean, isOwn: boolean, rooms: Array<{ __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null }> } };

export type assignAdminsToInstitutionVariables = Exact<{
  institutionId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type assignAdminsToInstitution = { assignAdminsToInstitution: { __typename: 'Institution', id: string } };

export type institutionAdminProfilesVariables = Exact<{
  institutionId: Scalars['ID']['input'];
}>;


export type institutionAdminProfiles = { institutionAdminProfiles: Array<{ __typename: 'AdminProfile', id: string, title: string, firstName: string, lastName: string, user?: { __typename: 'User', id: string } | null } | { __typename: 'AssistantProfile', id: string, title: string, firstName: string, lastName: string, user: { __typename: 'User', id: string } } | { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, user?: { __typename: 'User', id: string } | null } | { __typename: 'PatientProfile', id: string, title: string, firstName: string, lastName: string, user?: { __typename: 'User', id: string } | null }> };

export type uploadCertificateVariables = Exact<{
  institutionId: Scalars['String']['input'];
  certificate: Scalars['Upload']['input'];
  passphrase: Scalars['String']['input'];
}>;


export type uploadCertificate = { uploadCertificate: boolean };

export type checkCertificateVariables = Exact<{
  institutionId: Scalars['String']['input'];
}>;


export type checkCertificate = { checkCertificate: boolean };

export type message = { __typename: 'Message', id: string, message: string, createdAt: any, readAt?: any | null, recipientUserId: string, senderUserId: string };

export type getPartnersVariables = Exact<{ [key: string]: never; }>;


export type getPartners = { getPartners: Array<{ __typename: 'MessagePartner', id: string, lastMessageAt?: any | null, user: { __typename: 'User', userType: UserType, id: string, email: string, doctorProfile?: { __typename: 'DoctorProfile', id: string, firstName: string, lastName: string, title: string, phone?: string | null, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }> } | null, patientProfile?: { __typename: 'PatientProfile', id: string, firstName: string, lastName: string, title: string, tajNumber: string, phone: string, birthDate: any } | null, assistantProfile?: { __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, phone?: string | null } | null }, newMessages: Array<{ __typename: 'Message', id: string, message: string, createdAt: any, readAt?: any | null, recipientUserId: string, senderUserId: string }> }> };

export type getPartnerMessagesVariables = Exact<{
  partnerUserId: Scalars['String']['input'];
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getPartnerMessages = { getPartnerMessages: Array<{ __typename: 'Message', id: string, message: string, createdAt: any, readAt?: any | null, recipientUserId: string, senderUserId: string }> };

export type sendMessageVariables = Exact<{
  message: Scalars['String']['input'];
  recipientUserId: Scalars['String']['input'];
}>;


export type sendMessage = { sendMessage: { __typename: 'Message', id: string, message: string, createdAt: any, readAt?: any | null, recipientUserId: string, senderUserId: string } };

export type markMessagesAsReadVariables = Exact<{
  senderUserId?: InputMaybe<Scalars['String']['input']>;
}>;


export type markMessagesAsRead = { markMessagesAsRead: Array<{ __typename: 'Message', id: string, readAt?: any | null }> };

export type newMessageVariables = Exact<{ [key: string]: never; }>;


export type newMessage = { newMessage: { __typename: 'Message', id: string, message: string, createdAt: any, readAt?: any | null, recipientUserId: string, senderUserId: string } };

export type getNotificationsVariables = Exact<{ [key: string]: never; }>;


export type getNotifications = { getNotifications: Array<{ __typename: 'Notification', id: string, type: NotificationTypes, data?: any | null, isRead: boolean, createdAt: any, sentAt?: any | null }> };

export type markNotificationAsReadVariables = Exact<{
  notificationId: Scalars['String']['input'];
}>;


export type markNotificationAsRead = { markNotificationAsRead: { __typename: 'Notification', id: string, type: NotificationTypes, data?: any | null, isRead: boolean, createdAt: any, sentAt?: any | null } };

export type markAllNotificationAsReadVariables = Exact<{ [key: string]: never; }>;


export type markAllNotificationAsRead = { markAllNotificationAsRead: boolean };

export type newNotificationVariables = Exact<{ [key: string]: never; }>;


export type newNotification = { newNotification: { __typename: 'Notification', id: string, type: NotificationTypes, data?: any | null, isRead: boolean, createdAt: any, sentAt?: any | null } };

export type triggerDoctorNextWeekTasksVariables = Exact<{ [key: string]: never; }>;


export type triggerDoctorNextWeekTasks = { triggerDoctorNextWeekTasks: boolean };

export type triggerPatientNextWeekAppointmentsVariables = Exact<{ [key: string]: never; }>;


export type triggerPatientNextWeekAppointments = { triggerPatientNextWeekAppointments: boolean };

export type triggerPatientDailyAppointmentReminderVariables = Exact<{ [key: string]: never; }>;


export type triggerPatientDailyAppointmentReminder = { triggerPatientDailyAppointmentReminder: boolean };

export type getNotificationSettingsVariables = Exact<{ [key: string]: never; }>;


export type getNotificationSettings = { getNotificationSettings: Array<{ __typename: 'NotificationSettings', id: string, allowEmailSending: boolean, allowSmsSending: boolean, type: NotificationTypes }> };

export type updateNotificationSettingsVariables = Exact<{
  newSettings: NotificationSettingsInput;
}>;


export type updateNotificationSettings = { updateNotificationSettings: { __typename: 'NotificationSettings', id: string, allowEmailSending: boolean, allowSmsSending: boolean, type: NotificationTypes } };

export type getEProfileVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type getEProfile = { getEProfile: { __typename: 'PatientEProfile', patientId: string, warnings: Array<{ __typename: 'WarningGroup', id: string, type: WarningGroupType, cause: string, agent?: string | null, reaction?: string | null, risk?: Risk | null }>, lifestyle: { __typename: 'LifeStyleGroup', lastUpdated?: any | null, alcohol?: string | null, healthHabits?: string | null, smoking?: string | null, toxicImpacts?: string | null, medicationInfo?: string | null, diet?: string | null, typeOfWork?: string | null, exercise?: string | null }, cases: Array<{ __typename: 'CaseGroup', id: string, title: string, createdAt: any, updatedAt?: any | null, status: CaseStatus }>, medications: Array<{ __typename: 'MedicationGroup', id: string, name: string, dosage: string, severity?: Severity | null, doctor: string, date: any, isTakenNow?: boolean | null }>, vaccinations: Array<{ __typename: 'VaccinationGroup', id: string, code: string, name: string, date: any }>, surgeries: Array<{ __typename: 'SurgeryGroup', id: string, name: string, type: SurgeryType, date: any }> } };

export type getPatientProfileVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type getPatientProfile = { getPatientProfile: { __typename: 'PatientProfile', gender: string, bloodType?: BloodType | null, takenMedicines?: Array<string> | null, medicineIntolerance?: Array<string> | null, emailSettings?: any | null, weight?: number | null, height?: number | null, birthDate: any, addressCity?: string | null, addressPostalCode?: string | null, addressStreet?: string | null, motherFirstName: string, motherLastName: string, birthPlace: string, id: string, firstName: string, lastName: string, title: string, tajNumber: string, phone: string, emergencyContacts?: Array<{ __typename: 'PatientContact', id: string, firstName?: string | null, lastName?: string | null, phone?: string | null }> | null, entitleToInfoContacts?: Array<{ __typename: 'PatientContact', id: string, firstName?: string | null, lastName?: string | null, phone?: string | null }> | null } };

export type updatePatientProfileVariables = Exact<{
  updatePatientInput: EditablePatientData;
  patientId: Scalars['String']['input'];
}>;


export type updatePatientProfile = { updatePatientProfile: { __typename: 'PatientProfile', id: string } };

export type getReferralsVariables = Exact<{
  patientId: Scalars['ID']['input'];
  paginationInput?: InputMaybe<PaginationInput>;
  filterData?: InputMaybe<ReferralFilter>;
}>;


export type getReferrals = { getReferrals: { __typename: 'ReferralList', total: number, items: Array<{ __typename: 'Referral', id: string, name: string, status: ReferralStatus, expirationDate: any, isDeletable: boolean, doctor: { __typename: 'DoctorProfile', id: string, firstName: string, lastName: string, title: string, stampNumber: string, userId: string } }> } };

export type getReferralVariables = Exact<{
  referralId: Scalars['ID']['input'];
}>;


export type getReferral = { getReferral: { __typename: 'Referral', logNumber: string, description: string, createdAtDate: any, createdAtPlace: string, id: string, name: string, status: ReferralStatus, expirationDate: any, isDeletable: boolean, patient: { __typename: 'PatientProfile', addressCity?: string | null, addressPostalCode?: string | null, addressStreet?: string | null, birthDate: any, id: string, firstName: string, lastName: string, title: string, tajNumber: string, phone: string }, profession?: { __typename: 'Profession', id: string, code: string, name: string } | null, doctor: { __typename: 'DoctorProfile', id: string, firstName: string, lastName: string, title: string, stampNumber: string, userId: string } } };

export type createReferralVariables = Exact<{
  referralData: CreateReferralInput;
}>;


export type createReferral = { createReferral: { __typename: 'Referral', id: string } };

export type deleteReferralVariables = Exact<{
  referralId: Scalars['String']['input'];
}>;


export type deleteReferral = { deleteReferral: boolean };

export type listProfilesVariables = Exact<{
  types: Array<UserType> | UserType;
}>;


export type listProfiles = { listProfiles: Array<{ __typename: 'AdminProfile', id: string, title: string, firstName: string, lastName: string, user?: { __typename: 'User', id: string } | null } | { __typename: 'AssistantProfile', id: string, title: string, firstName: string, lastName: string, user: { __typename: 'User', id: string } } | { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, user?: { __typename: 'User', id: string } | null } | { __typename: 'PatientProfile', id: string, title: string, firstName: string, lastName: string, user?: { __typename: 'User', id: string } | null }> };

export type getTreatmentVariables = Exact<{
  treatmentId: Scalars['String']['input'];
}>;


export type getTreatment = { getTreatment: { __typename: 'Treatment', pocId?: string | null, id: string, status?: TreatmentStatus | null, createdAt: any, updatedAt: any, comment?: string | null, firstAndLastDates?: { __typename: 'FirstAndLastDates', firstAppointmentDate?: any | null, lastAppointmentDate?: any | null } | null, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, phone?: string | null, stampNumber: string, userId: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, user?: { __typename: 'User', id: string, email: string } | null, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }>, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> }, treatmentLogs?: Array<{ __typename: 'TreatmentLogDisplay', id: string, date: any, type?: TreatmentLogTypeEnum | null, diff?: any | null, title?: { __typename: 'MultiLangText', hu: string, en: string } | null, user?: { __typename: 'LogUser', title?: string | null, firstName: string, lastName: string } | null }> | null, appointments: Array<{ __typename: 'Appointment', createdAt: any, updatedAt: any, ratingText?: string | null, ratingStars?: number | null, status: AppointmentStatus, timeFrom?: string | null, timeTo?: string | null, katId?: string | null, id: string, proposedDate: any, eesztBookingId?: string | null, isBetmenBooked: boolean, eesztBookingTransaction?: { __typename: 'EesztAppointmentBookingTransaction', status?: EesztAppointmentBookingTransactionStatusEnum | null, message?: string | null } | null, treatmentSchema?: { __typename: 'TreatmentSchema', id: string, disabled: boolean, url?: string | null, snowmedCode?: string | null, title: { __typename: 'MultiLangText', hu: string, en: string }, description?: { __typename: 'MultiLangText', hu: string, en: string } | null, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> } | null, doctor: { __typename: 'DoctorProfile', id: string, phone?: string | null, title: string, firstName: string, lastName: string, stampNumber: string, userId: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, user?: { __typename: 'User', id: string, email: string } | null, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }>, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> }, info?: { __typename: 'AppointmentInfo', eesztServiceId?: string | null, beforeTreatmentNote?: boolean | null, oeno?: string | null, goodToKnow: { __typename: 'MultiLangText', hu: string, en: string }, patientTitle: { __typename: 'MultiLangText', hu: string, en: string }, doctorTitle: { __typename: 'MultiLangText', hu: string, en: string }, doctorTodo: { __typename: 'MultiLangText', hu: string, en: string } } | null, dependent: Array<{ __typename: 'AppointmentDependency', id: string, distance: string, type: AppointmentDependencyTypes, isBroken: boolean, isCustom: boolean, fromId: string, toId: string }>, appointmentInfo?: { __typename: 'AppointmentInfo', id: string } | null, institution?: { __typename: 'Institution', id: string, eesztId?: string | null, name: string, addressCounty?: string | null, addressPostalCode?: string | null, addressCity?: string | null, addressAddress?: string | null, concatenatedAddress?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, mapLink?: string | null, neak?: string | null, isActive: boolean, isOwn: boolean, rooms: Array<{ __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null }> } | null, room?: { __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null } | null }>, patient: { __typename: 'PatientProfile', id: string, firstName: string, lastName: string, title: string, tajNumber: string, phone: string, user?: { __typename: 'User', id: string, email: string } | null }, surveys: Array<{ __typename: 'Survey', createdByTreatmentSchemaId?: string | null, id: string, fillableFrom: any, fillableUntil?: any | null, doctor: { __typename: 'DoctorProfile', id: string, phone?: string | null, title: string, firstName: string, lastName: string, stampNumber: string, userId: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, user?: { __typename: 'User', id: string, email: string } | null, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }>, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> }, surveySchema: { __typename: 'SurveySchema', id: string, title: string, description: string, categories: Array<SurveyCategoryEnum>, isGlobal: boolean, status: SurveySchemaStatusEnum, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }> } }>, referrals: Array<{ __typename: 'Referral', description: string, id: string, name: string, status: ReferralStatus, expirationDate: any, isDeletable: boolean, doctor: { __typename: 'DoctorProfile', id: string, firstName: string, lastName: string, title: string, stampNumber: string, userId: string } }>, title: { __typename: 'MultiLangText', hu: string, en: string }, description: { __typename: 'MultiLangText', hu: string, en: string }, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> } };

export type getPatientHomeDataVariables = Exact<{
  patientId: Scalars['String']['input'];
  paginationInput?: InputMaybe<PaginationInput>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  treatmentId?: InputMaybe<Scalars['String']['input']>;
  isPast?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type getPatientHomeData = { getAppointments: { __typename: 'AppointmentList', total: number, appointments: Array<{ __typename: 'Appointment', id: string, proposedDate: any, status: AppointmentStatus, isBetmenBooked: boolean, eesztBookingId?: string | null, info?: { __typename: 'AppointmentInfo', patientTitle: { __typename: 'MultiLangText', hu: string, en: string }, goodToKnow: { __typename: 'MultiLangText', hu: string, en: string } } | null, institution?: { __typename: 'Institution', id: string, eesztId?: string | null, name: string, addressCounty?: string | null, addressPostalCode?: string | null, addressCity?: string | null, addressAddress?: string | null, concatenatedAddress?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, mapLink?: string | null, neak?: string | null, isActive: boolean, isOwn: boolean, rooms: Array<{ __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null }> } | null, room?: { __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null } | null, treatment: { __typename: 'Treatment', id: string, status?: TreatmentStatus | null, description: { __typename: 'MultiLangText', hu: string, en: string }, title: { __typename: 'MultiLangText', hu: string, en: string }, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string } }, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, phone?: string | null, user?: { __typename: 'User', email: string, id: string } | null, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> } }> } };

export type getTreatmentsToPatientDashboardVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type getTreatmentsToPatientDashboard = { getTreatmentsToPatientDashboard: Array<{ __typename: 'Treatment', id: string, status?: TreatmentStatus | null, title: { __typename: 'MultiLangText', hu: string, en: string } }> };

export type getKatEventsVariables = Exact<{
  tajNumber: Scalars['String']['input'];
}>;


export type getKatEvents = { getKatEvents: Array<{ __typename: 'EESZTKatEvent', katId: string, taj: string, eventType: string, status: string, eventStart: string, doctor: string, room: { __typename: 'MultiLangText', hu: string, en: string } }> };

export type getPatientAppointmentsCountVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type getPatientAppointmentsCount = { getPatientProfile: { __typename: 'PatientProfile', treatments: Array<{ __typename: 'Treatment', id: string, appointments: Array<{ __typename: 'Appointment', id: string, proposedDate: any, info?: { __typename: 'AppointmentInfo', patientTitle: { __typename: 'MultiLangText', hu: string, en: string } } | null }> }> } };

export type createTreatmentVariables = Exact<{
  treatmentData: CreateTreatmentInput;
}>;


export type createTreatment = { __typename: 'Mutation', createTreatment: { __typename: 'Treatment', id: string, status?: TreatmentStatus | null, createdAt: any, updatedAt: any, comment?: string | null, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, title: { __typename: 'MultiLangText', hu: string, en: string }, description: { __typename: 'MultiLangText', hu: string, en: string }, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> } };

export type addProtocolVariables = Exact<{
  treatmentData: AddProtocolInput;
}>;


export type addProtocol = { __typename: 'Mutation', addProtocol: { __typename: 'Treatment', id: string, status?: TreatmentStatus | null, createdAt: any, updatedAt: any, comment?: string | null, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, title: { __typename: 'MultiLangText', hu: string, en: string }, description: { __typename: 'MultiLangText', hu: string, en: string }, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> } };

export type updatePocVariables = Exact<{
  pocId: Scalars['String']['input'];
  katId: Scalars['String']['input'];
  appointmentId: Scalars['String']['input'];
}>;


export type updatePoc = { updatePoc: { __typename: 'EESZTPocId', pocId: string } };

export type deleteProtocolVariables = Exact<{
  treatmentData: DeleteProtocolInput;
}>;


export type deleteProtocol = { __typename: 'Mutation', deleteProtocol: { __typename: 'Treatment', pocId?: string | null, id: string, status?: TreatmentStatus | null, createdAt: any, updatedAt: any, comment?: string | null, firstAndLastDates?: { __typename: 'FirstAndLastDates', firstAppointmentDate?: any | null, lastAppointmentDate?: any | null } | null, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, phone?: string | null, stampNumber: string, userId: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, user?: { __typename: 'User', id: string, email: string } | null, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }>, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> }, treatmentLogs?: Array<{ __typename: 'TreatmentLogDisplay', id: string, date: any, type?: TreatmentLogTypeEnum | null, diff?: any | null, title?: { __typename: 'MultiLangText', hu: string, en: string } | null, user?: { __typename: 'LogUser', title?: string | null, firstName: string, lastName: string } | null }> | null, appointments: Array<{ __typename: 'Appointment', createdAt: any, updatedAt: any, ratingText?: string | null, ratingStars?: number | null, status: AppointmentStatus, timeFrom?: string | null, timeTo?: string | null, katId?: string | null, id: string, proposedDate: any, eesztBookingId?: string | null, isBetmenBooked: boolean, eesztBookingTransaction?: { __typename: 'EesztAppointmentBookingTransaction', status?: EesztAppointmentBookingTransactionStatusEnum | null, message?: string | null } | null, treatmentSchema?: { __typename: 'TreatmentSchema', id: string, disabled: boolean, url?: string | null, snowmedCode?: string | null, title: { __typename: 'MultiLangText', hu: string, en: string }, description?: { __typename: 'MultiLangText', hu: string, en: string } | null, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> } | null, doctor: { __typename: 'DoctorProfile', id: string, phone?: string | null, title: string, firstName: string, lastName: string, stampNumber: string, userId: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, user?: { __typename: 'User', id: string, email: string } | null, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }>, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> }, info?: { __typename: 'AppointmentInfo', id: string, eesztServiceId?: string | null, beforeTreatmentNote?: boolean | null, oeno?: string | null, goodToKnow: { __typename: 'MultiLangText', hu: string, en: string }, patientTitle: { __typename: 'MultiLangText', hu: string, en: string }, doctorTitle: { __typename: 'MultiLangText', hu: string, en: string }, doctorTodo: { __typename: 'MultiLangText', hu: string, en: string } } | null, dependent: Array<{ __typename: 'AppointmentDependency', id: string, distance: string, type: AppointmentDependencyTypes, isBroken: boolean, isCustom: boolean, fromId: string, toId: string }>, appointmentInfo?: { __typename: 'AppointmentInfo', id: string } | null, institution?: { __typename: 'Institution', id: string, eesztId?: string | null, name: string, addressCounty?: string | null, addressPostalCode?: string | null, addressCity?: string | null, addressAddress?: string | null, concatenatedAddress?: string | null, phoneNumber?: string | null, email?: string | null, website?: string | null, mapLink?: string | null, neak?: string | null, isActive: boolean, isOwn: boolean, rooms: Array<{ __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null }> } | null, room?: { __typename: 'Room', id: string, eesztUnitId?: string | null, mapLink?: string | null, isActive: boolean, neakCode?: string | null, name: { __typename: 'MultiLangText', hu: string, en: string }, address?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null, description?: { __typename: 'OptionalMultiLangText', hu?: string | null, en?: string | null } | null } | null }>, patient: { __typename: 'PatientProfile', id: string, firstName: string, lastName: string, title: string, tajNumber: string, phone: string, user?: { __typename: 'User', id: string, email: string } | null }, surveys: Array<{ __typename: 'Survey', createdByTreatmentSchemaId?: string | null, id: string, fillableFrom: any, fillableUntil?: any | null, doctor: { __typename: 'DoctorProfile', id: string, phone?: string | null, title: string, firstName: string, lastName: string, stampNumber: string, userId: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, user?: { __typename: 'User', id: string, email: string } | null, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, assistant?: any | null, facebookId?: string | null, phone?: string | null, workingHours?: Array<string> | null, institution: { __typename: 'Institution', id: string, mapLink?: string | null, name: string } }>, assistants: Array<{ __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } }> }, surveySchema: { __typename: 'SurveySchema', id: string, title: string, description: string, categories: Array<SurveyCategoryEnum>, isGlobal: boolean, status: SurveySchemaStatusEnum, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }> } }>, title: { __typename: 'MultiLangText', hu: string, en: string }, description: { __typename: 'MultiLangText', hu: string, en: string }, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> } };

export type sendDraftTreatmentVariables = Exact<{
  treatmentId: Scalars['ID']['input'];
}>;


export type sendDraftTreatment = { sendDraftTreatment: { __typename: 'Treatment', id: string, status?: TreatmentStatus | null } };

export type cancelTreatmentVariables = Exact<{
  treatmentData: CancelTreatmentInput;
}>;


export type cancelTreatment = { cancelTreatment: { __typename: 'Treatment', id: string, status?: TreatmentStatus | null } };

export type updateTreatmentVariables = Exact<{
  treatmentData: UpdateTreatmentInput;
}>;


export type updateTreatment = { updateTreatment: { __typename: 'Treatment', id: string, status?: TreatmentStatus | null, createdAt: any, updatedAt: any, comment?: string | null, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, title: { __typename: 'MultiLangText', hu: string, en: string }, description: { __typename: 'MultiLangText', hu: string, en: string }, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> } };

export type deleteDraftTreatmentVariables = Exact<{
  treatmentData: UpdateTreatmentInput;
}>;


export type deleteDraftTreatment = { deleteDraftTreatment: boolean };

export type triggerExpiringTreatmentRemainderVariables = Exact<{ [key: string]: never; }>;


export type triggerExpiringTreatmentRemainder = { triggerExpiringTreatmentRemainder: boolean };

export type addSurveyToTreatmentVariables = Exact<{
  treatmentId: Scalars['String']['input'];
  surveySchemaId: Scalars['String']['input'];
  patientUserId: Scalars['String']['input'];
  fillableFrom: Scalars['DateTime']['input'];
  fillableUntil: Scalars['DateTime']['input'];
}>;


export type addSurveyToTreatment = { addSurveyToTreatment: { __typename: 'Survey', id: string } };

export type removeSurveyFromTreatmentVariables = Exact<{
  treatmentId: Scalars['String']['input'];
  surveyId: Scalars['String']['input'];
}>;


export type removeSurveyFromTreatment = { removeSurveyFromTreatment: { __typename: 'Survey', id: string } };

export type updateSurveyFillableFromDateVariables = Exact<{
  surveyId: Scalars['String']['input'];
  fillableFromDate: Scalars['DateTime']['input'];
  fillableUntilDate: Scalars['DateTime']['input'];
}>;


export type updateSurveyFillableFromDate = { updateSurveyFillableFromDate: { __typename: 'Survey', id: string } };

export type initiatePasswordResetVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type initiatePasswordReset = { initiatePasswordReset: boolean };

export type setNewPasswordVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type setNewPassword = { setNewPassword: boolean };

export type LoginVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type Login = { login: { __typename: 'LoginResponse', jwtToken?: string | null, isFirstLogin: boolean } };

export type LoginWithTwoFactorTokenVariables = Exact<{
  loginWithTwoFactorTokenInput: LoginWithTwoFactorTokenInput;
}>;


export type LoginWithTwoFactorToken = { loginWithTwoFactorToken: { __typename: 'LoginWithTwoFactorTokenResponse', jwtToken: string } };

export type MeVariables = Exact<{ [key: string]: never; }>;


export type Me = { me: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, isAdmin: boolean, isLockedOut: boolean, assistantDoctorIds: Array<string>, institutionPermissions: Array<{ __typename: 'InstitutionPermission', institutionId: string }>, profile: { __typename: 'AdminProfile', id: string, title: string, firstName: string, lastName: string, phone?: string | null } | { __typename: 'AssistantProfile', id: string, title: string, firstName: string, lastName: string, phone?: string | null } | { __typename: 'DoctorProfile', stampNumber: string, id: string, title: string, firstName: string, lastName: string, phone?: string | null, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', id: string, phone?: string | null, workingHours?: Array<string> | null, facebookId?: string | null, assistant?: any | null, institution: { __typename: 'Institution', id: string, name: string } }>, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }> } | { __typename: 'PatientProfile', id: string, title: string, firstName: string, lastName: string, phone: string } } };

export type ChangeLanguageVariables = Exact<{
  language: Scalars['String']['input'];
}>;


export type ChangeLanguage = { changeLanguage: { __typename: 'User', id: string, language: Language } };

export type invitedDoctor = { __typename: 'User', id: string, email: string, lastLogin?: any | null, createdAt: any, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null };

export type getInvitedDoctorsByAdminVariables = Exact<{ [key: string]: never; }>;


export type getInvitedDoctorsByAdmin = { getInvitedDoctorsByAdmin: Array<{ __typename: 'User', id: string, email: string, lastLogin?: any | null, createdAt: any, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }> };

export type deleteInvitationVariables = Exact<{
  deleteUserId: Scalars['String']['input'];
}>;


export type deleteInvitation = { deleteInvitation: boolean };

export type getDoctorOwnAssistantsVariables = Exact<{ [key: string]: never; }>;


export type getDoctorOwnAssistants = { getDoctorOwnAssistants: Array<{ __typename: 'DoctorOwnAssistants', id: string, closedAt?: any | null, assistant: { __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } } }> };

export type addAssistantToDoctorVariables = Exact<{
  assistantId: Scalars['String']['input'];
}>;


export type addAssistantToDoctor = { addAssistantToDoctor: { __typename: 'DoctorOwnAssistants', id: string, closedAt?: any | null, assistant: { __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } } } };

export type removeAssistantFromDoctorVariables = Exact<{
  assistantId: Scalars['String']['input'];
}>;


export type removeAssistantFromDoctor = { removeAssistantFromDoctor: { __typename: 'DoctorOwnAssistants', id: string, closedAt?: any | null, assistant: { __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } } } };

export type inviteAssistantVariables = Exact<{
  createAssistantArgs: CreateAssistantProfileData;
}>;


export type inviteAssistant = { inviteAssistant: { __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } } };

export type findAssistantProfileVariables = Exact<{
  registrationNumber: Scalars['String']['input'];
}>;


export type findAssistantProfile = { findAssistantProfile: { __typename: 'AssistantProfile', id: string, firstName: string, lastName: string, title: string, registrationNumber: string, gender: string, phone?: string | null, createdAt: any, user: { __typename: 'User', id: string, email: string, userType: UserType, language: Language, lastLogin?: any | null } } | { __typename: 'AssistantProfileNotFoundError', message: string } };

export type getPatientsVariables = Exact<{
  doctorIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  filterData?: InputMaybe<PatientFilter>;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getPatients = { listPatientsForDoctor: { __typename: 'PatientProfileList', total: number, patients: Array<{ __typename: 'DoctorOwnPatients', id: string, closedAt?: any | null, createdAt: any, patient?: { __typename: 'PatientProfile', id: string, birthDate: any, weight?: number | null, height?: number | null, isDeletableForDoctor: boolean, firstName: string, lastName: string, title: string, tajNumber: string, phone: string, user?: { __typename: 'User', id: string, email: string } | null } | null }> } };

export type getDoctorPatientProfileVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type getDoctorPatientProfile = { getPatientProfile: { __typename: 'PatientProfile', gender: string, takenMedicines?: Array<string> | null, medicineIntolerance?: Array<string> | null, emailSettings?: any | null, bloodType?: BloodType | null, bloodTypeAttachmentEESZTId?: string | null, weight?: number | null, height?: number | null, isDeletableForDoctor: boolean, birthDate: any, addressCity?: string | null, addressPostalCode?: string | null, addressStreet?: string | null, motherFirstName: string, motherLastName: string, birthPlace: string, id: string, firstName: string, lastName: string, title: string, tajNumber: string, phone: string, emergencyContacts?: Array<{ __typename: 'PatientContact', id: string, firstName?: string | null, lastName?: string | null, phone?: string | null }> | null, entitleToInfoContacts?: Array<{ __typename: 'PatientContact', id: string, firstName?: string | null, lastName?: string | null, phone?: string | null }> | null, doctors: Array<{ __typename: 'DoctorProfile', id: string, firstName: string, lastName: string, title: string, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }> }>, user?: { __typename: 'User', id: string, email: string } | null } };

export type deleteDoctorsOwnPatientVariables = Exact<{
  patientId: Scalars['String']['input'];
}>;


export type deleteDoctorsOwnPatient = { deleteDoctorsOwnPatient?: { __typename: 'DoctorOwnPatients', id: string, closedAt?: any | null } | null };

export type deleteDoctorsOwnPatientsVariables = Exact<{
  patientIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type deleteDoctorsOwnPatients = { deleteDoctorsOwnPatients?: Array<{ __typename: 'BulkDismissResult', success: boolean, profile: { __typename: 'DoctorOwnPatients', patient?: { __typename: 'PatientProfile', id: string, birthDate: any, firstName: string, lastName: string, title: string, tajNumber: string, phone: string } | null } }> | null };

export type updatePatientsBloodTypeVariables = Exact<{
  patientId: Scalars['String']['input'];
  bloodType: BloodType;
  bloodTypeAttachmentEESZTId?: InputMaybe<Scalars['String']['input']>;
}>;


export type updatePatientsBloodType = { updatePatientsBloodType: { __typename: 'PatientProfile', id: string, bloodType?: BloodType | null, bloodTypeAttachmentEESZTId?: string | null } };

export type sendMessageToPatientsVariables = Exact<{
  recipientUserIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  message: Scalars['String']['input'];
  alsoAsEmail: Scalars['Boolean']['input'];
}>;


export type sendMessageToPatients = { sendMessageToUsers: { __typename: 'SendManyResults', success: boolean, total: number } };

export type getSurveyQuestionsVariables = Exact<{
  filterInput?: InputMaybe<SurveyQuestionFilterInput>;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getSurveyQuestions = { getSurveyQuestions: { __typename: 'SurveyQuestionList', total: number, surveyQuestions: Array<{ __typename: 'SurveyQuestion', isGlobal: boolean, id: string, title: string, description?: string | null, type: SurveyQuestionEnum, surveySchemaId?: string | null, user: { __typename: 'User', id: string }, data?: { __typename: 'QuestionData', multipleChoice?: boolean | null, scaleData?: { __typename: 'ScaleData', options: Array<{ __typename: 'ScaleOption', value: number, label?: string | null }> } | null, fileUploadData?: { __typename: 'FileUploadData', maxItemsCount: number, maxFileSize: SurveyQuestionFileSize, validFileTypes: Array<SurveyQuestionValidFileType> } | null } | null, mcSurveyQuestionChoices: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }>, sclSurveyQuestionAspects: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }> }> } };

export type createSurveyQuestionVariables = Exact<{
  surveyQuestionData: CreateSurveyQuestionInput;
}>;


export type createSurveyQuestion = { createSurveyQuestion: { __typename: 'SurveyQuestion', id: string } };

export type updateSurveyQuestionVariables = Exact<{
  surveyQuestionData: UpdateSurveyQuestionInput;
}>;


export type updateSurveyQuestion = { updateSurveyQuestion: { __typename: 'SurveyQuestion', id: string } };

export type deleteSurveyQuestionVariables = Exact<{
  surveyQuestionId: Scalars['String']['input'];
}>;


export type deleteSurveyQuestion = { deleteSurveyQuestion: { __typename: 'SurveyQuestion', id: string } };

export type getSurveySchemasVariables = Exact<{
  filterData?: InputMaybe<SurveySchemaFilter>;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getSurveySchemas = { getSurveySchemas: { __typename: 'SurveySchemaList', total: number, surveySchemas: Array<{ __typename: 'SurveySchema', id: string, title: string, description: string, patientDescription: string, categories: Array<SurveyCategoryEnum>, isGlobal: boolean, status: SurveySchemaStatusEnum, canBeDeleted: boolean, snomedCode?: string | null, surveySchemaQuestions: Array<{ __typename: 'SurveySchemaQuestion', id: string }>, user: { __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string } | null }, referenceUrls?: Array<{ __typename: 'SurveySchemaReferenceUrl', name: string, url: string }> | null, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }>, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutions: Array<{ __typename: 'Institution', id: string, name: string }>, sharedWithUsers: Array<{ __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, userId: string } | null }> }> } };

export type getSurveySchemaByIdVariables = Exact<{
  surveySchemaId: Scalars['String']['input'];
}>;


export type getSurveySchemaById = { getSurveySchemaById: { __typename: 'SurveySchema', id: string, title: string, description: string, patientDescription: string, categories: Array<SurveyCategoryEnum>, isGlobal: boolean, status: SurveySchemaStatusEnum, canBeDeleted: boolean, snomedCode?: string | null, user: { __typename: 'User', id: string }, surveySchemaQuestions: Array<{ __typename: 'SurveySchemaQuestion', id: string, required: boolean, orderInSection: number, section: number, sectionName?: string | null, data?: { __typename: 'SurveyQuestion2SurveySchemaData', nextSectionInformation: Array<{ __typename: 'NextSectionInformation', choiceId: string, choiceIndex: number, nextSectionOrder: number }> } | null, surveyQuestion: { __typename: 'SurveyQuestion', id: string, title: string, description?: string | null, type: SurveyQuestionEnum, surveySchemaId?: string | null, isGlobal: boolean, data?: { __typename: 'QuestionData', multipleChoice?: boolean | null, scaleData?: { __typename: 'ScaleData', options: Array<{ __typename: 'ScaleOption', value: number, label?: string | null }> } | null, fileUploadData?: { __typename: 'FileUploadData', maxItemsCount: number, maxFileSize: SurveyQuestionFileSize, validFileTypes: Array<SurveyQuestionValidFileType> } | null } | null, mcSurveyQuestionChoices: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }>, sclSurveyQuestionAspects: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }> } }>, referenceUrls?: Array<{ __typename: 'SurveySchemaReferenceUrl', name: string, url: string }> | null, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }>, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutions: Array<{ __typename: 'Institution', id: string, name: string }>, sharedWithUsers: Array<{ __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, userId: string } | null }> } };

export type createSurveySchemaVariables = Exact<{
  surveySchemaData: CreateSurveySchemaInput;
}>;


export type createSurveySchema = { createSurveySchema: { __typename: 'SurveySchema', id: string } };

export type updateSurveySchemaVariables = Exact<{
  surveySchemaData: UpdateSurveySchemaInput;
}>;


export type updateSurveySchema = { updateSurveySchema: { __typename: 'SurveySchema', id: string } };

export type updateSurveySchemaStatusVariables = Exact<{
  surveySchemaId: Scalars['String']['input'];
  status: SurveySchemaStatusEnum;
}>;


export type updateSurveySchemaStatus = { updateSurveySchemaStatus: { __typename: 'SurveySchema', id: string } };

export type deleteSurveySchemaVariables = Exact<{
  surveySchemaId: Scalars['String']['input'];
}>;


export type deleteSurveySchema = { deleteSurveySchema: { __typename: 'SurveySchema', id: string } };

export type sendSurveyToUsersVariables = Exact<{
  surveySchemaId: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  patientId?: InputMaybe<Scalars['String']['input']>;
  fillableFrom?: InputMaybe<Scalars['DateTime']['input']>;
  fillableUntil?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type sendSurveyToUsers = { sendSurveyToUsers: Array<{ __typename: 'Survey', id: string }> };

export type deleteSurveysFromTreatmentVariables = Exact<{
  treatmentId: Scalars['String']['input'];
  surveyIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type deleteSurveysFromTreatment = { deleteSurveysFromTreatment: boolean };

export type shareSurveySchemaVariables = Exact<{
  shareSurveySchemaInput: ShareSurveySchemaInput;
}>;


export type shareSurveySchema = { shareSurveySchema: { __typename: 'SurveySchema', id: string } };

export type duplicateSurveySchemaVariables = Exact<{
  surveySchemaId: Scalars['String']['input'];
}>;


export type duplicateSurveySchema = { duplicateSurveySchema: { __typename: 'SurveySchema', id: string } };

export type GetIndividualSurveyResultsVariables = Exact<{
  surveySchemaId: Scalars['String']['input'];
  isAnonymous: Scalars['Boolean']['input'];
  paginationInput?: InputMaybe<PaginationInput>;
  dateIntervalInput?: InputMaybe<DateIntervalInput>;
}>;


export type GetIndividualSurveyResults = { getIndividualSurveyResults: { __typename: 'IndividualResults', total: number, csvInBase64: string, xlsxInBase64: string, surveys: Array<{ __typename: 'Survey', fillableFrom: any, finishedAt?: any | null, doctor: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string, institutionToDoctor: Array<{ __typename: 'InstitutionToDoctor', institution: { __typename: 'Institution', name: string } }> }, patient?: { __typename: 'PatientProfile', title: string, firstName: string, lastName: string, tajNumber: string } | null, recipientProfile: { __typename: 'AdminProfile', title: string, firstName: string, lastName: string } | { __typename: 'AssistantProfile', title: string, firstName: string, lastName: string } | { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | { __typename: 'PatientProfile', title: string, firstName: string, lastName: string }, surveyQuestionAnswers: Array<{ __typename: 'SurveyQuestionAnswer', surveyQuestion?: { __typename: 'SurveyQuestion', id: string } | null, mcQuestionAnswer?: { __typename: 'McQuestionAnswer', selectedChoiceIds?: Array<string> | null } | null, scaleQuestionAnswer?: { __typename: 'ScaleQuestionAnswer', aspectAnswers?: Array<{ __typename: 'AspectAnswer', aspectId: string, scaleValue: number }> | null } | null, simpleTextQuestionAnswer?: { __typename: 'SimpleTextQuestionAnswer', text?: string | null } | null, fileUploadQuestionAnswer?: { __typename: 'FileUploadQuestionAnswer', documents?: Array<{ __typename: 'DocumentAnswer', documentId: string, fileName: string }> | null } | null }> }> } };

export type aggregatedSurveyResultsVariables = Exact<{
  surveySchemaId: Scalars['String']['input'];
  dateIntervalInput?: InputMaybe<DateIntervalInput>;
}>;


export type aggregatedSurveyResults = { getAggregatedSurveyResults: { __typename: 'AggregatedSurveyResults', totalSubmitters: number, csvInBase64: string, xlsxInBase64: string, surveyQuestionResultList: Array<{ __typename: 'FileUploadQuestionResult', totalSubmitters: number, questionId: string, documents: Array<{ __typename: 'DocumentAnswer', documentId: string, fileName: string }> } | { __typename: 'MultipleChoiceQuestionResult', totalAnswers: number, questionId: string, choiceResults: Array<{ __typename: 'ChoiceResult', id: string, name: string, total: number }> } | { __typename: 'ScaleQuestionResult', totalAnswersWithoutScaleAspect?: number | null, questionId: string, scaleOptionResultsWithoutScaleAspect: Array<{ __typename: 'ScaleOptionResult', value: number, label?: string | null, total: number }>, scaleAspectResults: Array<{ __typename: 'ScaleAspectResult', totalAnswers: number, id: string, name: string, scaleOptionResults: Array<{ __typename: 'ScaleOptionResult', value: number, label?: string | null, total: number }> }> } | { __typename: 'SimpleTextQuestionResult', totalAnswers: number, answers: Array<string>, questionId: string }> } };

export type getSurveySchemaForResultsVariables = Exact<{
  surveySchemaId: Scalars['String']['input'];
}>;


export type getSurveySchemaForResults = { getSurveySchemaById: { __typename: 'SurveySchema', id: string, title: string, description: string, patientDescription: string, categories: Array<SurveyCategoryEnum>, isGlobal: boolean, status: SurveySchemaStatusEnum, canBeDeleted: boolean, snomedCode?: string | null, user: { __typename: 'User', id: string }, surveySchemaQuestions: Array<{ __typename: 'SurveySchemaQuestion', id: string, required: boolean, orderInSection: number, section: number, sectionName?: string | null, data?: { __typename: 'SurveyQuestion2SurveySchemaData', nextSectionInformation: Array<{ __typename: 'NextSectionInformation', choiceId: string, choiceIndex: number, nextSectionOrder: number }> } | null, surveyQuestion: { __typename: 'SurveyQuestion', id: string, title: string, description?: string | null, type: SurveyQuestionEnum, surveySchemaId?: string | null, isGlobal: boolean, data?: { __typename: 'QuestionData', multipleChoice?: boolean | null, scaleData?: { __typename: 'ScaleData', options: Array<{ __typename: 'ScaleOption', value: number, label?: string | null }> } | null, fileUploadData?: { __typename: 'FileUploadData', maxItemsCount: number, maxFileSize: SurveyQuestionFileSize, validFileTypes: Array<SurveyQuestionValidFileType> } | null } | null, mcSurveyQuestionChoices: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }>, sclSurveyQuestionAspects: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }> } }>, referenceUrls?: Array<{ __typename: 'SurveySchemaReferenceUrl', name: string, url: string }> | null, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }>, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutions: Array<{ __typename: 'Institution', id: string, name: string }>, sharedWithUsers: Array<{ __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string, userId: string } | null }> } };

export type unsubscribeFromSurveySchemaVariables = Exact<{
  surveySchemaId: Scalars['String']['input'];
}>;


export type unsubscribeFromSurveySchema = { unsubscribeFromSurveySchema: { __typename: 'SurveySchema', id: string } };

export type getSurveysForSchemaIdVariables = Exact<{
  filterData: SurveyBySchemaFilter;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getSurveysForSchemaId = { getSurveysForSchemaId: { __typename: 'SurveyList', total: number, surveys: Array<{ __typename: 'Survey', id: string, status: SurveyStatusEnum, fillableFrom: any, fillableUntil?: any | null, finishedAt?: any | null, surveySchema: { __typename: 'SurveySchema', id: string, title: string, categories: Array<SurveyCategoryEnum> }, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, recipientProfile: { __typename: 'AdminProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'AssistantProfile', title: string, firstName: string, lastName: string, extraInfo: string, user: { __typename: 'User', userType: UserType, id: string } } | { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'PatientProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } }> } };

export type resendSurveyVariables = Exact<{
  surveyId: Scalars['String']['input'];
  fillableUntilDate: Scalars['DateTime']['input'];
}>;


export type resendSurvey = { resendSurvey: { __typename: 'Survey', id: string }, updateSurveyFillableUntilDate: { __typename: 'Survey', id: string } };

export type SchemaDisabledChore = { __typename: 'TreatmentSchema', disabled: boolean, isDeletable: boolean };

export type getTreatmentSchemasVariables = Exact<{
  treatmentSchemaFilter?: InputMaybe<TreatmentSchemaFilter>;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getTreatmentSchemas = { getTreatmentSchemas: { __typename: 'TreatmentSchemaList', total: number, treatmentSchemas: Array<{ __typename: 'TreatmentSchema', isDeletable: boolean, id: string, disabled: boolean, url?: string | null, snowmedCode?: string | null, isGlobal?: boolean | null, optimalDuration?: number | null, description?: { __typename: 'MultiLangText', hu: string, en: string } | null, title: { __typename: 'MultiLangText', hu: string, en: string }, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutions: Array<{ __typename: 'Institution', id: string, name: string }>, user: { __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }, sharedWith: Array<{ __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }>, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> }> } };

export type getTreatmentSchemaVariables = Exact<{
  treatmentSchemaId: Scalars['String']['input'];
}>;


export type getTreatmentSchema = { getTreatmentSchema: { __typename: 'TreatmentSchema', isDeletable: boolean, id: string, disabled: boolean, url?: string | null, snowmedCode?: string | null, isGlobal?: boolean | null, optimalDuration?: number | null, surveySchemas: Array<{ __typename: 'TreatmentSchemaToSurvey', id: string, customDays?: number | null, surveySchema: { __typename: 'SurveySchema', id: string, title: string } }>, schedules: Array<{ __typename: 'PlainTreatmentElement', id: string, createdAt: any, customDays?: number | null, appointmentInfo: { __typename: 'AppointmentInfo', id: string, beforeTreatmentNote?: boolean | null, oeno?: string | null, goodToKnow: { __typename: 'MultiLangText', hu: string, en: string }, doctorTitle: { __typename: 'MultiLangText', hu: string, en: string }, patientTitle: { __typename: 'MultiLangText', hu: string, en: string }, doctorTodo: { __typename: 'MultiLangText', hu: string, en: string }, professions?: Array<{ __typename: 'Profession', id: string, name: string }> | null }, doctorTitle?: { __typename: 'MultiLangText', hu: string, en: string } | null, date: { __typename: 'StartEndDates', start: any, end?: any | null }, dependencies: Array<{ __typename: 'Dependency', id: string, fromId: string, distance: string, type: AppointmentDependencyTypes }>, dependents: Array<{ __typename: 'Dependency', id: string, fromId: string, distance: string }> }>, description?: { __typename: 'MultiLangText', hu: string, en: string } | null, title: { __typename: 'MultiLangText', hu: string, en: string }, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutions: Array<{ __typename: 'Institution', id: string, name: string }>, user: { __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }, sharedWith: Array<{ __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }>, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> } };

export type createNewTreatmentSchemaVariables = Exact<{
  schema: TreatmentSchemaCreateInput;
}>;


export type createNewTreatmentSchema = { createNewTreatmentSchema: { __typename: 'TreatmentSchema', id: string } };

export type addScheduleVariables = Exact<{
  treatmentSchemaId: Scalars['String']['input'];
  appointmentInfoId: Scalars['String']['input'];
}>;


export type addSchedule = { addSchedule: { __typename: 'SchemaSchedule', id: string } };

export type createSchedulesVariables = Exact<{
  treatmentSchemaId: Scalars['String']['input'];
  appointmentInfoIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type createSchedules = { createSchedules: Array<{ __typename: 'SchemaSchedule', id: string }> };

export type removeSchedulesVariables = Exact<{
  scheduleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type removeSchedules = { removeSchedules: number };

export type removeScheduleVariables = Exact<{
  scheduleId: Scalars['String']['input'];
}>;


export type removeSchedule = { removeSchedule: { __typename: 'SchemaSchedule', id: string } };

export type addSchemaDependencyVariables = Exact<{
  dependencyInput: CreateDependencyInput;
}>;


export type addSchemaDependency = { addSchemaDependency: { __typename: 'SchemaDependency', id: string } };

export type removeSchemaDependencyVariables = Exact<{
  treatmentSchemaId: Scalars['String']['input'];
  dependencyId: Scalars['String']['input'];
}>;


export type removeSchemaDependency = { removeSchemaDependency: { __typename: 'SchemaDependency', id: string } };

export type updateSchemaDependencyVariables = Exact<{
  dependencyInput: UpdateDependencyInput;
}>;


export type updateSchemaDependency = { updateSchemaDependency: { __typename: 'SchemaDependency', id: string } };

export type removeTreatmentSchemaVariables = Exact<{
  treatmentSchemaId: Scalars['String']['input'];
}>;


export type removeTreatmentSchema = { removeTreatmentSchema: { __typename: 'TreatmentSchema', id: string } };

export type updateTreatmentSchemaVariables = Exact<{
  treatmentData: UpdateSchemaInput;
}>;


export type updateTreatmentSchema = { updateTreatmentSchema: { __typename: 'TreatmentSchema', id: string, disabled: boolean, url?: string | null, snowmedCode?: string | null, isGlobal?: boolean | null, optimalDuration?: number | null, description?: { __typename: 'MultiLangText', hu: string, en: string } | null, title: { __typename: 'MultiLangText', hu: string, en: string }, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutions: Array<{ __typename: 'Institution', id: string, name: string }>, user: { __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }, sharedWith: Array<{ __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }>, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> } };

export type updateTreatmentSchemaStatusVariables = Exact<{
  treatmentSchemaId: Scalars['ID']['input'];
  publish: Scalars['Boolean']['input'];
}>;


export type updateTreatmentSchemaStatus = { updateTreatmentSchemaStatus: { __typename: 'TreatmentSchema', id: string, disabled: boolean, isDeletable: boolean } };

export type duplicateTreatmentSchemaVariables = Exact<{
  treatmentSchemaId: Scalars['String']['input'];
}>;


export type duplicateTreatmentSchema = { duplicateTreatmentSchema: { __typename: 'TreatmentSchema', id: string } };

export type shareTreatmentSchemaVariables = Exact<{
  treatmentData: ShareSchemaInput;
}>;


export type shareTreatmentSchema = { shareTreatmentSchema: { __typename: 'TreatmentSchema', id: string, disabled: boolean, url?: string | null, snowmedCode?: string | null, isGlobal?: boolean | null, optimalDuration?: number | null, description?: { __typename: 'MultiLangText', hu: string, en: string } | null, title: { __typename: 'MultiLangText', hu: string, en: string }, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutions: Array<{ __typename: 'Institution', id: string, name: string }>, user: { __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }, sharedWith: Array<{ __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }>, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> } };

export type unSubscribeTreatmentSchemaVariables = Exact<{
  treatmentData: UnsubscribeSchemaInput;
}>;


export type unSubscribeTreatmentSchema = { unSubscribeTreatmentSchema: { __typename: 'TreatmentSchema', id: string, disabled: boolean, url?: string | null, snowmedCode?: string | null, isGlobal?: boolean | null, optimalDuration?: number | null, description?: { __typename: 'MultiLangText', hu: string, en: string } | null, title: { __typename: 'MultiLangText', hu: string, en: string }, professions: Array<{ __typename: 'Profession', id: string, code: string, name: string }>, institutions: Array<{ __typename: 'Institution', id: string, name: string }>, user: { __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }, sharedWith: Array<{ __typename: 'User', id: string, doctorProfile?: { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string } | null }>, bnoCodes: Array<{ __typename: 'BnoCode', id: string, code: string, title: string }> } };

export type setCustomDaysOfScheduleVariables = Exact<{
  scheduleId: Scalars['String']['input'];
  customDays?: InputMaybe<Scalars['Float']['input']>;
}>;


export type setCustomDaysOfSchedule = { setCustomDaysOfSchedule: { __typename: 'SchemaSchedule', id: string, customDays?: number | null } };

export type addSurveySchemaToTreatmentSchemaVariables = Exact<{
  treatmentSchemaId: Scalars['String']['input'];
  surveySchemaId: Scalars['String']['input'];
}>;


export type addSurveySchemaToTreatmentSchema = { addSurveySchemaToTreatmentSchema: { __typename: 'TreatmentSchemaToSurvey', id: string } };

export type removeSurveySchemaFromTreatmentSchemaVariables = Exact<{
  treatmentSchemaToSurveyId: Scalars['String']['input'];
}>;


export type removeSurveySchemaFromTreatmentSchema = { removeSurveySchemaFromTreatmentSchema: { __typename: 'TreatmentSchemaToSurvey', id: string } };

export type setCustomDaysOfTreatmentSchemaSurveyVariables = Exact<{
  treatmentSchemaToSurveyId: Scalars['String']['input'];
  customDays?: InputMaybe<Scalars['Float']['input']>;
}>;


export type setCustomDaysOfTreatmentSchemaSurvey = { setCustomDaysOfTreatmentSchemaSurvey: { __typename: 'TreatmentSchemaToSurvey', id: string, customDays?: number | null } };

export type getAppointmentCountByUserIdAndInFutureVariables = Exact<{ [key: string]: never; }>;


export type getAppointmentCountByUserIdAndInFuture = { appointmentCountByIsOwnAndInFuture: number };

export type getSurveyCountByUserIdAndNotFinishedVariables = Exact<{ [key: string]: never; }>;


export type getSurveyCountByUserIdAndNotFinished = { surveyCountByIsOwnAndNotFinished: number };

export type isSurveyExpireSoonByIsOwnAndNotFinishedVariables = Exact<{ [key: string]: never; }>;


export type isSurveyExpireSoonByIsOwnAndNotFinished = { isSurveyExpireSoonByIsOwnAndNotFinished: boolean };

export type getSurveysVariables = Exact<{
  filterData: SurveyFilterForPatient;
  paginationInput?: InputMaybe<PaginationInput>;
}>;


export type getSurveys = { getOwnSurveys: { __typename: 'SurveyList', total: number, surveys: Array<{ __typename: 'Survey', id: string, status: SurveyStatusEnum, fillableFrom: any, fillableUntil?: any | null, finishedAt?: any | null, surveySchema: { __typename: 'SurveySchema', id: string, title: string, categories: Array<SurveyCategoryEnum> }, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, recipientProfile: { __typename: 'AdminProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'AssistantProfile', title: string, firstName: string, lastName: string, extraInfo: string, user: { __typename: 'User', userType: UserType, id: string } } | { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'PatientProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } }> } };

export type getSurveyByIdVariables = Exact<{
  surveyId: Scalars['ID']['input'];
}>;


export type getSurveyById = { getSurvey: { __typename: 'Survey', id: string, status: SurveyStatusEnum, fillableFrom: any, fillableUntil?: any | null, finishedAt?: any | null, surveySchema: { __typename: 'SurveySchema', id: string, title: string, patientDescription: string, surveySchemaQuestions: Array<{ __typename: 'SurveySchemaQuestion', id: string, required: boolean, orderInSection: number, section: number, sectionName?: string | null, data?: { __typename: 'SurveyQuestion2SurveySchemaData', nextSectionInformation: Array<{ __typename: 'NextSectionInformation', choiceId: string, choiceIndex: number, nextSectionOrder: number }> } | null, surveyQuestion: { __typename: 'SurveyQuestion', id: string, title: string, description?: string | null, type: SurveyQuestionEnum, surveySchemaId?: string | null, isGlobal: boolean, data?: { __typename: 'QuestionData', multipleChoice?: boolean | null, scaleData?: { __typename: 'ScaleData', options: Array<{ __typename: 'ScaleOption', value: number, label?: string | null }> } | null, fileUploadData?: { __typename: 'FileUploadData', maxItemsCount: number, maxFileSize: SurveyQuestionFileSize, validFileTypes: Array<SurveyQuestionValidFileType> } | null } | null, mcSurveyQuestionChoices: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }>, sclSurveyQuestionAspects: Array<{ __typename: 'AnswerOption', id?: string | null, name: string }> } }> }, surveyQuestionAnswers: Array<{ __typename: 'SurveyQuestionAnswer', surveyQuestionId: string, mcQuestionAnswer?: { __typename: 'McQuestionAnswer', selectedChoiceIds?: Array<string> | null } | null, scaleQuestionAnswer?: { __typename: 'ScaleQuestionAnswer', aspectAnswers?: Array<{ __typename: 'AspectAnswer', aspectId: string, scaleValue: number }> | null } | null, simpleTextQuestionAnswer?: { __typename: 'SimpleTextQuestionAnswer', text?: string | null } | null, fileUploadQuestionAnswer?: { __typename: 'FileUploadQuestionAnswer', documents?: Array<{ __typename: 'DocumentAnswer', documentId: string, fileName: string }> | null } | null }>, doctor: { __typename: 'DoctorProfile', id: string, title: string, firstName: string, lastName: string }, recipientProfile: { __typename: 'AdminProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'AssistantProfile', title: string, firstName: string, lastName: string, extraInfo: string, user: { __typename: 'User', userType: UserType, id: string } } | { __typename: 'DoctorProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } | { __typename: 'PatientProfile', title: string, firstName: string, lastName: string, extraInfo: string, user?: { __typename: 'User', userType: UserType, id: string } | null } } };

export type upsertSurveyQuestionAnswerVariables = Exact<{
  inputSurveyQuestionAnswer: InputSurveyQuestionAnswer;
}>;


export type upsertSurveyQuestionAnswer = { upsertSurveyQuestionAnswer: { __typename: 'SurveyQuestionAnswer', id: string } };

export type finishVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type finish = { finishSurvey: { __typename: 'Survey', id: string } };

export type uploadFileVariables = Exact<{
  documentType: Scalars['String']['input'];
  file: Scalars['Upload']['input'];
}>;


export type uploadFile = { uploadDocument: string };


export type createAppointmentMutationFn = Apollo.MutationFunction<createAppointment, createAppointmentVariables>;
export type createAppointmentMutationResult = Apollo.MutationResult<createAppointment>;
export type createAppointmentMutationOptions = Apollo.BaseMutationOptions<createAppointment, createAppointmentVariables>;
export type updateAppointmentMutationFn = Apollo.MutationFunction<updateAppointment, updateAppointmentVariables>;
export type updateAppointmentMutationResult = Apollo.MutationResult<updateAppointment>;
export type updateAppointmentMutationOptions = Apollo.BaseMutationOptions<updateAppointment, updateAppointmentVariables>;
export type UpdateAppointmentWithDepsMutationFn = Apollo.MutationFunction<UpdateAppointmentWithDeps, UpdateAppointmentWithDepsVariables>;
export type UpdateAppointmentWithDepsMutationResult = Apollo.MutationResult<UpdateAppointmentWithDeps>;
export type UpdateAppointmentWithDepsMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentWithDeps, UpdateAppointmentWithDepsVariables>;
export type updateAppointmentGoodToKnowMutationFn = Apollo.MutationFunction<updateAppointmentGoodToKnow, updateAppointmentGoodToKnowVariables>;
export type updateAppointmentGoodToKnowMutationResult = Apollo.MutationResult<updateAppointmentGoodToKnow>;
export type updateAppointmentGoodToKnowMutationOptions = Apollo.BaseMutationOptions<updateAppointmentGoodToKnow, updateAppointmentGoodToKnowVariables>;
export type updateAppointmentOenoMutationFn = Apollo.MutationFunction<updateAppointmentOeno, updateAppointmentOenoVariables>;
export type updateAppointmentOenoMutationResult = Apollo.MutationResult<updateAppointmentOeno>;
export type updateAppointmentOenoMutationOptions = Apollo.BaseMutationOptions<updateAppointmentOeno, updateAppointmentOenoVariables>;
export type deleteAppointmentMutationFn = Apollo.MutationFunction<deleteAppointment, deleteAppointmentVariables>;
export type deleteAppointmentMutationResult = Apollo.MutationResult<deleteAppointment>;
export type deleteAppointmentMutationOptions = Apollo.BaseMutationOptions<deleteAppointment, deleteAppointmentVariables>;
export type deleteAppointmentsMutationFn = Apollo.MutationFunction<deleteAppointments, deleteAppointmentsVariables>;
export type deleteAppointmentsMutationResult = Apollo.MutationResult<deleteAppointments>;
export type deleteAppointmentsMutationOptions = Apollo.BaseMutationOptions<deleteAppointments, deleteAppointmentsVariables>;
export type triggerExpirePastAppointmentsQueryResult = Apollo.QueryResult<triggerExpirePastAppointments, triggerExpirePastAppointmentsVariables>;
export type createAppointmentDependencyMutationFn = Apollo.MutationFunction<createAppointmentDependency, createAppointmentDependencyVariables>;
export type createAppointmentDependencyMutationResult = Apollo.MutationResult<createAppointmentDependency>;
export type createAppointmentDependencyMutationOptions = Apollo.BaseMutationOptions<createAppointmentDependency, createAppointmentDependencyVariables>;
export type updateAppointmentDependencyMutationFn = Apollo.MutationFunction<updateAppointmentDependency, updateAppointmentDependencyVariables>;
export type updateAppointmentDependencyMutationResult = Apollo.MutationResult<updateAppointmentDependency>;
export type updateAppointmentDependencyMutationOptions = Apollo.BaseMutationOptions<updateAppointmentDependency, updateAppointmentDependencyVariables>;
export type deleteAppointmentDependencyMutationFn = Apollo.MutationFunction<deleteAppointmentDependency, deleteAppointmentDependencyVariables>;
export type deleteAppointmentDependencyMutationResult = Apollo.MutationResult<deleteAppointmentDependency>;
export type deleteAppointmentDependencyMutationOptions = Apollo.BaseMutationOptions<deleteAppointmentDependency, deleteAppointmentDependencyVariables>;
export type listAllAppointmentInfosQueryResult = Apollo.QueryResult<listAllAppointmentInfos, listAllAppointmentInfosVariables>;
export type listAppointmentInfosQueryResult = Apollo.QueryResult<listAppointmentInfos, listAppointmentInfosVariables>;
export type createAppointmentInfoMutationFn = Apollo.MutationFunction<createAppointmentInfo, createAppointmentInfoVariables>;
export type createAppointmentInfoMutationResult = Apollo.MutationResult<createAppointmentInfo>;
export type createAppointmentInfoMutationOptions = Apollo.BaseMutationOptions<createAppointmentInfo, createAppointmentInfoVariables>;
export type updateAppointmentInfoMutationFn = Apollo.MutationFunction<updateAppointmentInfo, updateAppointmentInfoVariables>;
export type updateAppointmentInfoMutationResult = Apollo.MutationResult<updateAppointmentInfo>;
export type updateAppointmentInfoMutationOptions = Apollo.BaseMutationOptions<updateAppointmentInfo, updateAppointmentInfoVariables>;
export type updateScheduleAppointmentInfoMutationFn = Apollo.MutationFunction<updateScheduleAppointmentInfo, updateScheduleAppointmentInfoVariables>;
export type updateScheduleAppointmentInfoMutationResult = Apollo.MutationResult<updateScheduleAppointmentInfo>;
export type updateScheduleAppointmentInfoMutationOptions = Apollo.BaseMutationOptions<updateScheduleAppointmentInfo, updateScheduleAppointmentInfoVariables>;
export type deleteAppointmentInfoMutationFn = Apollo.MutationFunction<deleteAppointmentInfo, deleteAppointmentInfoVariables>;
export type deleteAppointmentInfoMutationResult = Apollo.MutationResult<deleteAppointmentInfo>;
export type deleteAppointmentInfoMutationOptions = Apollo.BaseMutationOptions<deleteAppointmentInfo, deleteAppointmentInfoVariables>;
export type getAppointmentIcsQueryResult = Apollo.QueryResult<getAppointmentIcs, getAppointmentIcsVariables>;
export type getPatientAppointmentQueryResult = Apollo.QueryResult<getPatientAppointment, getPatientAppointmentVariables>;
export type getAssistantPatientsQueryResult = Apollo.QueryResult<getAssistantPatients, getAssistantPatientsVariables>;
export type getAssistantDoctorsQueryResult = Apollo.QueryResult<getAssistantDoctors, getAssistantDoctorsVariables>;
export type updateAssistantProfileMutationFn = Apollo.MutationFunction<updateAssistantProfile, updateAssistantProfileVariables>;
export type updateAssistantProfileMutationResult = Apollo.MutationResult<updateAssistantProfile>;
export type updateAssistantProfileMutationOptions = Apollo.BaseMutationOptions<updateAssistantProfile, updateAssistantProfileVariables>;
export type getAssistantProfilesForDoctorQueryResult = Apollo.QueryResult<getAssistantProfilesForDoctor, getAssistantProfilesForDoctorVariables>;
export type bnoCodesQueryResult = Apollo.QueryResult<bnoCodes, bnoCodesVariables>;
export type getLocationByPostalCodeQueryResult = Apollo.QueryResult<getLocationByPostalCode, getLocationByPostalCodeVariables>;
export type getCitiesQueryResult = Apollo.QueryResult<getCities, getCitiesVariables>;
export type getDashboardAppointmentsQueryResult = Apollo.QueryResult<getDashboardAppointments, getDashboardAppointmentsVariables>;
export type getReceivedSurveysForDoctorQueryResult = Apollo.QueryResult<getReceivedSurveysForDoctor, getReceivedSurveysForDoctorVariables>;
export type getSentSurveysForDoctorQueryResult = Apollo.QueryResult<getSentSurveysForDoctor, getSentSurveysForDoctorVariables>;
export type getReceivedSurveysForAssistantQueryResult = Apollo.QueryResult<getReceivedSurveysForAssistant, getReceivedSurveysForAssistantVariables>;
export type getSentSurveysForAssistantQueryResult = Apollo.QueryResult<getSentSurveysForAssistant, getSentSurveysForAssistantVariables>;
export type getDoctorPatientTreatmentsQueryResult = Apollo.QueryResult<getDoctorPatientTreatments, getDoctorPatientTreatmentsVariables>;
export type GetPatientProfileWithEhrQueryResult = Apollo.QueryResult<GetPatientProfileWithEhr, GetPatientProfileWithEhrVariables>;
export type findPatientProfileQueryResult = Apollo.QueryResult<findPatientProfile, findPatientProfileVariables>;
export type invitePatientMutationFn = Apollo.MutationFunction<invitePatient, invitePatientVariables>;
export type invitePatientMutationResult = Apollo.MutationResult<invitePatient>;
export type invitePatientMutationOptions = Apollo.BaseMutationOptions<invitePatient, invitePatientVariables>;
export type inviteExistingPatientMutationFn = Apollo.MutationFunction<inviteExistingPatient, inviteExistingPatientVariables>;
export type inviteExistingPatientMutationResult = Apollo.MutationResult<inviteExistingPatient>;
export type inviteExistingPatientMutationOptions = Apollo.BaseMutationOptions<inviteExistingPatient, inviteExistingPatientVariables>;
export type getDoctorPatientSurveysQueryResult = Apollo.QueryResult<getDoctorPatientSurveys, getDoctorPatientSurveysVariables>;
export type getDoctorProfileQueryResult = Apollo.QueryResult<getDoctorProfile, getDoctorProfileVariables>;
export type getDoctorProfilesForPatientsQueryResult = Apollo.QueryResult<getDoctorProfilesForPatients, getDoctorProfilesForPatientsVariables>;
export type getDoctorProfilesForAssistantQueryResult = Apollo.QueryResult<getDoctorProfilesForAssistant, getDoctorProfilesForAssistantVariables>;
export type getDoctorInvitesQueryResult = Apollo.QueryResult<getDoctorInvites, getDoctorInvitesVariables>;
export type getDoctorOwnPatientsQueryResult = Apollo.QueryResult<getDoctorOwnPatients, getDoctorOwnPatientsVariables>;
export type getDoctorProfilesQueryResult = Apollo.QueryResult<getDoctorProfiles, getDoctorProfilesVariables>;
export type getDoctorProfilesForDoctorQueryResult = Apollo.QueryResult<getDoctorProfilesForDoctor, getDoctorProfilesForDoctorVariables>;
export type updateDoctorProfileMutationFn = Apollo.MutationFunction<updateDoctorProfile, updateDoctorProfileVariables>;
export type updateDoctorProfileMutationResult = Apollo.MutationResult<updateDoctorProfile>;
export type updateDoctorProfileMutationOptions = Apollo.BaseMutationOptions<updateDoctorProfile, updateDoctorProfileVariables>;
export type listAllProfessionsQueryResult = Apollo.QueryResult<listAllProfessions, listAllProfessionsVariables>;
export type inviteDoctorMutationFn = Apollo.MutationFunction<inviteDoctor, inviteDoctorVariables>;
export type inviteDoctorMutationResult = Apollo.MutationResult<inviteDoctor>;
export type inviteDoctorMutationOptions = Apollo.BaseMutationOptions<inviteDoctor, inviteDoctorVariables>;
export type listAllDoctorsQueryResult = Apollo.QueryResult<listAllDoctors, listAllDoctorsVariables>;
export type hasEESZTTokenQueryResult = Apollo.QueryResult<hasEESZTToken, hasEESZTTokenVariables>;
export type generateFileDocumentsMutationFn = Apollo.MutationFunction<generateFileDocuments, generateFileDocumentsVariables>;
export type generateFileDocumentsMutationResult = Apollo.MutationResult<generateFileDocuments>;
export type generateFileDocumentsMutationOptions = Apollo.BaseMutationOptions<generateFileDocuments, generateFileDocumentsVariables>;
export type EesztStsLoginMutationFn = Apollo.MutationFunction<EesztStsLogin, EesztStsLoginVariables>;
export type EesztStsLoginMutationResult = Apollo.MutationResult<EesztStsLogin>;
export type EesztStsLoginMutationOptions = Apollo.BaseMutationOptions<EesztStsLogin, EesztStsLoginVariables>;
export type EesztMobileTokenLoginMutationFn = Apollo.MutationFunction<EesztMobileTokenLogin, EesztMobileTokenLoginVariables>;
export type EesztMobileTokenLoginMutationResult = Apollo.MutationResult<EesztMobileTokenLogin>;
export type EesztMobileTokenLoginMutationOptions = Apollo.BaseMutationOptions<EesztMobileTokenLogin, EesztMobileTokenLoginVariables>;
export type getEszigIdNoSamlQueryResult = Apollo.QueryResult<getEszigIdNoSaml, getEszigIdNoSamlVariables>;
export type EesztESZIGLoginMutationFn = Apollo.MutationFunction<EesztESZIGLogin, EesztESZIGLoginVariables>;
export type EesztESZIGLoginMutationResult = Apollo.MutationResult<EesztESZIGLogin>;
export type EesztESZIGLoginMutationOptions = Apollo.BaseMutationOptions<EesztESZIGLogin, EesztESZIGLoginVariables>;
export type EesztLogoutMutationFn = Apollo.MutationFunction<EesztLogout, EesztLogoutVariables>;
export type EesztLogoutMutationResult = Apollo.MutationResult<EesztLogout>;
export type EesztLogoutMutationOptions = Apollo.BaseMutationOptions<EesztLogout, EesztLogoutVariables>;
export type getFreeSlotsByInstitutionQueryResult = Apollo.QueryResult<getFreeSlotsByInstitution, getFreeSlotsByInstitutionVariables>;
export type EesztFeedQueryResult = Apollo.QueryResult<EesztFeed, EesztFeedVariables>;
export type EesztTorSyncStateQueryQueryResult = Apollo.QueryResult<EesztTorSyncStateQuery, EesztTorSyncStateQueryVariables>;
export type synchronizeEesztTorDataMutationFn = Apollo.MutationFunction<synchronizeEesztTorData, synchronizeEesztTorDataVariables>;
export type synchronizeEesztTorDataMutationResult = Apollo.MutationResult<synchronizeEesztTorData>;
export type synchronizeEesztTorDataMutationOptions = Apollo.BaseMutationOptions<synchronizeEesztTorData, synchronizeEesztTorDataVariables>;
export type listInstitutionsQueryResult = Apollo.QueryResult<listInstitutions, listInstitutionsVariables>;
export type createRoomMutationFn = Apollo.MutationFunction<createRoom, createRoomVariables>;
export type createRoomMutationResult = Apollo.MutationResult<createRoom>;
export type createRoomMutationOptions = Apollo.BaseMutationOptions<createRoom, createRoomVariables>;
export type updateRoomMutationFn = Apollo.MutationFunction<updateRoom, updateRoomVariables>;
export type updateRoomMutationResult = Apollo.MutationResult<updateRoom>;
export type updateRoomMutationOptions = Apollo.BaseMutationOptions<updateRoom, updateRoomVariables>;
export type createInstitutionMutationFn = Apollo.MutationFunction<createInstitution, createInstitutionVariables>;
export type createInstitutionMutationResult = Apollo.MutationResult<createInstitution>;
export type createInstitutionMutationOptions = Apollo.BaseMutationOptions<createInstitution, createInstitutionVariables>;
export type updateInstitutionMutationFn = Apollo.MutationFunction<updateInstitution, updateInstitutionVariables>;
export type updateInstitutionMutationResult = Apollo.MutationResult<updateInstitution>;
export type updateInstitutionMutationOptions = Apollo.BaseMutationOptions<updateInstitution, updateInstitutionVariables>;
export type assignAdminsToInstitutionMutationFn = Apollo.MutationFunction<assignAdminsToInstitution, assignAdminsToInstitutionVariables>;
export type assignAdminsToInstitutionMutationResult = Apollo.MutationResult<assignAdminsToInstitution>;
export type assignAdminsToInstitutionMutationOptions = Apollo.BaseMutationOptions<assignAdminsToInstitution, assignAdminsToInstitutionVariables>;
export type institutionAdminProfilesQueryResult = Apollo.QueryResult<institutionAdminProfiles, institutionAdminProfilesVariables>;
export type uploadCertificateMutationFn = Apollo.MutationFunction<uploadCertificate, uploadCertificateVariables>;
export type uploadCertificateMutationResult = Apollo.MutationResult<uploadCertificate>;
export type uploadCertificateMutationOptions = Apollo.BaseMutationOptions<uploadCertificate, uploadCertificateVariables>;
export type checkCertificateQueryResult = Apollo.QueryResult<checkCertificate, checkCertificateVariables>;
export type getPartnersQueryResult = Apollo.QueryResult<getPartners, getPartnersVariables>;
export type getPartnerMessagesQueryResult = Apollo.QueryResult<getPartnerMessages, getPartnerMessagesVariables>;
export type sendMessageMutationFn = Apollo.MutationFunction<sendMessage, sendMessageVariables>;
export type sendMessageMutationResult = Apollo.MutationResult<sendMessage>;
export type sendMessageMutationOptions = Apollo.BaseMutationOptions<sendMessage, sendMessageVariables>;
export type markMessagesAsReadMutationFn = Apollo.MutationFunction<markMessagesAsRead, markMessagesAsReadVariables>;
export type markMessagesAsReadMutationResult = Apollo.MutationResult<markMessagesAsRead>;
export type markMessagesAsReadMutationOptions = Apollo.BaseMutationOptions<markMessagesAsRead, markMessagesAsReadVariables>;
export type newMessageSubscriptionResult = Apollo.SubscriptionResult<newMessage>;
export type getNotificationsQueryResult = Apollo.QueryResult<getNotifications, getNotificationsVariables>;
export type markNotificationAsReadMutationFn = Apollo.MutationFunction<markNotificationAsRead, markNotificationAsReadVariables>;
export type markNotificationAsReadMutationResult = Apollo.MutationResult<markNotificationAsRead>;
export type markNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<markNotificationAsRead, markNotificationAsReadVariables>;
export type markAllNotificationAsReadMutationFn = Apollo.MutationFunction<markAllNotificationAsRead, markAllNotificationAsReadVariables>;
export type markAllNotificationAsReadMutationResult = Apollo.MutationResult<markAllNotificationAsRead>;
export type markAllNotificationAsReadMutationOptions = Apollo.BaseMutationOptions<markAllNotificationAsRead, markAllNotificationAsReadVariables>;
export type newNotificationSubscriptionResult = Apollo.SubscriptionResult<newNotification>;
export type triggerDoctorNextWeekTasksQueryResult = Apollo.QueryResult<triggerDoctorNextWeekTasks, triggerDoctorNextWeekTasksVariables>;
export type triggerPatientNextWeekAppointmentsQueryResult = Apollo.QueryResult<triggerPatientNextWeekAppointments, triggerPatientNextWeekAppointmentsVariables>;
export type triggerPatientDailyAppointmentReminderQueryResult = Apollo.QueryResult<triggerPatientDailyAppointmentReminder, triggerPatientDailyAppointmentReminderVariables>;
export type getNotificationSettingsQueryResult = Apollo.QueryResult<getNotificationSettings, getNotificationSettingsVariables>;
export type updateNotificationSettingsMutationFn = Apollo.MutationFunction<updateNotificationSettings, updateNotificationSettingsVariables>;
export type updateNotificationSettingsMutationResult = Apollo.MutationResult<updateNotificationSettings>;
export type updateNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<updateNotificationSettings, updateNotificationSettingsVariables>;
export type getEProfileQueryResult = Apollo.QueryResult<getEProfile, getEProfileVariables>;
export type getPatientProfileQueryResult = Apollo.QueryResult<getPatientProfile, getPatientProfileVariables>;
export type updatePatientProfileMutationFn = Apollo.MutationFunction<updatePatientProfile, updatePatientProfileVariables>;
export type updatePatientProfileMutationResult = Apollo.MutationResult<updatePatientProfile>;
export type updatePatientProfileMutationOptions = Apollo.BaseMutationOptions<updatePatientProfile, updatePatientProfileVariables>;
export type getReferralsQueryResult = Apollo.QueryResult<getReferrals, getReferralsVariables>;
export type getReferralQueryResult = Apollo.QueryResult<getReferral, getReferralVariables>;
export type createReferralMutationFn = Apollo.MutationFunction<createReferral, createReferralVariables>;
export type createReferralMutationResult = Apollo.MutationResult<createReferral>;
export type createReferralMutationOptions = Apollo.BaseMutationOptions<createReferral, createReferralVariables>;
export type deleteReferralMutationFn = Apollo.MutationFunction<deleteReferral, deleteReferralVariables>;
export type deleteReferralMutationResult = Apollo.MutationResult<deleteReferral>;
export type deleteReferralMutationOptions = Apollo.BaseMutationOptions<deleteReferral, deleteReferralVariables>;
export type listProfilesQueryResult = Apollo.QueryResult<listProfiles, listProfilesVariables>;
export type getTreatmentQueryResult = Apollo.QueryResult<getTreatment, getTreatmentVariables>;
export type getPatientHomeDataQueryResult = Apollo.QueryResult<getPatientHomeData, getPatientHomeDataVariables>;
export type getTreatmentsToPatientDashboardQueryResult = Apollo.QueryResult<getTreatmentsToPatientDashboard, getTreatmentsToPatientDashboardVariables>;
export type getKatEventsQueryResult = Apollo.QueryResult<getKatEvents, getKatEventsVariables>;
export type getPatientAppointmentsCountQueryResult = Apollo.QueryResult<getPatientAppointmentsCount, getPatientAppointmentsCountVariables>;
export type createTreatmentMutationFn = Apollo.MutationFunction<createTreatment, createTreatmentVariables>;
export type createTreatmentMutationResult = Apollo.MutationResult<createTreatment>;
export type createTreatmentMutationOptions = Apollo.BaseMutationOptions<createTreatment, createTreatmentVariables>;
export type addProtocolMutationFn = Apollo.MutationFunction<addProtocol, addProtocolVariables>;
export type addProtocolMutationResult = Apollo.MutationResult<addProtocol>;
export type addProtocolMutationOptions = Apollo.BaseMutationOptions<addProtocol, addProtocolVariables>;
export type updatePocMutationFn = Apollo.MutationFunction<updatePoc, updatePocVariables>;
export type updatePocMutationResult = Apollo.MutationResult<updatePoc>;
export type updatePocMutationOptions = Apollo.BaseMutationOptions<updatePoc, updatePocVariables>;
export type deleteProtocolMutationFn = Apollo.MutationFunction<deleteProtocol, deleteProtocolVariables>;
export type deleteProtocolMutationResult = Apollo.MutationResult<deleteProtocol>;
export type deleteProtocolMutationOptions = Apollo.BaseMutationOptions<deleteProtocol, deleteProtocolVariables>;
export type sendDraftTreatmentMutationFn = Apollo.MutationFunction<sendDraftTreatment, sendDraftTreatmentVariables>;
export type sendDraftTreatmentMutationResult = Apollo.MutationResult<sendDraftTreatment>;
export type sendDraftTreatmentMutationOptions = Apollo.BaseMutationOptions<sendDraftTreatment, sendDraftTreatmentVariables>;
export type cancelTreatmentMutationFn = Apollo.MutationFunction<cancelTreatment, cancelTreatmentVariables>;
export type cancelTreatmentMutationResult = Apollo.MutationResult<cancelTreatment>;
export type cancelTreatmentMutationOptions = Apollo.BaseMutationOptions<cancelTreatment, cancelTreatmentVariables>;
export type updateTreatmentMutationFn = Apollo.MutationFunction<updateTreatment, updateTreatmentVariables>;
export type updateTreatmentMutationResult = Apollo.MutationResult<updateTreatment>;
export type updateTreatmentMutationOptions = Apollo.BaseMutationOptions<updateTreatment, updateTreatmentVariables>;
export type deleteDraftTreatmentMutationFn = Apollo.MutationFunction<deleteDraftTreatment, deleteDraftTreatmentVariables>;
export type deleteDraftTreatmentMutationResult = Apollo.MutationResult<deleteDraftTreatment>;
export type deleteDraftTreatmentMutationOptions = Apollo.BaseMutationOptions<deleteDraftTreatment, deleteDraftTreatmentVariables>;
export type triggerExpiringTreatmentRemainderQueryResult = Apollo.QueryResult<triggerExpiringTreatmentRemainder, triggerExpiringTreatmentRemainderVariables>;
export type addSurveyToTreatmentMutationFn = Apollo.MutationFunction<addSurveyToTreatment, addSurveyToTreatmentVariables>;
export type addSurveyToTreatmentMutationResult = Apollo.MutationResult<addSurveyToTreatment>;
export type addSurveyToTreatmentMutationOptions = Apollo.BaseMutationOptions<addSurveyToTreatment, addSurveyToTreatmentVariables>;
export type removeSurveyFromTreatmentMutationFn = Apollo.MutationFunction<removeSurveyFromTreatment, removeSurveyFromTreatmentVariables>;
export type removeSurveyFromTreatmentMutationResult = Apollo.MutationResult<removeSurveyFromTreatment>;
export type removeSurveyFromTreatmentMutationOptions = Apollo.BaseMutationOptions<removeSurveyFromTreatment, removeSurveyFromTreatmentVariables>;
export type updateSurveyFillableFromDateMutationFn = Apollo.MutationFunction<updateSurveyFillableFromDate, updateSurveyFillableFromDateVariables>;
export type updateSurveyFillableFromDateMutationResult = Apollo.MutationResult<updateSurveyFillableFromDate>;
export type updateSurveyFillableFromDateMutationOptions = Apollo.BaseMutationOptions<updateSurveyFillableFromDate, updateSurveyFillableFromDateVariables>;
export type initiatePasswordResetMutationFn = Apollo.MutationFunction<initiatePasswordReset, initiatePasswordResetVariables>;
export type initiatePasswordResetMutationResult = Apollo.MutationResult<initiatePasswordReset>;
export type initiatePasswordResetMutationOptions = Apollo.BaseMutationOptions<initiatePasswordReset, initiatePasswordResetVariables>;
export type setNewPasswordMutationFn = Apollo.MutationFunction<setNewPassword, setNewPasswordVariables>;
export type setNewPasswordMutationResult = Apollo.MutationResult<setNewPassword>;
export type setNewPasswordMutationOptions = Apollo.BaseMutationOptions<setNewPassword, setNewPasswordVariables>;
export type LoginMutationFn = Apollo.MutationFunction<Login, LoginVariables>;
export type LoginMutationResult = Apollo.MutationResult<Login>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<Login, LoginVariables>;
export type LoginWithTwoFactorTokenMutationFn = Apollo.MutationFunction<LoginWithTwoFactorToken, LoginWithTwoFactorTokenVariables>;
export type LoginWithTwoFactorTokenMutationResult = Apollo.MutationResult<LoginWithTwoFactorToken>;
export type LoginWithTwoFactorTokenMutationOptions = Apollo.BaseMutationOptions<LoginWithTwoFactorToken, LoginWithTwoFactorTokenVariables>;
export type MeQueryResult = Apollo.QueryResult<Me, MeVariables>;
export type ChangeLanguageMutationFn = Apollo.MutationFunction<ChangeLanguage, ChangeLanguageVariables>;
export type ChangeLanguageMutationResult = Apollo.MutationResult<ChangeLanguage>;
export type ChangeLanguageMutationOptions = Apollo.BaseMutationOptions<ChangeLanguage, ChangeLanguageVariables>;
export type getInvitedDoctorsByAdminQueryResult = Apollo.QueryResult<getInvitedDoctorsByAdmin, getInvitedDoctorsByAdminVariables>;
export type deleteInvitationMutationFn = Apollo.MutationFunction<deleteInvitation, deleteInvitationVariables>;
export type deleteInvitationMutationResult = Apollo.MutationResult<deleteInvitation>;
export type deleteInvitationMutationOptions = Apollo.BaseMutationOptions<deleteInvitation, deleteInvitationVariables>;
export type getDoctorOwnAssistantsQueryResult = Apollo.QueryResult<getDoctorOwnAssistants, getDoctorOwnAssistantsVariables>;
export type addAssistantToDoctorMutationFn = Apollo.MutationFunction<addAssistantToDoctor, addAssistantToDoctorVariables>;
export type addAssistantToDoctorMutationResult = Apollo.MutationResult<addAssistantToDoctor>;
export type addAssistantToDoctorMutationOptions = Apollo.BaseMutationOptions<addAssistantToDoctor, addAssistantToDoctorVariables>;
export type removeAssistantFromDoctorMutationFn = Apollo.MutationFunction<removeAssistantFromDoctor, removeAssistantFromDoctorVariables>;
export type removeAssistantFromDoctorMutationResult = Apollo.MutationResult<removeAssistantFromDoctor>;
export type removeAssistantFromDoctorMutationOptions = Apollo.BaseMutationOptions<removeAssistantFromDoctor, removeAssistantFromDoctorVariables>;
export type inviteAssistantMutationFn = Apollo.MutationFunction<inviteAssistant, inviteAssistantVariables>;
export type inviteAssistantMutationResult = Apollo.MutationResult<inviteAssistant>;
export type inviteAssistantMutationOptions = Apollo.BaseMutationOptions<inviteAssistant, inviteAssistantVariables>;
export type findAssistantProfileQueryResult = Apollo.QueryResult<findAssistantProfile, findAssistantProfileVariables>;
export type getPatientsQueryResult = Apollo.QueryResult<getPatients, getPatientsVariables>;
export type getDoctorPatientProfileQueryResult = Apollo.QueryResult<getDoctorPatientProfile, getDoctorPatientProfileVariables>;
export type deleteDoctorsOwnPatientMutationFn = Apollo.MutationFunction<deleteDoctorsOwnPatient, deleteDoctorsOwnPatientVariables>;
export type deleteDoctorsOwnPatientMutationResult = Apollo.MutationResult<deleteDoctorsOwnPatient>;
export type deleteDoctorsOwnPatientMutationOptions = Apollo.BaseMutationOptions<deleteDoctorsOwnPatient, deleteDoctorsOwnPatientVariables>;
export type deleteDoctorsOwnPatientsMutationFn = Apollo.MutationFunction<deleteDoctorsOwnPatients, deleteDoctorsOwnPatientsVariables>;
export type deleteDoctorsOwnPatientsMutationResult = Apollo.MutationResult<deleteDoctorsOwnPatients>;
export type deleteDoctorsOwnPatientsMutationOptions = Apollo.BaseMutationOptions<deleteDoctorsOwnPatients, deleteDoctorsOwnPatientsVariables>;
export type updatePatientsBloodTypeMutationFn = Apollo.MutationFunction<updatePatientsBloodType, updatePatientsBloodTypeVariables>;
export type updatePatientsBloodTypeMutationResult = Apollo.MutationResult<updatePatientsBloodType>;
export type updatePatientsBloodTypeMutationOptions = Apollo.BaseMutationOptions<updatePatientsBloodType, updatePatientsBloodTypeVariables>;
export type sendMessageToPatientsMutationFn = Apollo.MutationFunction<sendMessageToPatients, sendMessageToPatientsVariables>;
export type sendMessageToPatientsMutationResult = Apollo.MutationResult<sendMessageToPatients>;
export type sendMessageToPatientsMutationOptions = Apollo.BaseMutationOptions<sendMessageToPatients, sendMessageToPatientsVariables>;
export type getSurveyQuestionsQueryResult = Apollo.QueryResult<getSurveyQuestions, getSurveyQuestionsVariables>;
export type createSurveyQuestionMutationFn = Apollo.MutationFunction<createSurveyQuestion, createSurveyQuestionVariables>;
export type createSurveyQuestionMutationResult = Apollo.MutationResult<createSurveyQuestion>;
export type createSurveyQuestionMutationOptions = Apollo.BaseMutationOptions<createSurveyQuestion, createSurveyQuestionVariables>;
export type updateSurveyQuestionMutationFn = Apollo.MutationFunction<updateSurveyQuestion, updateSurveyQuestionVariables>;
export type updateSurveyQuestionMutationResult = Apollo.MutationResult<updateSurveyQuestion>;
export type updateSurveyQuestionMutationOptions = Apollo.BaseMutationOptions<updateSurveyQuestion, updateSurveyQuestionVariables>;
export type deleteSurveyQuestionMutationFn = Apollo.MutationFunction<deleteSurveyQuestion, deleteSurveyQuestionVariables>;
export type deleteSurveyQuestionMutationResult = Apollo.MutationResult<deleteSurveyQuestion>;
export type deleteSurveyQuestionMutationOptions = Apollo.BaseMutationOptions<deleteSurveyQuestion, deleteSurveyQuestionVariables>;
export type getSurveySchemasQueryResult = Apollo.QueryResult<getSurveySchemas, getSurveySchemasVariables>;
export type getSurveySchemaByIdQueryResult = Apollo.QueryResult<getSurveySchemaById, getSurveySchemaByIdVariables>;
export type createSurveySchemaMutationFn = Apollo.MutationFunction<createSurveySchema, createSurveySchemaVariables>;
export type createSurveySchemaMutationResult = Apollo.MutationResult<createSurveySchema>;
export type createSurveySchemaMutationOptions = Apollo.BaseMutationOptions<createSurveySchema, createSurveySchemaVariables>;
export type updateSurveySchemaMutationFn = Apollo.MutationFunction<updateSurveySchema, updateSurveySchemaVariables>;
export type updateSurveySchemaMutationResult = Apollo.MutationResult<updateSurveySchema>;
export type updateSurveySchemaMutationOptions = Apollo.BaseMutationOptions<updateSurveySchema, updateSurveySchemaVariables>;
export type updateSurveySchemaStatusMutationFn = Apollo.MutationFunction<updateSurveySchemaStatus, updateSurveySchemaStatusVariables>;
export type updateSurveySchemaStatusMutationResult = Apollo.MutationResult<updateSurveySchemaStatus>;
export type updateSurveySchemaStatusMutationOptions = Apollo.BaseMutationOptions<updateSurveySchemaStatus, updateSurveySchemaStatusVariables>;
export type deleteSurveySchemaMutationFn = Apollo.MutationFunction<deleteSurveySchema, deleteSurveySchemaVariables>;
export type deleteSurveySchemaMutationResult = Apollo.MutationResult<deleteSurveySchema>;
export type deleteSurveySchemaMutationOptions = Apollo.BaseMutationOptions<deleteSurveySchema, deleteSurveySchemaVariables>;
export type sendSurveyToUsersMutationFn = Apollo.MutationFunction<sendSurveyToUsers, sendSurveyToUsersVariables>;
export type sendSurveyToUsersMutationResult = Apollo.MutationResult<sendSurveyToUsers>;
export type sendSurveyToUsersMutationOptions = Apollo.BaseMutationOptions<sendSurveyToUsers, sendSurveyToUsersVariables>;
export type deleteSurveysFromTreatmentMutationFn = Apollo.MutationFunction<deleteSurveysFromTreatment, deleteSurveysFromTreatmentVariables>;
export type deleteSurveysFromTreatmentMutationResult = Apollo.MutationResult<deleteSurveysFromTreatment>;
export type deleteSurveysFromTreatmentMutationOptions = Apollo.BaseMutationOptions<deleteSurveysFromTreatment, deleteSurveysFromTreatmentVariables>;
export type shareSurveySchemaMutationFn = Apollo.MutationFunction<shareSurveySchema, shareSurveySchemaVariables>;
export type shareSurveySchemaMutationResult = Apollo.MutationResult<shareSurveySchema>;
export type shareSurveySchemaMutationOptions = Apollo.BaseMutationOptions<shareSurveySchema, shareSurveySchemaVariables>;
export type duplicateSurveySchemaMutationFn = Apollo.MutationFunction<duplicateSurveySchema, duplicateSurveySchemaVariables>;
export type duplicateSurveySchemaMutationResult = Apollo.MutationResult<duplicateSurveySchema>;
export type duplicateSurveySchemaMutationOptions = Apollo.BaseMutationOptions<duplicateSurveySchema, duplicateSurveySchemaVariables>;
export type GetIndividualSurveyResultsQueryResult = Apollo.QueryResult<GetIndividualSurveyResults, GetIndividualSurveyResultsVariables>;
export type aggregatedSurveyResultsQueryResult = Apollo.QueryResult<aggregatedSurveyResults, aggregatedSurveyResultsVariables>;
export type getSurveySchemaForResultsQueryResult = Apollo.QueryResult<getSurveySchemaForResults, getSurveySchemaForResultsVariables>;
export type unsubscribeFromSurveySchemaMutationFn = Apollo.MutationFunction<unsubscribeFromSurveySchema, unsubscribeFromSurveySchemaVariables>;
export type unsubscribeFromSurveySchemaMutationResult = Apollo.MutationResult<unsubscribeFromSurveySchema>;
export type unsubscribeFromSurveySchemaMutationOptions = Apollo.BaseMutationOptions<unsubscribeFromSurveySchema, unsubscribeFromSurveySchemaVariables>;
export type getSurveysForSchemaIdQueryResult = Apollo.QueryResult<getSurveysForSchemaId, getSurveysForSchemaIdVariables>;
export type resendSurveyMutationFn = Apollo.MutationFunction<resendSurvey, resendSurveyVariables>;
export type resendSurveyMutationResult = Apollo.MutationResult<resendSurvey>;
export type resendSurveyMutationOptions = Apollo.BaseMutationOptions<resendSurvey, resendSurveyVariables>;
export type getTreatmentSchemasQueryResult = Apollo.QueryResult<getTreatmentSchemas, getTreatmentSchemasVariables>;
export type getTreatmentSchemaQueryResult = Apollo.QueryResult<getTreatmentSchema, getTreatmentSchemaVariables>;
export type createNewTreatmentSchemaMutationFn = Apollo.MutationFunction<createNewTreatmentSchema, createNewTreatmentSchemaVariables>;
export type createNewTreatmentSchemaMutationResult = Apollo.MutationResult<createNewTreatmentSchema>;
export type createNewTreatmentSchemaMutationOptions = Apollo.BaseMutationOptions<createNewTreatmentSchema, createNewTreatmentSchemaVariables>;
export type addScheduleMutationFn = Apollo.MutationFunction<addSchedule, addScheduleVariables>;
export type addScheduleMutationResult = Apollo.MutationResult<addSchedule>;
export type addScheduleMutationOptions = Apollo.BaseMutationOptions<addSchedule, addScheduleVariables>;
export type createSchedulesMutationFn = Apollo.MutationFunction<createSchedules, createSchedulesVariables>;
export type createSchedulesMutationResult = Apollo.MutationResult<createSchedules>;
export type createSchedulesMutationOptions = Apollo.BaseMutationOptions<createSchedules, createSchedulesVariables>;
export type removeSchedulesMutationFn = Apollo.MutationFunction<removeSchedules, removeSchedulesVariables>;
export type removeSchedulesMutationResult = Apollo.MutationResult<removeSchedules>;
export type removeSchedulesMutationOptions = Apollo.BaseMutationOptions<removeSchedules, removeSchedulesVariables>;
export type removeScheduleMutationFn = Apollo.MutationFunction<removeSchedule, removeScheduleVariables>;
export type removeScheduleMutationResult = Apollo.MutationResult<removeSchedule>;
export type removeScheduleMutationOptions = Apollo.BaseMutationOptions<removeSchedule, removeScheduleVariables>;
export type addSchemaDependencyMutationFn = Apollo.MutationFunction<addSchemaDependency, addSchemaDependencyVariables>;
export type addSchemaDependencyMutationResult = Apollo.MutationResult<addSchemaDependency>;
export type addSchemaDependencyMutationOptions = Apollo.BaseMutationOptions<addSchemaDependency, addSchemaDependencyVariables>;
export type removeSchemaDependencyMutationFn = Apollo.MutationFunction<removeSchemaDependency, removeSchemaDependencyVariables>;
export type removeSchemaDependencyMutationResult = Apollo.MutationResult<removeSchemaDependency>;
export type removeSchemaDependencyMutationOptions = Apollo.BaseMutationOptions<removeSchemaDependency, removeSchemaDependencyVariables>;
export type updateSchemaDependencyMutationFn = Apollo.MutationFunction<updateSchemaDependency, updateSchemaDependencyVariables>;
export type updateSchemaDependencyMutationResult = Apollo.MutationResult<updateSchemaDependency>;
export type updateSchemaDependencyMutationOptions = Apollo.BaseMutationOptions<updateSchemaDependency, updateSchemaDependencyVariables>;
export type removeTreatmentSchemaMutationFn = Apollo.MutationFunction<removeTreatmentSchema, removeTreatmentSchemaVariables>;
export type removeTreatmentSchemaMutationResult = Apollo.MutationResult<removeTreatmentSchema>;
export type removeTreatmentSchemaMutationOptions = Apollo.BaseMutationOptions<removeTreatmentSchema, removeTreatmentSchemaVariables>;
export type updateTreatmentSchemaMutationFn = Apollo.MutationFunction<updateTreatmentSchema, updateTreatmentSchemaVariables>;
export type updateTreatmentSchemaMutationResult = Apollo.MutationResult<updateTreatmentSchema>;
export type updateTreatmentSchemaMutationOptions = Apollo.BaseMutationOptions<updateTreatmentSchema, updateTreatmentSchemaVariables>;
export type updateTreatmentSchemaStatusMutationFn = Apollo.MutationFunction<updateTreatmentSchemaStatus, updateTreatmentSchemaStatusVariables>;
export type updateTreatmentSchemaStatusMutationResult = Apollo.MutationResult<updateTreatmentSchemaStatus>;
export type updateTreatmentSchemaStatusMutationOptions = Apollo.BaseMutationOptions<updateTreatmentSchemaStatus, updateTreatmentSchemaStatusVariables>;
export type duplicateTreatmentSchemaMutationFn = Apollo.MutationFunction<duplicateTreatmentSchema, duplicateTreatmentSchemaVariables>;
export type duplicateTreatmentSchemaMutationResult = Apollo.MutationResult<duplicateTreatmentSchema>;
export type duplicateTreatmentSchemaMutationOptions = Apollo.BaseMutationOptions<duplicateTreatmentSchema, duplicateTreatmentSchemaVariables>;
export type shareTreatmentSchemaMutationFn = Apollo.MutationFunction<shareTreatmentSchema, shareTreatmentSchemaVariables>;
export type shareTreatmentSchemaMutationResult = Apollo.MutationResult<shareTreatmentSchema>;
export type shareTreatmentSchemaMutationOptions = Apollo.BaseMutationOptions<shareTreatmentSchema, shareTreatmentSchemaVariables>;
export type unSubscribeTreatmentSchemaMutationFn = Apollo.MutationFunction<unSubscribeTreatmentSchema, unSubscribeTreatmentSchemaVariables>;
export type unSubscribeTreatmentSchemaMutationResult = Apollo.MutationResult<unSubscribeTreatmentSchema>;
export type unSubscribeTreatmentSchemaMutationOptions = Apollo.BaseMutationOptions<unSubscribeTreatmentSchema, unSubscribeTreatmentSchemaVariables>;
export type setCustomDaysOfScheduleMutationFn = Apollo.MutationFunction<setCustomDaysOfSchedule, setCustomDaysOfScheduleVariables>;
export type setCustomDaysOfScheduleMutationResult = Apollo.MutationResult<setCustomDaysOfSchedule>;
export type setCustomDaysOfScheduleMutationOptions = Apollo.BaseMutationOptions<setCustomDaysOfSchedule, setCustomDaysOfScheduleVariables>;
export type addSurveySchemaToTreatmentSchemaMutationFn = Apollo.MutationFunction<addSurveySchemaToTreatmentSchema, addSurveySchemaToTreatmentSchemaVariables>;
export type addSurveySchemaToTreatmentSchemaMutationResult = Apollo.MutationResult<addSurveySchemaToTreatmentSchema>;
export type addSurveySchemaToTreatmentSchemaMutationOptions = Apollo.BaseMutationOptions<addSurveySchemaToTreatmentSchema, addSurveySchemaToTreatmentSchemaVariables>;
export type removeSurveySchemaFromTreatmentSchemaMutationFn = Apollo.MutationFunction<removeSurveySchemaFromTreatmentSchema, removeSurveySchemaFromTreatmentSchemaVariables>;
export type removeSurveySchemaFromTreatmentSchemaMutationResult = Apollo.MutationResult<removeSurveySchemaFromTreatmentSchema>;
export type removeSurveySchemaFromTreatmentSchemaMutationOptions = Apollo.BaseMutationOptions<removeSurveySchemaFromTreatmentSchema, removeSurveySchemaFromTreatmentSchemaVariables>;
export type setCustomDaysOfTreatmentSchemaSurveyMutationFn = Apollo.MutationFunction<setCustomDaysOfTreatmentSchemaSurvey, setCustomDaysOfTreatmentSchemaSurveyVariables>;
export type setCustomDaysOfTreatmentSchemaSurveyMutationResult = Apollo.MutationResult<setCustomDaysOfTreatmentSchemaSurvey>;
export type setCustomDaysOfTreatmentSchemaSurveyMutationOptions = Apollo.BaseMutationOptions<setCustomDaysOfTreatmentSchemaSurvey, setCustomDaysOfTreatmentSchemaSurveyVariables>;
export type getAppointmentCountByUserIdAndInFutureQueryResult = Apollo.QueryResult<getAppointmentCountByUserIdAndInFuture, getAppointmentCountByUserIdAndInFutureVariables>;
export type getSurveyCountByUserIdAndNotFinishedQueryResult = Apollo.QueryResult<getSurveyCountByUserIdAndNotFinished, getSurveyCountByUserIdAndNotFinishedVariables>;
export type isSurveyExpireSoonByIsOwnAndNotFinishedQueryResult = Apollo.QueryResult<isSurveyExpireSoonByIsOwnAndNotFinished, isSurveyExpireSoonByIsOwnAndNotFinishedVariables>;
export type getSurveysQueryResult = Apollo.QueryResult<getSurveys, getSurveysVariables>;
export type getSurveyByIdQueryResult = Apollo.QueryResult<getSurveyById, getSurveyByIdVariables>;
export type upsertSurveyQuestionAnswerMutationFn = Apollo.MutationFunction<upsertSurveyQuestionAnswer, upsertSurveyQuestionAnswerVariables>;
export type upsertSurveyQuestionAnswerMutationResult = Apollo.MutationResult<upsertSurveyQuestionAnswer>;
export type upsertSurveyQuestionAnswerMutationOptions = Apollo.BaseMutationOptions<upsertSurveyQuestionAnswer, upsertSurveyQuestionAnswerVariables>;
export type finishMutationFn = Apollo.MutationFunction<finish, finishVariables>;
export type finishMutationResult = Apollo.MutationResult<finish>;
export type finishMutationOptions = Apollo.BaseMutationOptions<finish, finishVariables>;
export type uploadFileMutationFn = Apollo.MutationFunction<uploadFile, uploadFileVariables>;
export type uploadFileMutationResult = Apollo.MutationResult<uploadFile>;
export type uploadFileMutationOptions = Apollo.BaseMutationOptions<uploadFile, uploadFileVariables>;